<!-- Remarks:
    !! T01係唔同backend，以下嘅function有啲未有（參考disabledInOldVersion）!!
    - 報讀新課程 或 購買套票 不可同時付款

    課程:
      - 報讀課程：自動grab之後啲堂，backend會自動將未來嘅lesson assign比student
      - 報讀單一課堂：可以揀N堂
        -> 付款 (`new_order`)，啲揀咗嘅堂會mark paid（create嘅個張order只係屬於user揀咗要比錢嘅lesson）
      - 下月應付項目(order_id = -2)：攞下個月order preview (extend_order_pre) -> 付款 (`extend_order`)
        -> 可以edit lesson discount
        -> 可以同product / 自訂項目 / 新報讀課程(if enableCombineNextAndNew) 同一張單
        -> 可以同 待付款項目 同一張單 (if enableCombineNextAndUnpaid)
        -> (optional) 可以remove唔要嘅lesson (會remove attendance if yes)
      - 待付款項目(order_id = -3)：今日之前所有未比錢lesson (unpaid_lesson_pre) -> 付款 (`unpaid_lesson_next`)
        -> 可以edit lesson discount
        -> 可以揀要交邊啲lesson，但冇得remove
        -> 可以同product / 自訂項目 / 下月應付項目 同一張單 (if enableCombineNextAndUnpaid)
        -> filter走skip from嘅lesson，留skip to嘅lesson
      - 待付款/待審核訂單：
        -> Case 待付款 (status = 'pending')
          -> 可以edit lesson discount
          -> 可以加減lesson
            (x) 只會重新render過order，減去嘅lesson對attendance冇影響
            (v) 減去嘅lesson會remove埋students & attendance (20260304更新)
          -> 可以加減product
            (v) 會影響inventory
          -> 可以加減package & package lesson
            (x) 原有package嘅lesson attendance唔會有影響
            (v) 減去嘅lesson會remove埋students & attendance (20260304更新)
          -> 可以加月票，不可以減月票
            (x) 原有月票嘅lesson attendance唔會有影響 (可加不可減，因為減去嘅lesson唔會remove monthly_used)
            (v) 可以加減月票嘅lesson，減去嘅lesson會remove埋students & attendance (20260304更新)
          -> 更新訂單 (`renew_order`) 
        -> Case 待審核 (status = 'processing')
          -> 只可以update payment method/status/upload payment image/remark
          -> 更新訂單 (`edit_order`)
      - 新增自訂項目(order_id = -4)
      - 跳堂紀錄（顯示於收據上）(order_id = -5)
        -> 揀要擺落下張單嘅skip to lesson（唔會有任可checking同價錢）

    套票: 
      - 買新套票 (可以唔洗揀lesson)
        -> 如果有unpaid lesson & 未指派課堂，要將啲 未指派課堂 assign曬先 -> 繼續（如果有unpaid lesson，個status一定要係paid）
        -> 如果有剩 未指派課堂，問要唔要assign埋一齊用
        -> 可以揀自動報堂（揀第一堂，自動grab之後啲堂），定自己揀堂。
        -> 自動報堂如果唔夠堂，問要唔要新增lesson
        -> 付款 (new_order)
      - 只會assign佢揀咗嘅堂，唔會assign之後嘅堂
      - 同時都會攞 status !== 'paid' 嘅order比user update返個payment method/status/upload payment image/remark -> 付款 (edit_order)
      - 新增自訂項目
    
    商品: 
      - 買新商品 -> 付款 (new_order)
      - 同時都會攞 status !== 'paid' 嘅order比user update返個payment method/status/upload payment image/remark -> 付款 (edit_order)
      - 換領積分（if any）

    月票:
      - 買新月票 -> 付款 (new_order)
        -> 按日數：最少要揀一堂做第一堂
        -> 按月份：揀由邊月開始
        -> 可以揀自動報堂（揀第一堂，自動grab月票範圍內嘅堂），定自己揀堂。
        -> 如果買多過一個月票，揀嘅第一堂嘅日期要接續上一個月票end date
        -> 同一時段月票唔可以重覆購買
        -> 每張訂單只可買一種月票類型
      - 只會assign佢揀咗嘅堂，唔會assign之後嘅堂
      - 報讀月票 -> 確認 (assign_monthly_lesson)
        -> 要月票order status係"paid"先可以用


    * order_id = -5 -> 跳堂紀錄（顯示於收據上）
    * order_id = -4 -> 新增自訂項目 -> new order/ extend_order
    * order_id = -3 -> previous unpaid order (待付款項目) -> unpaid_lesson_next
    * order_id = -2 -> next month order (本月/下月應付項目) -> extend_order
    * order_id = -1 -> new add lesson -> new order
    * order_id > -1 -> exist order (待付款/待審核訂單) -> update order/ renew order
 -->

<template>
  <v-container fluid>
    <PageHeaderSlot showBackButton>
      <template slot="bottom-right-slot">
        <FormButton
          v-if="$validate.DataValid(orderId)"
          outlined
          color="error"
          text="cancelUpdate"
          @click="handleCancelUpdateOrder()"
        >
          <template slot="prepend"> <v-icon class="fi-rr-cross mr-2" size="10"></v-icon></template>
        </FormButton>
      </template>
    </PageHeaderSlot>
    <v-row class="ma-0">
      <v-col class="pl-0 pr-0 pr-md-8" cols="12" md="9">
        <div v-if="studentData.remark" class="remark-block py-4 px-8 mb-4">
          {{ $t('studentRemark') }}{{ studentData.remark }}
        </div>

        <!-- 兄弟姊妹 (T21) -->
        <Datatable
          v-if="
            gEnableSibling && isAppMode(['T21']) && studentData.siblings.length > 0 && !$validate.DataValid(orderId)
          "
          class="mb-6"
          tableName="siblings"
          :tableData="studentData.siblings"
          :tableHeaders="siblingTableHeaders"
          disablePagination
        >
          <template v-slot:[`item.relationship`]="{ item }">
            <span v-if="item.relationship">{{ $t('siblingOptions.' + item.relationship) }}</span>
          </template>
          <template v-slot:[`item.actionNav`]="{ item }">
            <FormButton text="menu.payTuition" block @click="navSiblingPayment(item.student_id)" />
          </template>
        </Datatable>

        <!-- 待付款/待審核訂單 -->
        <v-row class="ma-0 mb-16" v-if="unpaidTableData.length > 0 && !$validate.DataValid(orderId)">
          <v-col cols="12" class="pa-0">
            <Datatable
              :isLoading="tableLoading"
              tableName="tableGroup.order"
              :tableHeaders="unpaidTableHeaders"
              :tableData="unpaidTableData"
              disablePagination
            >
              <template v-slot:[`item.status`]="{ item }">
                <TableDropdown>
                  <template slot="prepend">
                    <v-chip
                      :class="{
                        'chip-success': item.status === 'paid',
                        'chip-active': item.status === 'processing',
                        'chip-inactive': item.status !== 'paid' && item.status !== 'processing',
                      }"
                    >
                      {{ item.status | formatOrderStatus }}
                    </v-chip>
                  </template>
                  <template slot="list">
                    <!-- 修改訂單 -->
                    <v-list-item
                      v-if="canEditOrder"
                      @click.prevent="openEditOrder(item.id)"
                      :disabled="$store.getters.isLoading"
                    >
                      <v-list-item-title>{{ $t('updateOrder') }}</v-list-item-title>
                    </v-list-item>
                    <!-- 作廢發票 -->
                    <v-list-item
                      v-if="canAdvancedEditOrder && !item.is_redeem"
                      @click.prevent="handleVoidOrder(item.id)"
                      :disabled="$store.getters.isLoading"
                    >
                      <v-list-item-title>{{ $t('voidOrder') }}</v-list-item-title>
                    </v-list-item>
                  </template>
                </TableDropdown>
              </template>
            </Datatable>
          </v-col>
        </v-row>

        <v-tabs
          class="mb-4"
          :class="{ 'pointer-none': $store.getters.isLoading }"
          v-model="paymentTypeTab"
          color="colorBlack"
          :height="40"
          active-class="tab-active"
          hide-slider
          @change="onTabChange()"
        >
          <v-tab v-for="key in displayTabs" :disabled="disableTab(key)" :href="`#tab_${key}`" :key="`tab_${key}`">
            <template v-if="key === 'course'">{{ $t('applyNewCourse') }}</template>
            <template v-else-if="key === 'package'">{{ $t('purchasePackage') }}</template>
            <template v-else-if="key === 'month_pass'">{{ $t('purchaseMonthPass') }}</template>
            <template v-else-if="key === 'assign_month_pass'">{{ $t('assignMonthPass') }}</template>
            <template v-else-if="key === 'online_course'">{{ $t('onlineCourse') }}</template>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="paymentItemTab" class="mt-8">
          <!-- Course -->
          <v-tab-item transition="fade-transition" value="tab_course">
            <FormButton
              v-if="!disabledAddCourse"
              class="mb-5"
              text="applyNewCourse"
              @click="openAddSearchDialog('course')"
            />

            <Datatable
              :isLoading="tableLoading"
              tableName="course"
              :tableHeaders="courseTableHeaders"
              :tableData="courseTableData"
              disablePagination
              :enableSelectToggle="!disabledEditItem && $validate.DataValid(courseTableData)"
              :selectedTableRow.sync="courseSelectedRow"
              tableEmptyText="noCourse"
              @selected-row-changed="onCourseSelectedRowChanged()"
              :groupBy="getGroupBy('course')"
              :hideEmptyResult="enableCustomItem"
              disabledSelectAll
            >
              <template slot="append-widget">
                <div v-if="enableCustomItem" class="custom-item-container pa-4" v-show="!tableLoading">
                  <v-btn
                    type="button"
                    block
                    elevation="0"
                    class="py-8"
                    @click.prevent="handleAddCustomItem()"
                    :disabled="disabledInOldVersion"
                  >
                    {{ $t('addCustomItems') }}
                  </v-btn>
                </div>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <ItemAction
                  :rowId="item.id"
                  :orderId="
                    $validate.DataValid(orderId) ? (item.order_id === -1 ? orderId : item.order_id) : item.order_id
                  "
                  :orderStatus="orderData.status"
                  :disabledDelete="item.disabledDelete || disabledEditItem"
                  @edit-clicked="handleEditItem($event, 'course')"
                  @delete-clicked="handleDeleteAction($event, 'course')"
                />
              </template>
            </Datatable>
          </v-tab-item>

          <!-- Package -->
          <v-tab-item transition="fade-transition" value="tab_package">
            <FormButton
              v-if="!disabledAddPackage"
              class="mb-5"
              text="choosePackage"
              @click="openAddSearchDialog('package')"
            />

            <Datatable
              :isLoading="tableLoading"
              tableName="package"
              :tableHeaders="packageTableHeaders"
              :tableData="packageTableData"
              disablePagination
              :enableSelectToggle="!disabledEditItem && $validate.DataValid(packageTableData)"
              :selectedTableRow.sync="packageSelectedRow"
              tableEmptyText="noPackage"
              @selected-row-changed="onPackageSelectedRowChanged()"
              :groupBy="getGroupBy('package')"
              :hideEmptyResult="enableCustomItem"
              disabledSelectAll
            >
              <template slot="append-widget">
                <div v-if="enableCustomItem" class="custom-item-container pa-4" v-show="!tableLoading">
                  <v-btn
                    type="button"
                    block
                    elevation="0"
                    class="py-8"
                    @click.prevent="handleAddCustomItem()"
                    :disabled="disabledInOldVersion"
                  >
                    {{ $t('addCustomItems') }}
                  </v-btn>
                </div>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <ItemAction
                  :rowId="item.id"
                  :orderId="$validate.DataValid(orderId) ? orderId : item.order_id"
                  :orderStatus="orderData.status"
                  :disabledDelete="item.disabledDelete || disabledEditItem"
                  @edit-clicked="handleEditItem($event, 'package')"
                  @delete-clicked="handleDeleteAction($event, 'package')"
                />
              </template>
            </Datatable>
          </v-tab-item>

          <!-- 月票 -->
          <v-tab-item transition="fade-transition" v-if="gEnableMonthPass" value="tab_month_pass">
            <FormButton
              v-if="!disabledAddMonthPass"
              class="mb-5"
              text="chooseMonthPass"
              @click="openAddSearchDialog('month_pass')"
            />

            <Datatable
              :isLoading="tableLoading"
              tableName="monthPass"
              :tableHeaders="monthPassTableHeaders"
              :tableData="monthPassTableData"
              disablePagination
              :enableSelectToggle="!disabledEditItem && $validate.DataValid(monthPassTableData)"
              :selectedTableRow.sync="monthPassSelectedRow"
              tableEmptyText="noMonthPass"
              @selected-row-changed="onMonthPassSelectedRowChanged()"
              :groupBy="getGroupBy('month_pass')"
              :hideEmptyResult="enableCustomItem"
              disabledSelectAll
            >
              <template slot="append-widget">
                <div v-if="enableCustomItem" class="custom-item-container pa-4" v-show="!tableLoading">
                  <v-btn
                    type="button"
                    block
                    elevation="0"
                    class="py-8"
                    @click.prevent="handleAddCustomItem()"
                    :disabled="disabledInOldVersion"
                  >
                    {{ $t('addCustomItems') }}
                  </v-btn>
                </div>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <ItemAction
                  :rowId="item.id"
                  :orderId="$validate.DataValid(orderId) ? orderId : item.order_id"
                  :orderStatus="orderData.status"
                  :disabledDelete="item.disabledDelete || disabledEditItem"
                  @edit-clicked="handleEditItem($event, 'month_pass')"
                  @delete-clicked="handleDeleteAction($event, 'month_pass')"
                />
              </template>
            </Datatable>
          </v-tab-item>

          <!-- 報讀月票 -->
          <v-tab-item
            transition="fade-transition"
            v-if="gEnableMonthPass && otherMonthPassLessonDates.length > 0"
            value="tab_assign_month_pass"
          >
            <Datatable
              class="mb-8"
              :isLoading="tableLoading"
              tableName="course"
              :tableHeaders="assignLessonTableHeaders"
              :tableData="assignLessonTableData"
              :selectedTableRow.sync="assignLessonSelectedRow"
              disablePagination
              tableEmptyText="noCourse"
              :enableSelectToggle="$validate.DataValid(assignLessonTableData)"
            >
              <template slot="append-toolbar-left">
                <FormButton
                  text="applyCourse"
                  isAdd
                  class="ml-4 my-2"
                  @click="openAssignMonthPass()"
                  :class="{ 'pointer-none': $store.getters.isLoading }"
                />
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <ItemAction
                  :rowId="item.id"
                  :orderId="$validate.DataValid(orderId) ? orderId : item.order_id"
                  :orderStatus="orderData.status"
                  @edit-clicked="handleEditItem($event, 'assign_month_pass')"
                  @delete-clicked="handleDeleteAction($event, 'assign_month_pass')"
                />
              </template>
            </Datatable>

            <Datatable
              :isLoading="tableLoading"
              tableName="monthPass"
              :tableHeaders="existMonthPassTableHeaders"
              :tableData="existMonthPass.tableData"
              :page.sync="existMonthPass.page"
              :pageLimit.sync="existMonthPass.limit"
              :itemTotal="existMonthPass.total"
              tableEmptyText="noMonthPass"
              @options-update="_getExistMonthPassTableData()"
              :pageLimitOptions="[5, 10, 20, 50]"
            >
              <template v-slot:[`item.range`]="{ item }">
                <span v-for="date in item.dates" class="d-block">
                  {{ formatMonthPassDate(date.start_date) }} - {{ formatMonthPassDate(date.end_date) }}
                </span>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-btn
                  depressed
                  text
                  color="primary"
                  :ripple="false"
                  class="pa-0"
                  :class="{ 'pointer-none': $store.getters.isLoading }"
                  style="min-width: unset !important;"
                  @click.prevent="openAssignMonthPass(item.id)"
                >
                  {{ $t('applyCourse') }}
                </v-btn>
              </template>
            </Datatable>
          </v-tab-item>

          <!-- 線上課程 -->
          <v-tab-item
            transition="fade-transition"
            v-if="$validate.DataValid(orderId) && orderData.order_type.includes('online_course')"
            value="tab_online_course"
          >
            <Datatable
              :isLoading="tableLoading"
              tableName="menu.onlineCourse"
              :tableHeaders="onlineCourseTableHeaders"
              :tableData="onlineCourseTableData"
              disablePagination
              :selectedTableRow.sync="onlineCourseSelectedRow"
              tableEmptyText="noCourse"
              :groupBy="getGroupBy('month_pass')"
            />
          </v-tab-item>
        </v-tabs-items>

        <!-- Product -->
        <div class="ma-0 mt-16" v-show="currentTabType !== 'assign_month_pass'">
          <v-tabs
            class="mb-8"
            :class="{ 'pointer-none': $store.getters.isLoading }"
            color="colorBlack"
            :height="40"
            active-class="tab-active"
            hide-slider
          >
            <v-tab :disabled="$store.getters.isLoading">{{ $t('purchaseProduct') }}</v-tab>
          </v-tabs>

          <FormButton
            v-if="!disabledInOldVersion"
            class="mb-5"
            text="addProduct"
            @click="openAddSearchDialog('product')"
          />

          <Datatable
            :isLoading="tableLoading"
            tableName="product"
            :tableHeaders="productTableHeaders"
            :tableData="productTableData"
            disablePagination
            :enableSelectToggle="!disabledEditItem && $validate.DataValid(productTableData)"
            :selectedTableRow.sync="productSelectedRow"
            tableEmptyText="noProduct"
            @selected-row-changed="onProductSelectedRowChanged()"
            :groupBy="getGroupBy('product')"
            disabledSelectAll
          >
            <template v-slot:[`item.total_text`]="{ item }">
              <span v-if="$validate.DataValid(item.total)">
                HK${{ $formatter.separator(item.total)
                }}{{ enablePoints ? ` (${$t('points', { points: item.points * item.qty })})` : '' }}
              </span>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <ItemAction
                :rowId="item.id"
                :orderId="$validate.DataValid(orderId) ? orderId : item.order_id"
                :orderStatus="orderData.status"
                :disabledDelete="item.disabledDelete || disabledEditItem"
                @edit-clicked="handleEditItem($event, 'product')"
                @delete-clicked="handleDeleteAction($event, 'product')"
              />
            </template>
          </Datatable>
        </div>
      </v-col>

      <!-- 訂單詳情 -->
      <v-col class="px-0 my-4" cols="12" md="3">
        <v-card>
          <v-overlay absolute :value="currentTabType === 'assign_month_pass'">
            <span class="colorWhite--text text-subtitle-1">{{ $t('na') }}</span>
          </v-overlay>
          <v-card-title class="subtitle-2 order-card-title">{{ $t('orderDetails') }}</v-card-title>
          <v-card-text class="px-0 py-4">
            <OrderDetailRow
              label="subtotal"
              :value="
                formData.is_redeem
                  ? $t('points', { points: $formatter.separator(pointSubtotals) })
                  : `$${$formatter.separator($formatter.formatMoney(subtotal))}`
              "
            />
            <OrderDetailRow :label="itemQtyLabel" :value="itemQty" />
            <OrderDetailRow v-if="enableCustomItem && customItemQty > 0" label="customItemQty" :value="customItemQty" />
            <OrderDetailRow v-if="skipLessonQty > 0" label="skipItemQty" :value="skipLessonQty" />
            <OrderDetailRow v-if="productQty > 0" label="productQty" :value="productQty" />
            <OrderDetailRow
              v-if="$validate.DataValid(orderId) && orderData.status === 'debit' && orderData.debit_amount > 0"
              label="refunded"
              :value="`-$${$formatter.separator($formatter.formatMoney(orderData.debit_amount))}`"
            />
            <v-divider class="my-4"></v-divider>
            <v-form ref="dataForm" @submit.prevent="">
              <OrderDetailRow
                v-if="formData.is_redeem"
                label="payPoints"
                :value="$formatter.separator(pointTotalAmount)"
                valueLarge
              />
              <template v-else>
                <!-- TODO: #241 remove after apply -->
                <OrderDetailRow v-if="isAppMode(['DEV', 'UAT']) && !isAppMode(['T01'])" label="payTotal">
                  <div class="total-input">
                    <FormInput
                      type="number"
                      :fieldValue.sync="formData.subtotal"
                      :placeholder="`${totalAmount}`"
                      prefix="$"
                      required
                      hideDetails
                      :disabled="disabledInOldVersion"
                      isStrictFloat
                    />
                  </div>
                </OrderDetailRow>
                <OrderDetailRow v-else label="payTotal" :value="`$${$formatter.separator(totalAmount)}`" valueLarge />
              </template>

              <v-row class="ma-0 pb-3 px-4">
                <v-col class="pa-0 ma-0" cols="12" v-if="enablePoints">
                  <v-checkbox
                    v-model="formData.is_redeem"
                    class="mt-0"
                    @change="onUsePointChange()"
                    :disabled="$validate.DataValid(orderId)"
                  >
                    <template v-slot:label>
                      <div class="text-body-2 colorBlack--text">{{ $t('usePoints') }}</div>
                    </template>
                  </v-checkbox>
                </v-col>
                <template v-if="!formData.is_redeem">
                  <template v-if="gEnableCoupon">
                    <v-col class="pa-0 ma-0" cols="12">
                      <FormSelect
                        label="discountMethod"
                        placeholder="selectDiscountMethod"
                        :fieldValue.sync="formData.discount_method"
                        :options="discountMethodOptions"
                        @changed="onDiscountMethodChanged()"
                        required
                        :disabled="disabledInOldVersion"
                      />
                    </v-col>
                    <v-col class="pa-0 ma-0" cols="12" v-if="formData.discount_method === 'code'">
                      <FormSearchSelect
                        label="couponCode"
                        placeholder="couponCode"
                        searchPlaceholder="searchCouponCode"
                        :fieldValue.sync="formData.discount_coupon_code"
                        :options="couponOptions"
                        :searching="couponSearching"
                        :disabled="disabledInOldVersion"
                        enableClear
                        @changed="onCouponChanged()"
                        @click-search="searchCoupons($event)"
                      />
                    </v-col>
                  </template>

                  <v-col class="pa-0 ma-0" cols="12">
                    <FormSelect
                      label="discountType"
                      placeholder="selectDiscountType"
                      :fieldValue.sync="formData.discount_type"
                      :options="discountTypeOptions"
                      @changed="formData.discount_value = ''"
                      enableClear
                      :disabled="disabledInOldVersion || formData.discount_method === 'code'"
                    />
                  </v-col>
                  <v-col class="pa-0 ma-0" cols="12" v-if="$validate.DataValid(formData.discount_type)">
                    <FormDiscount
                      :discountValue.sync="formData.discount_value"
                      :discountType="formData.discount_type"
                      :price="subtotal"
                      :disabled="disabledInOldVersion || formData.discount_method === 'code'"
                      required
                    />
                  </v-col>
                  <v-col class="pa-0 ma-0" cols="12">
                    <FormSelect
                      label="payStatus"
                      :fieldValue.sync="formData.status"
                      :options="statusOptions"
                      required
                    />
                  </v-col>

                  <template
                    v-if="
                      !isAppMode(['T01']) &&
                        $validate.DataValid(orderId) &&
                        formData.status === 'paid' &&
                        orderData.status === 'paid'
                    "
                  >
                    <v-col class="pa-0 ma-0 pr-1 mb-4" cols="8">
                      <FormDatePicker
                        label="paidDate"
                        disableClear
                        :dateValue.sync="formData.pay_date"
                        required
                        hideDetails
                        disabledActionButtons
                      />
                    </v-col>
                    <v-col class="pa-0 ma-0 mb-4" cols="4">
                      <FormTimePicker
                        :fieldValue.sync="formData.pay_time"
                        :options="createTimeOptions"
                        required
                        style="margin-top: 26px"
                        hideDetails
                      />
                    </v-col>
                  </template>
                  <template v-if="formData.status !== 'pending'">
                    <v-col class="pa-0 ma-0" cols="12">
                      <FormSelect
                        label="paymentSupport"
                        :fieldValue.sync="formData.payment_method"
                        :options="$paymentMethodOptions"
                        required
                      />
                    </v-col>
                    <v-col
                      v-if="isAppMode(['T21']) && formData.payment_method === 'cash'"
                      class="pa-0 ma-0 mb-4"
                      cols="12"
                    >
                      <div class="d-flex align-center" v-if="formData.sign">
                        <FormButton text="viewEleSign" class="flex-grow-1" @click="viewSign(formData.sign)" />
                        <v-btn
                          min-width="20"
                          max-width="20"
                          min-height="20"
                          class="ml-2 primary"
                          @click.prevent="openSignPad()"
                        >
                          <v-icon class="fi fi-rr-pen-clip" size="18"></v-icon>
                        </v-btn>
                      </div>
                      <FormButton v-else text="sign" block @click="openSignPad()">
                        <template slot="prepend"><v-icon class="fi fi-rr-pen-clip mr-1" size="15"></v-icon></template>
                      </FormButton>
                    </v-col>
                    <v-col class="pa-0 mb-4" cols="12">
                      <FormUploader
                        uploadText="uploadPaymentRecord"
                        fileInputKey="upload_payment"
                        :files.sync="formData.payment_images"
                        dispatchUpdateOnChange
                        :single="gDisableMultiplePaymentImg"
                      />
                    </v-col>
                  </template>
                </template>
                <v-col class="pa-0 ma-0" cols="12">
                  <FormInput label="orderRemark" placeholder="addOrderRemark" :fieldValue.sync="formData.remark" />
                </v-col>
                <template v-if="!isAppMode(['T01'])">
                  <v-col class="pa-0 ma-0" cols="12">
                    <FormInput label="receiptRemark" placeholder="addRemark" :fieldValue.sync="formData.pdf_remark" />
                  </v-col>
                  <template v-if="$validate.DataValid(orderId)">
                    <v-col class="pa-0 ma-0 pr-1" cols="8">
                      <FormDatePicker
                        label="createdDate"
                        disableClear
                        :dateValue.sync="formData.order_create_date"
                        required
                        hideDetails
                        disabledActionButtons
                      />
                    </v-col>
                    <v-col class="pa-0 ma-0" cols="4">
                      <FormTimePicker
                        :fieldValue.sync="formData.order_create_time"
                        :options="createTimeOptions"
                        required
                        style="margin-top: 26px"
                        hideDetails
                      />
                    </v-col>
                  </template>
                </template>
                <v-col
                  class="pa-0 ma-0 mt-6"
                  cols="12"
                  v-if="isAppMode(['DEV', 'T21']) && $validate.DataValid(orderId)"
                >
                  <FormInput
                    label="customOrderCode"
                    :placeholder="orderData.order_code"
                    :fieldValue.sync="formData.custom_invoice_number"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
        <FormButton
          v-if="currentTabType === 'assign_month_pass'"
          class="my-3 colorBlack--text"
          color="accent"
          text="confirm"
          height="48px"
          @click="handleAssignLessonSubmit()"
          block
        />
        <FormButton
          v-else
          class="my-3 colorBlack--text"
          color="accent"
          :text="$validate.DataValid(orderId) ? `${$t('updateOrder')} ${orderData.order_code}` : 'pay'"
          height="48px"
          @click="handlePaymentSubmit()"
          block
        />

        <v-card>
          <v-card-text class="pa-4">
            <v-row class="ma-0 pb-6 details-row">
              <div>
                <div class="mb-2">{{ $t('studentName') }}</div>
                <div class="font-weight-regular">{{ studentData.student_name }}</div>
              </div>
              <v-avatar size="40" v-if="studentAvatar !== ''">
                <img :src="studentAvatar" :alt="studentData.student_name" />
              </v-avatar>
            </v-row>

            <v-row class="ma-0 pb-6 details-row">
              <div>
                <div class="mb-2">{{ $t('studentPhone') }}</div>
                <div class="font-weight-regular">{{ studentData.phone }}</div>
              </div>
              <WhatsappButton :phone="studentData.phone" width="80" />
            </v-row>

            <v-row class="ma-0 pb-6 details-row" v-if="enablePoints">
              <div>
                <div class="mb-2">{{ $t('pointsCanUse') }}</div>
                <div class="font-weight-regular">{{ $formatter.separator(pointsCanUse) }}</div>
              </div>
            </v-row>
          </v-card-text>
          <v-card-actions v-if="canViewStudent || canViewOrder">
            <v-row class="my-0">
              <v-col cols="6" md="12" lg="6" class="py-0 px-1" v-if="canViewStudent">
                <FormButton
                  text="viewStudentInfo"
                  block
                  :class="{ unflex: $i18n.locale === 'en' }"
                  class="my-1"
                  :to="{ name: 'StudentDetails', params: { id: studentData.student_id } }"
                />
              </v-col>
              <v-col cols="6" md="12" lg="6" class="py-0 px-1" v-if="canViewOrder">
                <FormButton text="recentInvoice" block :to="{ name: 'OrderList', params: { sid: id } }" class="my-1" />
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
        <!-- 兄弟姊妹 -->
        <v-card
          v-if="gEnableSibling && !isAppMode(['T21'])"
          class="mt-4"
          v-for="item in studentData.siblings"
          :key="`sibling-${item.student_id}`"
        >
          <v-card-text class="pa-4">
            <v-row class="ma-0">
              <v-col cols="4" md="12" lg="4" class="d-block details-row">
                <div class="mb-2">{{ $t('studentName') }}</div>
                <div class="font-weight-regular">{{ item.name }}</div>
              </v-col>
              <v-col cols="4" md="12" lg="4" class="d-block details-row">
                <div class="mb-2">{{ $t('relationship') }}</div>
                <div class="font-weight-regular">
                  {{ item.relationship ? $t(`siblingOptions.${item.relationship}`) : '' }}
                </div>
              </v-col>
              <v-col cols="4" md="12" lg="4" class="d-block details-row">
                <div class="mb-2">{{ $t('studentPhone') }}</div>
                <div class="font-weight-regular">{{ item.phone }}</div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row class="my-0">
              <v-col cols="6" md="12" lg="6" class="py-0 px-1">
                <FormButton text="menu.payTuition" block @click="navSiblingPayment(item.student_id)" />
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <SignPad ref="signaturePadDialog" @confirm="onSignSubmit($event)" />

    <!-- Modal: 報讀新課程 -->
    <AssignLessonDialog
      ref="addCourseDialog"
      :loading="isSearching"
      :enableConfirm="
        (currentTabType === 'course' && addCourseFilter.type === 'singleDate') ||
          currentTabType === 'package' ||
          currentTabType === 'month_pass' ||
          currentTabType === 'assign_month_pass'
      "
      :enableCancel="
        currentTabType === 'package' ||
          (currentTabType === 'month_pass' && tempSelectedMonthPass && tempSelectedMonthPass.type === 'months')
      "
      cancelBtnText="skipApply"
      :enableLessonType="
        currentTabType !== 'package' && currentTabType !== 'month_pass' && currentTabType !== 'assign_month_pass'
      "
      :showTable="
        currentTabType !== 'month_pass' ||
          !tempSelectedMonthPass ||
          tempSelectedMonthPass.type !== 'months' ||
          $validate.DataValid(addCourseFilter.selectedMonth)
      "
      :courseNameOptions="courseNameOptions"
      :courseNameSearching="courseNameSearching"
      :tutorOptions="tutorOptions"
      :disableGrade="disableCourseGrade"
      :filterLessonType.sync="addCourseFilter.type"
      :filterCourseName.sync="addCourseFilter.keyword"
      :filterDates.sync="addCourseFilter.dateRange"
      :filterWeekdays.sync="addCourseFilter.weekdays"
      :filterTutor.sync="addCourseFilter.tutor"
      :filterGrade.sync="addCourseFilter.grade"
      :filterPage.sync="searchFilter.page"
      :filterLimit.sync="searchFilter.limit"
      :filterCenter="getSearchCenterId()"
      :tableData="searchTableData"
      :tableHeaders="addCourseTableHeaders"
      :tableTotal="searchTableTotal"
      :tempSelectedLesson="tempSelectedLesson"
      @filter-update="onCourseFilterChange($event)"
      @options-update="onSearchTableOptionsChange()"
      @close="handleAddCourseActionClick($event)"
    >
      <template slot="extra">
        <v-row
          v-if="
            currentTabType === 'package' || currentTabType === 'month_pass' || currentTabType === 'assign_month_pass'
          "
          class="ma-0 px-4"
        >
          <v-col cols="12"><v-divider></v-divider></v-col>

          <template v-if="currentTabType === 'package'">
            <v-col cols="4">
              <label class="input-label">{{ $t('unassignLesson') }}</label>
              <div>{{ availablePackageLessonCount }}</div>
            </v-col>
            <v-col cols="4">
              <label class="input-label">{{ $t('toBeAttended') }}</label>
              <div>{{ pendingPackageLessonCount }}</div>
            </v-col>
            <v-col cols="4">
              <label class="input-label">{{ $t('newPackageCount') }}</label>
              <div>{{ tempSelectedPackage ? tempSelectedPackage.lesson_count : 0 }}</div>
            </v-col>
          </template>

          <v-col
            v-if="currentTabType === 'month_pass' && tempSelectedMonthPass && tempSelectedMonthPass.type === 'months'"
            cols="12"
            sm="6"
          >
            <v-form ref="monthPassForm" @submit.prevent="">
              <FormDatePicker
                label="monthPassActivateMonth"
                :dateValue.sync="addCourseFilter.selectedMonth"
                isYearMonthOnly
                @changed="onMonthPassMonthChanged()"
                disabledActionButtons
                required
                disableClear
                :disabled="$validate.DataValid(orderId) && orderData.month_pass_selected_months.length > 0"
              />
            </v-form>
          </v-col>

          <v-col
            cols="12"
            v-if="
              !isAppMode(['T01']) &&
                (currentTabType !== 'month_pass' ||
                  !tempSelectedMonthPass ||
                  tempSelectedMonthPass.type !== 'months' ||
                  $validate.DataValid(addCourseFilter.selectedMonth))
            "
            :class="{
              'mt-6':
                currentTabType !== 'month_pass' || !tempSelectedMonthPass || tempSelectedMonthPass.type !== 'months',
            }"
          >
            <label class="input-label">{{ $t('applyRuleType') }}</label>

            <v-radio-group
              name="applyRuleType"
              v-model="addCourseFilter.packageLessonRule"
              row
              hide-details
              class="ma-0"
              @change="onPackageRuleChanged()"
              :readonly="isSearching"
            >
              <v-radio :label="$t('autoGrabLesson')" value="auto"></v-radio>
              <v-radio :label="$t('customLesson')" value="manually"></v-radio>
            </v-radio-group>
          </v-col>

          <v-col cols="12" v-if="currentTabType === 'package'">
            <small class="d-block text-caption mt-2">{{ $t('packageDes') }}</small>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`actionSelectCourse`]="{ item }">
        <div class="colorGrey--text pointer-none" v-if="item.applied">{{ $t('lessonStatus.applied') }}</div>
        <v-btn
          v-else-if="isItemSelected(item.id)"
          :loading="$store.getters.isLoading"
          depressed
          text
          color="red"
          :ripple="false"
          class="pa-0"
          :class="{ 'pointer-none': $store.getters.isLoading }"
          style="min-width: unset !important;"
          @click="handleSelectedRowCancel(item.id)"
          :disabled="item.disabled"
        >
          {{ $t('cancel') }}
        </v-btn>
        <div class="colorGrey--text pointer-none" v-else-if="item.selected">
          {{ $t('lessonStatus.selected') }}
        </div>
        <div class="colorGrey--text pointer-none" v-else-if="item.unavailable">
          {{ $t('lessonStatus.unavailable') }}
        </div>
        <v-btn
          v-else
          :loading="$store.getters.isLoading"
          depressed
          text
          color="primary"
          :ripple="false"
          class="pa-0"
          :class="{ 'pointer-none': $store.getters.isLoading }"
          style="min-width: unset !important;"
          @click="handleAddNewCourse(item.id)"
          :disabled="item.disabled || item.temp_disabled"
        >
          {{ $t('apply') }}
        </v-btn>
      </template>
    </AssignLessonDialog>

    <!-- Modal: 新增產品 -->
    <DialogLayout ref="addProductDialog" title="addProduct" hideAction cardContentClass="pa-0">
      <div class="pa-4">
        <v-row class="ma-0 my-4">
          <v-col cols="12" sm="6">
            <Searchbar
              label="searchProduct"
              :searchText.sync="searchFilter.keyword"
              searchPlaceholder="searchProductName"
              @search-clicked="onProductFilterChange()"
              :isSearching="isSearching"
              enableClear
            />
          </v-col>
        </v-row>
      </div>

      <Datatable
        :isLoading="isSearching"
        :tableData="searchTableData"
        :tableHeaders="addProductTableHeaders"
        :itemTotal="searchTableTotal"
        :page.sync="searchFilter.page"
        :pageLimit.sync="searchFilter.limit"
        :pageLimitOptions="searchFilter.limitOptions"
        @options-update="onSearchTableOptionsChange()"
        tableEmptyText="noProduct"
      >
        <template v-slot:[`item.actionSelectProduct`]="{ item }">
          <v-btn
            :loading="$store.getters.isLoading"
            :disabled="$validate.DataValid(item.inventory) && item.inventory < 1"
            depressed
            text
            color="primary"
            :ripple="false"
            class="pa-0"
            :class="{ 'pointer-none': $store.getters.isLoading }"
            style="min-width: unset !important;"
            @click="handleAddNewProduct(item.id)"
          >
            {{ $t('select') }}
          </v-btn>
        </template>
      </Datatable>
    </DialogLayout>

    <!-- Modal: 選擇套票 -->
    <DialogLayout ref="addPackageDialog" title="choosePackage" hideAction cardContentClass="pa-0">
      <div class="pa-4">
        <v-row class="ma-0 my-4">
          <v-col cols="12" sm="6">
            <Searchbar
              label="searchPackage"
              :searchText.sync="searchFilter.keyword"
              searchPlaceholder="searchPackageName"
              @search-clicked="onPackageFilterChange()"
              :isSearching="isSearching"
              enableClear
            />
          </v-col>
        </v-row>
      </div>

      <Datatable
        :isLoading="isSearching"
        :tableData="searchTableData"
        :tableHeaders="addPackageTableHeaders"
        :itemTotal="searchTableTotal"
        :page.sync="searchFilter.page"
        :pageLimit.sync="searchFilter.limit"
        :pageLimitOptions="searchFilter.limitOptions"
        @options-update="onSearchTableOptionsChange()"
        tableEmptyText="noPackage"
      >
        <template v-slot:[`item.actionSelectPackage`]="{ item }">
          <v-btn
            :loading="$store.getters.isLoading"
            depressed
            text
            color="primary"
            :ripple="false"
            class="pa-0"
            :class="{ 'pointer-none': $store.getters.isLoading }"
            style="min-width: unset !important;"
            @click="handleAddNewPackage(item.id)"
            >{{ $t('select') }}</v-btn
          >
        </template>
      </Datatable>
    </DialogLayout>

    <!-- Modal: 選擇月票 -->
    <DialogLayout ref="addMonthPassDialog" title="chooseMonthPass" hideAction cardContentClass="pa-0">
      <div class="pa-4">
        <v-row class="ma-0 my-4">
          <v-col cols="12" sm="6">
            <Searchbar
              label="searchMonthPass"
              :searchText.sync="searchFilter.keyword"
              searchPlaceholder="searchMonthPassName"
              @search-clicked="onMonthPassFilterChange()"
              :isSearching="isSearching"
              enableClear
            />
          </v-col>
        </v-row>
      </div>
      <Datatable
        :isLoading="isSearching"
        :tableData="searchTableData"
        :tableHeaders="addMonthPassTableHeaders"
        :itemTotal="searchTableTotal"
        :page.sync="searchFilter.page"
        :pageLimit.sync="searchFilter.limit"
        :pageLimitOptions="searchFilter.limitOptions"
        @options-update="onSearchTableOptionsChange()"
        tableEmptyText="noMonthPass"
      >
        <template v-slot:[`item.actionSelect`]="{ item }">
          <v-btn
            :loading="$store.getters.isLoading"
            depressed
            text
            color="primary"
            :ripple="false"
            class="pa-0"
            :class="{ 'pointer-none': $store.getters.isLoading }"
            style="min-width: unset !important;"
            @click="handleAddNewMonthPass(item.id)"
            >{{ $t('select') }}</v-btn
          >
        </template>
        <template v-slot:[`item.type`]="{ item }">
          <span v-if="item.type">{{ $t(`monthPassTypeOption.${item.type}`) }}</span>
        </template>
        <template v-slot:[`item.days`]="{ item }">
          <span v-if="item.type === 'months'">{{ $t('oneMonth') }}</span>
          <span v-else>{{ item.days }}</span>
        </template>
      </Datatable>
    </DialogLayout>

    <!-- Modal: 選擇「未付款」課堂 -->
    <FormDialog
      ref="unpaidLessonFormDialog"
      formRef="unpaidLessonForm"
      title="chooseUnpaidLesson"
      cardContentClass="pa-0"
      confirmBtnText="continue"
      enableCancel
      cancelBtnText="applyOtherLesson"
      btnAlign="space-between"
      disableCloseHide
    >
      <v-row class="ma-0">
        <v-col cols="4">
          <label class="input-label">{{ $t('unassignLesson') }}</label>
          <div>{{ availablePackageLessonCount }}</div>
        </v-col>
        <v-col cols="4">
          <label class="input-label">{{ $t('toBeAttended') }}</label>
          <div>{{ pendingPackageLessonCount }}</div>
        </v-col>
        <v-col cols="4">
          <label class="input-label">{{ $t('newPackageCount') }}</label>
          <div>{{ tempSelectedPackage ? tempSelectedPackage.lesson_count : 0 }}</div>
        </v-col>
      </v-row>
      <small class="px-4 mb-2 mt-6 d-block text-caption">{{ $t('unpaidLessonDes') }}</small>
      <Datatable
        :tableData="unpaidLessonTableData"
        :tableHeaders="lessonTableHeaders"
        :pageLimitOptions="[15, 30, 50]"
        :page.sync="unpaidLessonFilter.page"
        :pageLimit.sync="unpaidLessonFilter.limit"
        :itemTotal="allUnpaidLessonData.length"
        @options-update="getUnpaidLessonTableData()"
        enableSelectToggle
        :selectedTableRow.sync="unpaidLessonSelectedRow"
        tableEmptyText="calendar.noLesson"
        @selected-row-changed="onUnpaidLessonSelectedRowChanged()"
        disabledSelectAll
      />
    </FormDialog>

    <!-- Modal: 新增課堂 -->
    <FormDialog
      title="askConfirmToAddLesson"
      :maxWidth="600"
      ref="addLessonFormDialog"
      formRef="addLessonForm"
      enableCancel
      confirmBtnText="confirmToAddLesson"
      cancelBtnText="continueToApply"
    >
      <v-row class="ma-0">
        <v-col cols="12">
          <label class="input-label">{{ $t('selectCourse') }}</label>
          <v-radio-group name="createLessonRegularId" v-model="createLessonRegularId" column hide-details class="ma-0">
            <v-radio
              v-for="item in createLessonCourseOptions"
              :label="item.text"
              :value="item.value"
              :key="`createLessonRegularId_${item.value}`"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" sm="6">
          <FormInput label="addLessonCount" :fieldValue.sync="createLessonCount" type="number" required isIntegerOnly />
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col class="py-0" cols="12" sm="12">
            <span>{{ $t('addLessonAlert') }}</span>
        </v-col>
        <v-col class="py-0" cols="12" sm="12">
          <Datatable
            class="mb-4"
            :enableSelectToggle="select_std"
            :tableData="course_students"
            :tableHeaders="courseStudentHeader"
            disablePagination
            :selectedTableRow.sync="selected_course_students"
          >
          </Datatable>
            <!-- tableName="select_std" -->
        </v-col>
      </v-row>
    </FormDialog>

    <!-- Modal: 修改項目資料 -->
    <FormDialog ref="editFormDialog" formRef="editForm" title="editItem" cardContentClass="pa-0">
      <v-row class="ma-0 my-4" v-if="editItemData.type !== 'assign_month_pass'">
        <template v-if="editItemData.type !== 'package' || enableMultiPackage">
          <v-col cols="12" sm="6">
            <FormSelect
              label="discountType"
              :fieldValue.sync="editItemData.discount_type"
              :options="discountTypeOptions"
              placeholder="selectDiscountType"
              @changed="editItemData.discount_value = ''"
              enableClear
              :disabled="disabledInOldVersion"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <FormDiscount
              :discountValue.sync="editItemData.discount_value"
              :discountType="editItemData.discount_type"
              :price="editItemData.original_price"
              :disabled="disabledInOldVersion"
              :required="$validate.DataValid(editItemData.discount_type)"
            />
          </v-col>
        </template>

        <v-col cols="12" sm="6">
          <div class="input-label">{{ $t('price') }}</div>
          <div class="d-flex align-center mt-3">
            <span
              :class="{ 'text-decoration-line-through': $validate.DataValid(editDiscountPrice) }"
              class="colorBlack--text"
            >
              ${{ $formatter.separator(editItemData.original_price || 0) }}
            </span>
            <span v-if="$validate.DataValid(editDiscountPrice)" class="primary--text ml-2">
              ${{ $formatter.separator(editDiscountPrice) }}
            </span>
          </div>
        </v-col>
      </v-row>

      <Datatable
        :isLoading="editTableLoading"
        :tableData="editTableData"
        :tableHeaders="editItemHeaders"
        disablePagination
        :enableSelectToggle="
          !disabledEditItem && (editItemData.type === 'course' || editItemData.type === 'assign_month_pass')
        "
        :selectedTableRow.sync="editItemData.selectedRow"
        :tableEmptyText="editItemData.type === 'product' ? 'noProduct' : 'calendar.noLesson'"
      >
        <template
          slot="append-toolbar-left"
          v-if="
            !isAppMode(['T01']) &&
              !disabledEditItem &&
              !disabledInOldVersion &&
              (editItemData.type === 'month_pass' || editItemData.type === 'package')
          "
        >
          <FormButton text="chooseLesson" class="my-2" @click="openEditLesson(editItemData.type)" outlined>
            <template slot="prepend"><v-icon class="fi fi-rr-pencil mr-1" color="primary" size="15"></v-icon></template>
          </FormButton>
        </template>
        <template v-slot:[`item.trial`]="{ item }">
          <v-simple-checkbox
            v-model="item.trial"
            color="primary"
            :disabled="item.order_id !== -1 || $validate.DataValid(orderId)"
          />
        </template>
      </Datatable>

      <v-row class="ma-0" v-if="allowRemoveLessonAlert">
        <v-col cols="12">
          <small class="text-caption">
            <v-icon size="15" class="mr-1">{{ icon.mdiInformation }}</v-icon>
            {{ $t('message.attendanceRemoveIfLessonRemove') }}
          </small>
        </v-col>
      </v-row>
    </FormDialog>

    <!-- Modal: 新增自訂項目 -->
    <FormDialog title="addCustomItems" ref="addCustomItemFormDialog" formRef="addCustomItemForm">
      <v-row class="ma-0">
        <v-col cols="12" sm="6">
          <FormInput
            label="purchaseItem"
            :fieldValue.sync="customItemFormData.name"
            required
            :disabled="disabledInOldVersion"
          />
        </v-col>
        <v-col cols="12">
          <FormTextarea
            label="itemDescription"
            :fieldValue.sync="customItemFormData.description"
            :disabled="disabledInOldVersion"
          />
        </v-col>
        <!-- <v-col v-if="!isAppMode('T32')" cols="12" sm="6">
          <FormSelect
            label="quantity"
            :fieldValue.sync="customItemFormData.qty"
            required
            :options="qtyOptions"
            :disabled="disabledInOldVersion"
          />
        </v-col>
        <v-col v-if="isAppMode('T32')" cols="12" sm="6"> -->
        <v-col cols="12" sm="6">
          <FormInput
            label="quantity"
            :fieldValue.sync="customItemFormData.qty"
            required
            type="number"
            :disabled="disabledInOldVersion"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <FormInput
            label="unitPrice"
            :fieldValue.sync="customItemFormData.price"
            required
            type="number"
            prefix="$"
            :disabled="disabledInOldVersion"
          />
        </v-col>
      </v-row>
    </FormDialog>

    <!-- Alert: 重覆課堂 -->
    <DialogLayout
      ref="repeatLessonDialog"
      isError
      title="message.repeatLesson"
      btnAlign="center"
      hideAction
      :maxWidth="500"
    >
      <v-list class="px-4 my-4">
        <v-list-item
          class="my-1 pa-0"
          v-for="(item, i) in repeatLessons"
          style="min-height: unset;"
          :key="`repeat_lesson_${i}`"
        >
          {{ item.course_name }} {{ item.date.substring(8, 10) }}/{{ item.date.substring(5, 7) }}/{{
            item.date.substring(0, 4)
          }}
          ({{ $d($formatter.convertDate(item.date), 'weekdayShort') }}) {{ item.start_time }}-{{ item.end_time }}
        </v-list-item>
      </v-list>
    </DialogLayout>

    <!-- Alert: 轉到該分校頁面 -->
    <FormDialog ref="confirmChangeCenterMulti" formRef="selectCenterForm" enableCancel :maxWidth="500">
      <div>{{ $t('message.confirmChangeCenter1', { name: this.changeCenterAlert.studentName }) }}</div>
      <v-radio-group v-model="changeCenterAlert.schoolId" class="ma-0" :rules="[v => this.$validate.required(v)]">
        <v-radio
          v-for="item in changeCenterAlert.centerOptions"
          :label="item.text"
          :value="item.value"
          :key="item.value"
        ></v-radio>
      </v-radio-group>
      <div>{{ $t('message.confirmChangeCenter2') }}</div>
    </FormDialog>

    <!-- Alert: 付款已完成 -->
    <ConfirmDialog ref="payDoneAlert" title="" confirmBtnText="continuePay" cancelBtnText="viewOrder">
      <p>{{ $t('message.paymentCompleted', { count: payDoneAlert.count }) }}</p>
      <p v-if="payDoneAlert.message">{{ $t(payDoneAlert.message) }}</p>
    </ConfirmDialog>
  </v-container>
</template>

<script>
import { mdiInformation } from '@mdi/js'
import Datatable from '@/components/Datatable.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import FormSelect from '@/components/formField/FormSelect.vue'
import FormInput from '@/components/formField/FormInput.vue'
import FormDatePicker from '@/components/formField/FormDatePicker.vue'
import DialogLayout from '@/components/layout/DialogLayout.vue'
import FormDialog from '@/components/FormDialog.vue'
import Searchbar from '@/components/Searchbar.vue'
import FormTextarea from '@/components/formField/FormTextarea.vue'
import SignPad from '@/components/SignPad.vue'
import FormTimePicker from '@/components/formField/FormTimePicker.vue'
import ItemAction from './components/ItemAction.vue'
import WhatsappButton from '@/components/WhatsappButton.vue'
import TableDropdown from '@/components/layout/TableDropdown.vue'
import FormUploader from '@/components/formField/FormUploader.vue'
import AssignLessonDialog from './components/AssignLessonDialog.vue'
import FormDiscount from '@/components/formField/FormDiscount.vue'
import OrderDetailRow from './components/OrderDetailRow.vue'
import FormSearchSelect from '@/components/formField/FormSearchSelect.vue'

export default {
  name: 'PayTuitionPayment',
  inject: ['getConfirmDialogRef'],
  components: {
    Datatable,
    ConfirmDialog,
    FormSelect,
    FormInput,
    FormDatePicker,
    DialogLayout,
    FormDialog,
    Searchbar,
    FormUploader,
    FormTextarea,
    SignPad,
    ItemAction,
    FormTimePicker,
    WhatsappButton,
    TableDropdown,
    AssignLessonDialog,
    FormDiscount,
    OrderDetailRow,
    FormSearchSelect,
  },
  computed: {
    confirmRef() {
      return this.getConfirmDialogRef()
    },
    id() {
      return this.$validate.regexNumber(this.$route.params.id) ? parseInt(this.$route.params.id) : null
    },
    orderId() {
      const query = this.$route.query
      if (this.$validate.DataValid(query) && this.$validate.regexNumber(query.order)) {
        return parseInt(query.order)
      }

      return null
    },
    studentAvatar() {
      if (this.$validate.DataValid(this.studentData.avatar)) {
        return `${this.$mediaPath}/${this.studentData.avatar}`
      } else if (this.studentData.gender === 'M') {
        return require('@/assets/images/gender-m.svg')
      } else if (this.studentData.gender === 'F') {
        return require('@/assets/images/gender-f.svg')
      } else {
        return ''
      }
    },
    displayTabs() {
      let list = ['course', 'package', 'month_pass', 'assign_month_pass', 'online_course']
      if (this.isAppMode(['T49'])){
        list = ['package', 'month_pass', 'assign_month_pass', 'online_course']
      }
      for (let i = list.length - 1; i >= 0; i--) {
        if (list[i] === 'course') {
          if (
            this.isAppMode(['T01']) &&
            (!this.$validate.DataValid(this.orderId) ||
              (this.$validate.DataValid(this.orderId) &&
                (this.orderData.lesson_list.length < 1 || this.orderData.package_list.length > 0)))
          ) {
            list.splice(i, 1)
          }
        } else if (list[i] === 'month_pass') {
          if (!this.gEnableMonthPass) {
            list.splice(i, 1)
          }
        } else if (list[i] === 'assign_month_pass') {
          if (
            !this.gEnableMonthPass ||
            this.otherMonthPassLessonDates.length < 1 ||
            this.$validate.DataValid(this.orderId)
          ) {
            list.splice(i, 1)
          }
        } else if (list[i] === 'online_course') {
          if (!this.$validate.DataValid(this.orderId) || !this.orderData.order_type.includes('online_course')) {
            list.splice(i, 1)
          }
        }
      }
      return list
    },
    currentTabType() {
      return this.paymentTypeTab.substring('tab_'.length)
    },
    courseTableHeaders() {
      let headers = [{ value: 'course_name', text: this.$t('purchaseItem'), width: 150 }]
      if (this.$validate.DataValid(this.courseTableData)) {
        headers = [
          ...headers,
          { value: 'month_label', text: this.$t('month') },
          { value: 'dates', text: this.$t('date'), width: 300 },
          { value: 'unit_price', text: this.$t('price') },
          { value: 'qty', text: this.$t('quantity') },
          { value: 'total', text: this.$t('subtotal') },
          { value: 'action', text: '', align: 'end' },
        ]
      }

      return headers
    },
    productTableHeaders() {
      let headers = [{ value: 'item_name', text: this.$t('purchaseItem'), width: 150 }]

      if (this.$validate.DataValid(this.productTableData)) {
        headers = [...headers, { value: 'unit_price', text: this.$t('price') }]
        if (this.enablePoints) {
          headers.push({ value: 'points', text: this.$t('neededPoints') })
        }
        headers = [
          ...headers,
          { value: 'qty', text: this.$t('quantity') },
          { value: 'total_text', text: this.$t('subtotal') },
          { value: 'action', text: '', align: 'end' },
        ]
      }

      return headers
    },
    packageTableHeaders() {
      let headers = [{ value: 'item_name', text: this.$t('purchaseItem'), width: 150 }]
      if (this.$validate.DataValid(this.packageTableData)) {
        headers = [
          ...headers,
          { value: 'lesson_count', text: this.$t('lessonQty') },
          { value: 'dates', text: this.$t('date'), width: 300 },
          { value: 'unit_price', text: this.$t('price') },
          { value: 'qty', text: this.$t('quantity') },
          { value: 'total', text: this.$t('subtotal') },
          { value: 'action', text: '', align: 'end' },
        ]
      }

      return headers
    },
    monthPassTableHeaders() {
      let headers = [{ value: 'item_name', text: this.$t('purchaseItem'), width: 150 }]
      if (this.$validate.DataValid(this.monthPassTableData)) {
        headers = [
          ...headers,
          { value: 'dates', text: this.$t('date'), width: 300 },
          { value: 'unit_price', text: this.$t('price') },
          { value: 'qty', text: this.$t('quantity') },
          { value: 'total', text: this.$t('subtotal') },
          { value: 'action', text: '', align: 'end' },
        ]
      }

      return headers
    },
    addCourseTableHeaders() {
      const vm = this
      let headers = [
        { value: 'course_name', text: vm.$t('purchaseItem') },
        { value: 'full_date', text: vm.$t('date'), hasWeekday: true },
        { value: 'timeslot', text: vm.$t('time') },
      ]
      if (!this.disableCourseGrade) {
        headers.push({ value: 'grade', text: vm.$t('grade') })
      }
      headers = [
        ...headers,
        { value: 'tutor', text: vm.$t('tutor') },
        { value: 'current_per_max_student_num', text: vm.$t('personCount') },
        { value: 'actionSelectCourse', text: '', align: 'end' },
      ]
      return headers
    },
    addProductTableHeaders() {
      const vm = this
      let headers = [
        { value: 'item_name', text: vm.$t('purchaseItem'), width: 300 },
        { value: 'inventory', text: vm.$t('inventory') },
        { value: 'unit_price', text: vm.$t('price') },
      ]
      if (this.enablePoints) {
        headers.push({ value: 'points', text: vm.$t('neededPoints') })
      }
      headers.push({ value: 'qtySetter', text: vm.$t('quantity'), align: 'center', width: 140 })
      headers.push({ value: 'actionSelectProduct', text: '', align: 'end' })
      return headers
    },
    // 訂單詳情
    subtotal() {
      let subtotal = 0

      const selectProductIds = this.productSelectedRow.map(el => el.id)
      const selectedProductRows = this.productTableData.filter(el => selectProductIds.includes(el.id))
      subtotal += selectedProductRows.reduce((count, item) => count + this.getUnitPrice(item) * item.qty, 0)

      if (this.currentTabType === 'course') {
        const selectedIds = this.courseSelectedRow.map(el => el.id)
        const selectedRows = this.courseTableData.filter(el => selectedIds.includes(el.id))
        // console.log(selectedRows);
        subtotal += selectedRows.reduce((count, item) => count + this.getUnitPrice(item) * item.qty, 0)
      } else if (this.currentTabType === 'package') {
        const selectedIds = this.packageSelectedRow.map(el => el.id)
        const selectedRows = this.packageTableData.filter(el => selectedIds.includes(el.id))
        subtotal += selectedRows.reduce((count, item) => count + this.getUnitPrice(item) * item.qty, 0)
      } else if (this.currentTabType === 'month_pass') {
        const selectedIds = this.monthPassSelectedRow.map(el => el.id)
        const selectedRows = this.monthPassTableData.filter(el => selectedIds.includes(el.id))
        subtotal += selectedRows.reduce((count, item) => count + this.getUnitPrice(item) * item.qty, 0)
      } else if (this.currentTabType === 'online_course') {
        const selectedIds = this.onlineCourseSelectedRow.map(el => el.id)
        const selectedRows = this.onlineCourseTableData.filter(el => selectedIds.includes(el.id))
        subtotal += selectedRows.reduce((count, item) => count + this.getUnitPrice(item) * item.qty, 0)
      }

      return subtotal
    },
    pointSubtotals() {
      let subtotal = 0
      const selectProductIds = this.productSelectedRow.map(el => el.id)
      const selectedProductRows = this.productTableData.filter(el => selectProductIds.includes(el.id))
      subtotal += selectedProductRows.reduce((count, item) => count + item.points * item.qty, 0)
      return subtotal
    },
    itemQtyLabel() {
      switch (this.currentTabType) {
        case 'package':
          return 'packageQty'
        case 'month_pass':
          return 'monthPassQty'
        case 'online_course':
          return 'onlineCourseQty'
      }
      return 'lessonQty'
    },
    itemQty() {
      let selectedIds = []
      let selectedRows = []

      if (this.currentTabType === 'course') {
        selectedIds = this.courseSelectedRow.map(el => el.id)
        selectedRows = this.courseTableData.filter(el => selectedIds.includes(el.id) && el.order_type === 'course')
      } else if (this.currentTabType === 'package') {
        selectedIds = this.packageSelectedRow.map(el => el.id)
        selectedRows = this.packageTableData.filter(el => selectedIds.includes(el.id) && el.order_type === 'package')
      } else if (this.currentTabType === 'month_pass') {
        selectedIds = this.monthPassSelectedRow.map(el => el.id)
        selectedRows = this.monthPassTableData.filter(
          el => selectedIds.includes(el.id) && el.order_type === 'month_pass',
        )
      } else if (this.currentTabType === 'online_course') {
        selectedIds = this.onlineCourseSelectedRow.map(el => el.id)
        selectedRows = this.onlineCourseTableData.filter(
          el => selectedIds.includes(el.id) && el.order_type === 'online_course',
        )
      }

      return selectedRows.reduce((count, item) => count + item.qty, 0)
    },
    customItemQty() {
      let selectedIds = []
      let selectedRows = []

      if (this.currentTabType === 'course') {
        selectedIds = this.courseSelectedRow.map(el => el.id)
        selectedRows = this.courseTableData.filter(el => selectedIds.includes(el.id) && el.order_type === 'custom')
      } else if (this.currentTabType === 'package') {
        selectedIds = this.packageSelectedRow.map(el => el.id)
        selectedRows = this.packageTableData.filter(el => selectedIds.includes(el.id) && el.order_type === 'custom')
      } else if (this.currentTabType === 'month_pass') {
        selectedIds = this.monthPassSelectedRow.map(el => el.id)
        selectedRows = this.monthPassTableData.filter(el => selectedIds.includes(el.id) && el.order_type === 'custom')
      }
      return selectedRows.reduce((count, item) => count + item.qty, 0)
    },
    productQty() {
      const selectedIds = this.productSelectedRow.map(el => el.id)
      const selectedRows = this.productTableData.filter(el => selectedIds.includes(el.id))
      return selectedRows.reduce((count, item) => count + item.qty, 0)
    },
    skipLessonQty() {
      if (this.currentTabType === 'course') {
        const selectedIds = this.courseSelectedRow.map(el => el.id)
        const selectedRows = this.courseTableData.filter(el => selectedIds.includes(el.id) && el.order_type === 'skip')
        return selectedRows.reduce((count, item) => count + item.qty, 0)
      }
      return 0
    },
    totalAmount() {
      let total = this.subtotal
      if (this.formData.discount_type && this.formData.discount_value) {
        total = this.getDiscountPrice(this.subtotal, this.formData.discount_type, this.formData.discount_value)
      }

      if (this.$validate.DataValid(this.orderId) && this.orderData.status === 'debit') {
        total -= this.orderData.debit_amount
      }

      if (!total) {
        total = 0
      }

      return this.$formatter.formatMoney(total)
    },
    pointTotalAmount() {
      let total = this.pointSubtotals
      return total
    },
    statusOptions() {
      const vm = this
      let paidDisabled = false
      let pendingDisabled = false
      let processingDisabled = false

      if (this.$validate.DataValid(this.orderId)) {
        if (this.orderData.status === 'pending') {
        } else if (this.orderData.status === 'processing') {
          pendingDisabled = true
        } else {
          if (this.orderData.status !== 'paid') {
            paidDisabled = true
          }

          pendingDisabled = true
          processingDisabled = true
        }
      }

      if (this._forcePaid()) {
        // 如果係待付款項目，status只可以係"paid"
        pendingDisabled = true
        processingDisabled = true
      }

      let options = [
        { value: 'paid', text: vm.$t('paymentStatus.paid'), disabled: paidDisabled },
        { value: 'pending', text: vm.$t('paymentStatus.pending'), disabled: pendingDisabled },
        { value: 'processing', text: vm.$t('paymentStatus.processing'), disabled: processingDisabled },
      ]
      
      if (this.isAppMode(['T49'])){
        options = [
          { value: 'pending', text: vm.$t('paymentStatus.pending'), disabled: pendingDisabled },
          { value: 'processing', text: vm.$t('paymentStatus.processing'), disabled: processingDisabled },
          { value: 'paid', text: vm.$t('paymentStatus.paid'), disabled: paidDisabled },
        ]
      }

      if (this.$validate.DataValid(this.orderId)) {
        if (!['paid', 'pending', 'processing'].includes(this.orderData.status)) {
          options.unshift({ value: this.orderData.status, text: vm.$t(`orderStatusOption.${this.orderData.status}`) })
        }
      }

      return options
    },
    // 修改項目資料
    editDiscountPrice() {
      const p = this.getDiscountPrice(
        this.editItemData.original_price,
        this.editItemData.discount_type,
        this.editItemData.discount_value,
      )
      return p
    },
    editItemHeaders() {
      const vm = this
      let headers = []
      if (this.editItemData.type === 'course' || this.editItemData.type === 'assign_month_pass') {
        headers = [
          { value: 'full_date', text: vm.$t('date'), width: 145 }, // need 'date'
          { value: 'weekday', text: vm.$t('weekday'), width: 80 },
          { value: 'timeslot', text: vm.$t('time') },
        ]
        if (this.isAppMode(['DEV', 'UAT']) && this.editItemData.type === 'course') {
          // TODO: #234 add T02 after apply
          headers.push({ value: 'trial', text: vm.$t('trialLesson'), align: 'end' })
        }
      } else if (this.editItemData.type === 'product') {
        headers = [
          { value: 'item_name', text: vm.$t('purchaseItem'), width: 400 },
          { value: 'inventory', text: vm.$t('inventory') },
        ]
        if (this.disabledInOldVersion) {
          headers.push({ value: 'qty', text: vm.$t('quantity') })
        } else {
          headers.push({ value: 'qtySetter', text: vm.$t('quantity'), align: 'center', width: 140 })
        }
      } else if (this.editItemData.type === 'package' || this.editItemData.type === 'month_pass') {
        headers = this.lessonTableHeaders
      }

      return headers
    },
    allowRemoveLessonAlert() {
      if (this.enableSelectDropLesson) return false
      if (!this.isAppMode(['T01'])) {
        if (
          this.editItemData.type === 'course' ||
          this.editItemData.type === 'package' ||
          this.editItemData.type === 'month_pass'
        ) {
          if (
            this.$validate.DataValid(this.orderId) ||
            (this.editItemData.type === 'course' &&
              this.editTableData.length > 0 &&
              this.editTableData[0].order_id === -2)
          ) {
            return true
          }
        }
      }

      return false
    },
    // page setting
    disabledEditItem() {
      // 不可以減course/product/package/custom item，改discount
      /**
       * 只可以update order，唔可以renew
       * 1. 如果order status != "pending"
       * 2. 如果order係用積分換領
       * 3. 如果order係買package，而又包含咗未付款lesson
       * 4. 如果order係線上課程
       */
      if (this.$validate.DataValid(this.orderId)) {
        return (
          this.orderData.status !== 'pending' ||
          this.orderData.is_redeem ||
          // (this.orderData.order_type.includes('package') && this.orderData.unpaid_lesson_datas.length > 0) ||
          this.orderData.order_type.includes('online_course')
        )
      }
      return false
    },
    disabledAddCourse() {
      // 不可以加course
      return (
        this.disabledEditItem ||
        (this.$validate.DataValid(this.orderId) &&
          !this.orderData.order_type.includes('course') &&
          !this.orderData.order_type.includes('custom') &&
          !this.orderData.order_type.includes('skip') &&
          !this.orderData.order_type.includes('product')) ||
        (this.$validate.DataValid(this.orderId) && this.isAppMode(['T01']))
      )
    },
    disabledAddPackage() {
      // 不可以加package
      return (
        this.disabledEditItem ||
        (this.$validate.DataValid(this.orderId) &&
          !this.orderData.order_type.includes('package') &&
          !this.orderData.order_type.includes('custom') &&
          !this.orderData.order_type.includes('product')) ||
        (this.$validate.DataValid(this.orderId) && this.isAppMode(['T01']))
      )
    },
    disabledAddMonthPass() {
      // 不可以加月票
      return (
        this.disabledEditItem ||
        (this.$validate.DataValid(this.orderId) &&
          !this.orderData.order_type.includes('month_pass') &&
          !this.orderData.order_type.includes('custom') &&
          !this.orderData.order_type.includes('product')) ||
        (this.$validate.DataValid(this.orderId) && this.isAppMode(['T01']))
      )
    },
    disabledInOldVersion() {
      // 舊版本唔到以edit到嘅item
      // 唔比加野，改discount
      return this.disabledEditItem || (this.$validate.DataValid(this.orderId) && this.isAppMode(['T01']))
    },
    // permission / setting
    enableCustomItem() {
      return !this.isAppMode(['T01'])
    },
    enableMultiPackage() {
      return !this.isAppMode(['T01', 'T03', 'T17'])
    },
    enableSelectDropLesson() {
      // 如果本期/下期應付項目有lesson remove咗，可以揀照keep啲堂定退堂
      return !this.isAppMode(['T01'])
    },
    enableCombineNextAndNew() {
      // 本期/下期應付項目 同 新增項目 可以同一張單
      return !this.isAppMode(['T01'])
    },
    enableCombineUnpaidAndNew() {
      // 待付款 同 新增項目 可以同一張單
      // 呢個未有function架，不過都整定先啦，因為我都係有良心嘅，邊個冇就唔知啦
      return false
    },
    enableCombineNextAndUnpaid() {
      // 本期/下期應付項目 同 待付款，用`extend_order`黎create
      return !this.isAppMode(['T01'])
    },
    canEditOrder() {
      return this.$validate.allowAction('editOrder', this.userType)
    },
    canAdvancedEditOrder() {
      return this.$validate.allowAction('advancedEditOrder', this.userType)
    },
    canViewStudent() {
      return this.$validate.allowAction('StudentDetails', this.userType)
    },
    canViewOrder() {
      return this.$validate.allowAction('OrderList', this.userType)
    },
  },
  watch: {
    totalAmount: {
      handler(val) {
        if (this.totalAmountInit) {
          this.formData.subtotal = val
        }
        this.totalAmountInit = true
      },
      immediate: false,
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    permissionValid: true,

    payDoneAlert: {
      count: 5,
      message: '',
      counter: null,
    },
    disableCourseGrade: false,
    rowId: 0,
    tableLoading: false,
    tutorOptions: [],
    paymentTypeTab: 'tab_course',
    paymentItemTab: 'tab_course',
    totalAmountInit: false,
    orderData: {
      order_code: '',
      status: '',
      order_type: [],
      unpaid_lesson_datas: [],
      except_lesson_id_list: [],
      custom_items: [],
      lesson_list: [],
      lesson_datas: [],
      package_list: [],
      product_list: [],
      month_pass_list: [],
      month_pass_selected_months: [],
      discount_type: '',
      discount_value: '',
      is_redeem: false,
      order_date: '',
      pay_date: '',
      debit_amount: 0,
      real_subtotal: 0,
    },

    studentData: {
      student_id: -1,
      student_name: '',
      gender: '',
      phone: '',
      schools: [],
      grade: '',
      remark: '',
      siblings: [],
      avatar: '',
    },
    formData: {
      is_redeem: false,
      discount_type: '',
      discount_value: '',
      status: 'paid',
      payment_method: 'cash',
      payment_images: [],
      remark: '',
      pdf_remark: '',
      sign: '',
      order_create_date: '',
      order_create_time: '',
      pay_date: '',
      pay_time: '',
      subtotal: 0,
      custom_invoice_number: '',

      discount_method: 'manually', // manually | code
      discount_coupon_code: null,
    },
    appliedCoupon: null,
    couponOptions: [],
    couponSearching: false,

    changeCenterAlert: {
      studentName: '',
      centerOptions: [],
      schoolId: null,
    },

    isSearching: false,
    searchFilter: {
      keyword: '',
      limitOptions: [5, 10, 20],
      limit: vm.isAppMode(['T37', 'T40', 'T45']) ? 20 : 5,
      page: 1,
    },
    searchTableTotal: 0,
    searchTableData: [],
    searchTableSelectedRow: [],
    tempSelectedLesson: [],

    // edit common
    editTableLoading: false,
    editTableData: [],
    editItemData: {
      type: '',
      discount_type: '', // 'percentage' | 'fix_amount'
      discount_value: '',
      original_price: 0,
      selectedRow: [], // edit course
    },

    // ===== Course related
    courseTableData: [],
    courseSelectedRow: [],
    nextPreviewOrder: null,
    nextPreviewOrderAdd: 1,
    prevPreviewOrder: null,
    previewMonths: 1,

    // search course
    addCourseFilter: {
      type: 'weekday', // 'weekday' | 'singleDate'
      keyword: '',
      weekdays: [],
      dateRange: [],
      tutor: null, // tutor id
      grade: '',
      packageLessonRule: 'auto', // 'auto' | 'manually'
      selectedMonth: '',
    },
    courseNameOptions: [],
    courseNameSearching: false,

    // ===== Product related
    productTableData: [],
    productSelectedRow: [],

    // ===== Package related
    packageTableData: [],
    packageSelectedRow: [],
    remainPackageLessonCount: 0,
    pendingPackageLessonCount: 0,
    availablePackageLessonCount: 0,
    remainPackageLessonCountInit: true,
    createLessonCount: 0,
    createLessonRegularId: null,
    createLessonCourseOptions: [],

    // search package
    tempSelectedPackage: null,

    // unpaid lesson
    allUnpaidLessonDataStatic: [],
    allUnpaidLessonData: [],
    unpaidLessonTableData: [],
    unpaidLessonSelectedRow: [],
    unpaidLessonFilter: {
      page: 1,
      limit: 15,
    },

    repeatLessons: [],

    // ===== 新增自訂項目
    customItemFormData: {
      name: '',
      description: '',
      qty: 1,
      price: '',
    },

    // ===== 月票 related
    monthPassTableData: [],
    monthPassSelectedRow: [],
    // search month pass
    tempSelectedMonthPass: null,

    otherMonthPassLessonDates: [],
    existMonthPass: {
      limit: vm.isAppMode(['T37', 'T40', 'T45']) ? 20 : 5,
      page: 1,
      tableData: [],
      allData: [],
      total: 0,
    },
    assignLessonTableData: [],
    assignLessonSelectedRow: [],

    // ===== 換領積分
    enablePoints: false,
    pointsCanUse: 0,

    // ===== 待付款/待審核訂單
    unpaidTableData: [],

    // ===== 線上課程 related
    onlineCourseTableData: [],
    onlineCourseSelectedRow: [],

    // ===== static data
    discountTypeOptions: [
      { value: 'percentage', text: vm.$t('percentage') },
      { value: 'fix_amount', text: vm.$t('fixAmount') },
    ],
    discountMethodOptions: [
      { value: 'manually', text: vm.$t('discountMethodOptions.manually') },
      { value: 'code', text: vm.$t('discountMethodOptions.code') },
    ],
    lessonTableHeaders: [
      { value: 'course_name', text: vm.$t('courseName'), width: 250 },
      { value: 'full_date', text: vm.$t('date'), width: 145 }, // need 'date'
      { value: 'weekday', text: vm.$t('weekday'), width: 80 },
      { value: 'timeslot', text: vm.$t('time') },
    ],
    addPackageTableHeaders: [
      { value: 'item_name', text: vm.$t('purchaseItem'), width: 150 },
      { value: 'lesson_count', text: vm.$t('lessonQty') },
      { value: 'unit_price', text: vm.$t('price') },
      { value: 'total', text: vm.$t('subtotal') },
      { value: 'actionSelectPackage', text: '', align: 'end' },
    ],
    addMonthPassTableHeaders: [
      { value: 'item_name', text: vm.$t('purchaseItem'), width: 150 },
      { value: 'type', text: vm.$t('monthPassType') },
      { value: 'days', text: vm.$t('monthPassValidDay') },
      { value: 'unit_price', text: vm.$t('price') },
      { value: 'qtySetter', text: vm.$t('quantity'), align: 'center', width: 140 },
      { value: 'actionSelect', text: '', align: 'end' },
    ],
    qtyOptions: [],
    unpaidTableHeaders: [
      { value: 'order_code', text: vm.$t('orderCode'), width: vm.isAppMode(['T21']) ? 250 : 100 },
      { value: 'create_date', text: vm.$t('createdDate'), width: 120 },
      { value: 'order_type', text: vm.$t('orderType'), width: 120 },
      { value: 'order_items', text: vm.$t('item'), width: 300 },
      { value: 'qty', text: vm.$t('quantity') },
      { value: 'total_price', text: vm.$t('totalPrice'), width: 110 },
      { value: 'remark', text: vm.$t('remark'), width: 200 },
      { value: 'status', text: vm.$t('status'), align: 'center' },
    ],
    editOrderTableHeaders: [],
    onlineCourseTableHeaders: [
      { value: 'item_name', text: vm.$t('purchaseItem'), width: 150 },
      { value: 'unit_price', text: vm.$t('price') },
      { value: 'qty', text: vm.$t('quantity') },
      { value: 'total', text: vm.$t('subtotal') },
    ],
    createTimeOptions: [],
    existMonthPassTableHeaders: [
      { value: 'range', text: vm.$t('dayRange') },
      { value: 'action', text: '', align: 'end' },
    ],
    assignLessonTableHeaders: [
      { value: 'item_name', text: vm.$t('courseName'), width: 250 },
      { value: 'month_label', text: vm.$t('month') },
      { value: 'dates', text: vm.$t('date') },
      { value: 'action', text: '', align: 'end' },
    ],
    siblingTableHeaders: [
      { value: 'name', text: vm.$t('name'), width: 150 },
      { value: 'relationship', text: vm.$t('relationship'), width: 80 },
      { value: 'phone', text: vm.$t('phone') },
      { value: 'actionNav', text: '', align: 'end', width: 150 },
    ],
    icon: {
      mdiInformation,
    },

    courseStudentHeader: [
      { value: 'student_code', text: vm.$t('studentCode'), width: 120 },
      { value: 'class_student_name', text: vm.$t('studentName'), width: 130 },
      { value: 'select_student', text: '', align: 'end' },
    ],
    select_std: true,
    course_code: '',
    course_students: [],
    selected_course_students: [],
    // ===== End of static data
  }),
  methods: {
    async getPayTuitionData() {
      this.resetPage()
      this.tableLoading = true
      try {
        if (this.$validate.DataValid(this.id)) {
          const data = await this.$Fetcher.GetPayTuitionById(this.id, { join_siblings: true })
          // staff只可以view所屬分校student
          if (
            !this.gDisableStudentCenter &&
            this.$validate.DataValid(data.schools, true) &&
            !data.schools.includes(-1)
          ) {
            let pass = false
            const getUserSchools = this.gfGetUserSchools()
            for (let i = 0; i < data.schools.length; i++) {
              if (getUserSchools.includes(data.schools[i])) {
                pass = true
                break
              }
            }

            if (!pass) {
              this.permissionValid = false
              throw 'message.notBelongStudentBranch'
            }
          }

          for (const key in this.studentData) {
            if (this.$validate.DataValid(data[key])) {
              this.studentData[key] = data[key]
            }
          }
          this.$store.dispatch('toggleLoadingPage', false)

          // 如果該學生不屬於現時分校，alert轉分校
          if (!this.gDisableStudentCenter) {
            const selectedSchool = this.gfGetUserSelectedSchool()
            if (
              selectedSchool > -1 &&
              this.$validate.DataValid(data.schools, true) &&
              !data.schools.includes(-1) &&
              !data.schools.includes(selectedSchool)
            ) {
              this.changeCenterAlert.studentName = data.student_name
              if (data.schools.length === 1) {
                const centerName = await this._getCenterName(data.schools[0])
                const confirm = await this.confirmRef.show({
                  message: this.$t('message.confirmChangeCenter', {
                    name: data.student_name,
                    center: centerName,
                  }),
                })
                if (confirm) {
                  // reject if 該admin不是under要轉去嘅分校
                  const adminSchools = this.gfGetUserSchools()
                  if (!adminSchools.includes(data.schools[0])) {
                    this.showAlert({
                      title: '',
                      message: 'message.adminNotBelongsCenter',
                      isError: true,
                    })
                  } else {
                    this.gfExpiredSettingLogo()
                    this.gfUpdateUserSelectedSchool(data.schools[0])
                    this.$router.go()
                    return
                  }
                }
              } else {
                this.changeCenterAlert.centerOptions = []
                const centers = await this.$Fetcher.GetSchoolsByIdList(data.schools)
                for (let i = 0; i < data.schools.length; i++) {
                  const found = centers.find(el => el.id === data.schools[i])
                  if (found) {
                    this.changeCenterAlert.centerOptions.push({ value: data.schools[i], text: found.name })
                  }
                }
                this._handleNavSchool(this.id)
                this.changeCenterAlert.schoolId = data.schools[0]
              }
            }
          }

          if (this.$validate.DataValid(this.orderId)) {
            await this.getOrderById()
          } else {
            await this.getPreviews()
          }
          this.tableLoading = false
        } else {
          throw 'noData'
        }
      } catch (err) {
        this.$common.error(err)
        if (err !== 'abort') {
          this.showAlert({
            message: err,
            returnLink: 'PayTuitionList',
            isError: true,
          })
        }
        this.$store.dispatch('toggleLoadingPage', false)
      }
    },
    async getPreviews() {
      this.totalAmountInit = true
      this.tableLoading = true
      let next = true
      let existLesson = []
      if (next) next = await this.getStudentOrders() // >-1
      if (this.$validate.DataValid(this.unpaidTableData, true)) {
        existLesson = this.unpaidTableData.reduce((list, item) => {
          let l = []
          if (this.$validate.DataValid(item.lesson_datas, true)) {
            l = item.lesson_datas.map(el => el.id)
          }
          if (this.$validate.DataValid(item.unpaid_lesson_datas, true)) {
            const ids = item.unpaid_lesson_datas.map(el => el.id)
            l = [...l, ...ids]
          }
          return [...list, ...l]
        }, [])
      }

      if (next) next = await this.generateNextMonthPreview(existLesson) // -2
      if (this.nextPreviewOrder) {
        const existLessonNext = (this.nextPreviewOrder.lesson_list || []).map(el => el.id)
        existLesson = [...existLesson, ...existLessonNext]
      }

      if (next) next = await this.generatePrevUnpaidPreview(existLesson) // -3
      if (next) next = await this.generateSkipLessonPreview() // -5

      this.onCourseSelectedRowChanged()
      this.tableLoading = false
    },
    _groupPreviewOrder(order_id, previewOrder) {
      const courseRows = []
      previewOrder.lesson_list.forEach(item => {
        const targetItem = previewOrder.lesson_datas.find(el => el.id === item.id)
        // filter 走已經paid咗嘅lesson
        if (targetItem && !targetItem.paid_student_ids.includes(this.studentData.student_id)) {
          const lessonItem = {
            ...targetItem,
            unit_price: targetItem.price,
            order_id: order_id,
          }

          const found = courseRows.find(
            el => el[0].lesson_type === 'regular' && el[0].regular_id === targetItem.regular_id,
          )
          if (found) {
            found.push(lessonItem)
          } else {
            courseRows.push([lessonItem])
          }
        }
      })

      if (courseRows.length) {
        for (let i = 0; i < courseRows.length; i++) {
          courseRows[i].sort((a, b) => this.$formatter.sortDate(a.date, b.date))
          let newCourse = this.parseCourseTableData(courseRows[i][0], courseRows[i])
          if (i !== 0 && order_id !== -3) {
            if (order_id === -2 && this.enableSelectDropLesson) {
            } else {
              newCourse.readonly = true
            }
          }
          this.addItemToGroup(this.courseTableData, newCourse)
          if (order_id === -2) {
            this.courseSelectedRow.push({ id: newCourse.id })
          }
        }
      }
    },
    async generatePrevUnpaidPreview(excludeLessons = []) {
      // 攞今日或之前未比錢嘅lesson (order)
      try {
        const previewOrder = await this.$Fetcher.GenPrevUnpaidPreviewOrder(this.studentData.student_id)
        this.prevPreviewOrder = previewOrder
        // remove repeat lesson (if unpaid order / next month lesson exist)
        for (let i = this.prevPreviewOrder.lesson_list.length - 1; i >= 0; i--) {
          if (excludeLessons.includes(this.prevPreviewOrder.lesson_list[i].id)) {
            for (let y = this.prevPreviewOrder.lesson_datas.length - 1; y >= 0; y--) {
              if (this.prevPreviewOrder.lesson_datas[y].id === this.prevPreviewOrder.lesson_list[i].id) {
                this.prevPreviewOrder.lesson_datas.splice(y, 1)
                break
              }
            }
            this.prevPreviewOrder.lesson_list.splice(i, 1)
          }
        }
        this._groupPreviewOrder(-3, previewOrder)
      } catch (err) {
        this.$common.error(err)
        if (err === 'abort') {
          return false
        }
      }
      return true
    },
    async generateNextMonthPreview(excludeLessons = [], count = 0) {
      // 攞下個月order preview
      if (count < 3) {
        try {
          let centerId = -1
          if (this.gEnableRegularPeriod && !this.gDisableSettingByCenter) {
            centerId = await this.getSearchCenterId()
          }

          const add = count// + 1
          const previewOrder = await this.$Fetcher.GenNextMonthPreviewOrder(this.studentData.student_id, add, centerId)
          const check = this.$formatter.convertDate()
          check.setMonth(check.getMonth() + add)
          const findCheckMonthLesson = previewOrder.lesson_datas.find(el => {
            const date = this.$formatter.convertDate(el.date)
            return date.getFullYear() === check.getFullYear() && date.getMonth() === check.getMonth()
          })
          if (!findCheckMonthLesson && count < 2) {
            throw 'no lesson'
          }
          this.nextPreviewOrder = previewOrder
          // remove repeat lesson (if unpaid order exist)
          for (let i = this.nextPreviewOrder.lesson_list.length - 1; i >= 0; i--) {
            if (excludeLessons.includes(this.nextPreviewOrder.lesson_list[i].id)) {
              for (let y = this.nextPreviewOrder.lesson_datas.length - 1; y >= 0; y--) {
                if (this.nextPreviewOrder.lesson_datas[y].id === this.nextPreviewOrder.lesson_list[i].id) {
                  this.nextPreviewOrder.lesson_datas.splice(y, 1)
                  break
                }
              }
              this.nextPreviewOrder.lesson_list.splice(i, 1)
            }
          }
          this.nextPreviewOrderAdd = add
          this._groupPreviewOrder(-2, previewOrder)
        } catch (err) {
          this.$common.error(err)
          count += 1
          if (err === 'abort') {
            return false
          } else if (err === 'no lesson') {
            return this.generateNextMonthPreview(excludeLessons, count)
          }
        }
      }

      return true
    },
    async generateSkipLessonPreview() {
      if (this.isAppMode(['T01'])) return true

      try {
        const data = await this.$Fetcher.GetSkipToLessons(this.studentData.student_id)
        for (let i = 0; i < data.length; i++) {
          const newCourse = this.parseSkipToLessonData(data[i])
          this.addItemToGroup(this.courseTableData, newCourse)
        }
      } catch (err) {
        this.$common.error(err)
        if (err === 'abort') {
          return false
        }
      }

      return true
    },
    async getStudentOrders() {
      this.otherMonthPassLessonDates = []
      this.existMonthPass.tableData = []
      this.existMonthPass.limit = 5
      this.existMonthPass.page = 1
      this.existMonthPass.total = 0
      this.existMonthPass.allData = []
      this.unpaidTableData = []

      try {
        const { data } = await this.$Fetcher.GetOrders({
          filter_item: [{ key: 'student_id', value: this.studentData.student_id }],
        })

        // --------- 待付款/待審核訂單
        const excludeStatus = {
          paid: true,
          debit: true,
          cancelled: true,
          void: true,
        }
        const unpaidOrders = data.filter(item => !excludeStatus[item.status])
        const list = await this._getOrderPackages(unpaidOrders)
        this.unpaidTableData = list.map(el => {
          let item = this.gfParseOrderData(el)
          if (item.discount_type === 'percentage') {
            item.discount_value = 100 - item.discount_value
          }

          if (item.lesson_list) {
            for (let i = 0; i < item.lesson_list.length; i++) {
              if (item.lesson_list[i].discount_type === 'percentage') {
                item.lesson_list[i].discount_value = 100 - item.lesson_list[i].discount_value
              }
            }
          }

          if (item.product_list) {
            for (let i = 0; i < item.product_list.length; i++) {
              if (item.product_list[i].discount_type === 'percentage') {
                item.product_list[i].discount_value = 100 - item.product_list[i].discount_value
              }
            }
          }

          if (item.package_list) {
            for (let i = 0; i < item.package_list.length; i++) {
              if (item.package_list[i].discount_type === 'percentage') {
                item.package_list[i].discount_value = 100 - item.package_list[i].discount_value
              }
            }
          }
          return item
        })
        await this._getOrderCode()
        this.$common.logData(this.unpaidTableData, '待付款/待審核訂單')

        // --------- User 買咗月票嘅日子
        const { list: existMonthPassList, dates } = this.gfGetUserMonthPass(data)
        this.existMonthPass.allData = existMonthPassList
        this.otherMonthPassLessonDates = dates
        this.existMonthPass.total = this.existMonthPass.allData.length
        this._getExistMonthPassTableData()
        this.$common.logData(this.existMonthPass.allData, 'All 買咗月票嘅order')
        this.$common.logData(this.otherMonthPassLessonDates, 'User 買咗月票嘅日子')
      } catch (err) {
        this.$common.error(err)
        if (err === 'abort') {
          return false
        }
      }
      return true
    },
    _getOrderPackages(list) {
      return new Promise(async (resolve, reject) => {
        const noDataPackages = []

        list.forEach(item => {
          for (let i = 0; i < item.package_list.length; i++) {
            const found = item.package_datas.find(el => el.id === item.package_list[i].id)
            if (!found) {
              noDataPackages.push(item.package_list[i].id)
            }
          }
        })
        if (noDataPackages.length) {
          try {
            const data = await this.$Fetcher.GetPackagesByIdList(noDataPackages)
            list.forEach(item => {
              for (let i = 0; i < item.package_list.length; i++) {
                const found = item.package_datas.find(el => el.id === item.package_list[i].id)
                if (!found) {
                  const foundPackage = data.find(el => el.id === item.package_list[i].id)
                  if (foundPackage) {
                    item.package_datas.push(foundPackage)
                  }
                }
              }
            })
            resolve(list)
          } catch (err) {
            this.$common.error(err)
            if (err === 'abort') {
              reject(err)
            } else {
              resolve(list)
            }
          }
        } else {
          resolve(list)
        }
      })
    },
    async _getOrderCode(count = 0) {
      if (count < this.unpaidTableData.length) {
        const orderCode = await this.gfGenerateOrderId(this.unpaidTableData[count])
        if (orderCode !== 'abort') {
          this.$set(this.unpaidTableData[count], 'order_code', orderCode)
          count += 1
          await this._getOrderCode(count)
        }
      }
    },

    onTabChange() {
      if (this.currentTabType === 'course') {
        // -- handle course
        const { selectedRow: courseSelectedRow } = this._getUpdateSiblingTableData()
        this.courseSelectedRow = courseSelectedRow
      } else if (this.currentTabType === 'package') {
        // -- handle package
        const { selectedRow: packageSelectedRow } = this._getUpdateSiblingTableData()
        this.packageSelectedRow = packageSelectedRow
      } else if (this.currentTabType === 'month_pass') {
        // -- handle month pass
        const { selectedRow: monthPassSelectedRow } = this._getUpdateSiblingTableData()
        this.monthPassSelectedRow = monthPassSelectedRow
      }

      this.paymentItemTab = this.paymentTypeTab
      if (this.formData.is_redeem) {
        this._onUsePointSelected()
      }

      if (this._forcePaid()) {
        this.formData.status = 'paid'
      }
    },

    onUsePointChange() {
      if (this.formData.is_redeem) {
        this._onUsePointSelected()
      } else {
        if (this.currentTabType === 'course') {
          this.onCourseSelectedRowChanged()
        } else if (this.currentTabType === 'package') {
          this.onPackageSelectedRowChanged()
        } else if (this.currentTabType === 'month_pass') {
          this.onMonthPassSelectedRowChanged()
        }
      }
    },
    _onUsePointSelected() {
      this.courseSelectedRow = []
      this.packageSelectedRow = []
      this.monthPassSelectedRow = []
      this.productSelectedRow = this.productSelectedRow.filter(el => {
        const found = this.productTableData.find(elm => elm.id === el.id && elm.order_id === -1)
        return found
      })
      this.courseTableData.forEach(el => {
        el.disabled = true
      })
      this.packageTableData.forEach(el => {
        el.disabled = true
      })
      this.monthPassTableData.forEach(el => {
        el.disabled = true
      })
      this.productTableData.forEach(el => {
        if (el.order_id !== -1) {
          el.disabled = true
        }
      })
    },

    getUnitPrice(item) {
      return this.$validate.DataValid(item.discount_price) ? item.discount_price : item.unit_price
    },
    getDiscountPrice(price, discount_type, discount_value = 0) {
      // price after discount
      let p = 0
      if (this.$validate.regexFloating(price) && this.$validate.regexFloating(discount_value) && discount_type) {
        if (discount_type === 'percentage') {
          p = (parseFloat(price) * (100 - parseFloat(discount_value))) / 100
        } else if (discount_type === 'fix_amount') {
          p = parseFloat(price) - parseFloat(discount_value)
        }
        p = this.$formatter.formatMoney(p)

        if (p < 0) {
          p = 0
        }

        return p
      }

      return null
    },

    _getUpdateTableData(tableData, selectedRow) {
      let _tableData = JSON.parse(JSON.stringify(tableData))
      let _selectedRow = JSON.parse(JSON.stringify(selectedRow))
      _tableData.forEach(el => (el.disabled = false))

      let order_id = null
      for (let i = 0; i < _tableData.length; i++) {
        const item = _tableData[i]
        const pos = _selectedRow.findIndex(el => el.id === item.id)

        let toBreak = false
        if (pos > -1) {
          let possibleItems = _tableData.filter(el => el.order_id === item.order_id).map(el => el.id)
          let partners = []
          if (item.order_id === -4 || item.order_id === -5) {
            // 新增自訂項目/跳堂紀錄 selected
            partners = [-2, -1]
            if (item.order_id === -4) {
              partners = [-2, -1, -5]
              if (this.enableCombineNextAndUnpaid) {
                partners.push(-3)
              }
            } else if (item.order_id === -5) {
              partners = [-2, -1, -3, -4]
            }
            toBreak = true
          } else if (item.order_id === -3) {
            // 待付款項目 selected (可以分開揀)
            partners = [-5]
            if (this.enableCombineUnpaidAndNew) {
              partners.push(-1)
            }

            if (this.enableCombineNextAndUnpaid) {
              partners.push(-2)
              if (!this.enableCombineUnpaidAndNew && this.enableCombineNextAndNew) {
                partners.push(-1)
                partners.push(-4)
              }
            }
          } else if (item.order_id === -2) {
            partners = [-4, -5]
            if (this.enableCombineNextAndNew) {
              partners.push(-1)
            }

            if (this.enableCombineNextAndUnpaid) {
              partners.push(-3)
            }
            // 應付項目 selected (一定要揀曬)
            if (!this.enableSelectDropLesson) {
              // filter走唔係  應付項目 / 新增自訂項目 / 跳堂紀錄 嘅row
              if (order_id === item.order_id) {
                // parent 冇揀，remove selected
                _selectedRow.splice(pos, 1)
              } else {
                _selectedRow = _tableData.filter(el => {
                  let found = null
                  if (partners.includes(el.order_id)) {
                    found = _selectedRow.find(elm => elm.id === el.id)
                  }
                  return el.order_id === item.order_id || found
                })
                toBreak = true
              }
            }
          } else if (item.order_id === -1) {
            // 新增項目 selected (可以分開揀)
            // filter走唔係  新增項目 / 新增自訂項目 嘅row
            partners = [-4, -5]
            if (this.enableCombineNextAndNew) {
              partners.push(-2)
            }
            if (this.enableCombineUnpaidAndNew || (this.enableCombineNextAndUnpaid && this.enableCombineNextAndNew)) {
              partners.push(-3)
            }
            if (item.order_type === 'month_pass') {
              // 如果買月票，一定要揀曬
              if (order_id === item.order_id) {
                // parent 冇揀，remove selected
                _selectedRow.splice(pos, 1)
              } else {
                _selectedRow = _tableData.filter(el => {
                  let found = null
                  if (partners.includes(el.order_id)) {
                    found = _selectedRow.find(elm => elm.id === el.id)
                  }
                  return el.order_id === item.order_id || found
                })
                toBreak = true
              }
            } else {
              toBreak = true
            }
          } else if (item.order_id > -1) {
            // 待付款/待審核訂單 selected (一定要揀曬同一張order)
            if (order_id === item.order_id) {
              // parent 冇揀，remove selected
              _selectedRow.splice(pos, 1)
            } else {
              _selectedRow = _tableData.filter(el => el.order_id === item.order_id)
              toBreak = true
            }
          }

          if (partners.length > 0) {
            const foundPossibleItems = _tableData.filter(el => partners.includes(el.order_id)).map(el => el.id)
            possibleItems = [...possibleItems, ...foundPossibleItems]
          }
          _tableData.forEach(el => {
            if (!possibleItems.includes(el.id)) el.disabled = true
          })
          _selectedRow = _selectedRow.filter(el => possibleItems.includes(el.id))
        }

        if (order_id !== item.order_id) order_id = item.order_id
        if (toBreak) break
      }

      // 如果係更改訂單，唔比減走啲skip to lesson
      if (this.$validate.DataValid(this.orderId)) {
        _tableData.forEach(el => {
          if (el.order_id === -5) el.disabled = true
        })
      }

      return { tableData: _tableData, selectedRow: _selectedRow }
    },
    _getUpdateChildTableData(tableData, selectedRow, parentTableData, parentSelectedRow) {
      let _tableData = JSON.parse(JSON.stringify(tableData))
      let _selectedRow = JSON.parse(JSON.stringify(selectedRow))
      let _parentTableData = JSON.parse(JSON.stringify(parentTableData))
      let _parentSelectedRow = JSON.parse(JSON.stringify(parentSelectedRow))

      let selectedItem = _parentTableData.find(el => _parentSelectedRow[0] && el.id === _parentSelectedRow[0].id)
      if (!selectedItem) {
        selectedItem = _tableData.find(el => _selectedRow[0] && el.id === _selectedRow[0].id)
      }

      let possibleItems = []

      if (selectedItem) {
        possibleItems = _tableData.filter(el => el.order_id === selectedItem.order_id).map(el => el.id)
        let partners = []
        if (selectedItem.order_id === -4 || selectedItem.order_id === -5) {
          partners = [-2, -1]
          if (selectedItem.order_id === -4) {
            partners = [-2, -1, -5]
            if (this.enableCombineNextAndUnpaid) {
              partners.push(-3)
            }
          } else if (selectedItem.order_id === -5) {
            partners = [-2, -1, -3, -4]
          }
        } else if (selectedItem.order_id === -3) {
          partners = [-5]
          if (this.enableCombineUnpaidAndNew) {
            partners.push(-1)
          }
          if (this.enableCombineNextAndUnpaid) {
            partners.push(-2)

            if (!this.enableCombineUnpaidAndNew && this.enableCombineNextAndNew) {
              partners.push(-1)
              partners.push(-4)
            }
          }
        } else if (selectedItem.order_id === -2) {
          partners = [-4, -5]
          if (this.enableCombineNextAndNew) {
            partners.push(-1)
          }
          if (this.enableCombineNextAndUnpaid) {
            partners.push(-3)
          }
          const foundPossibleProductItems = _tableData
            .filter(el => el.order_id === -1 && el.order_type === 'product')
            .map(el => el.id)
          possibleItems = [...possibleItems, ...foundPossibleProductItems]

          if (!this.enableSelectDropLesson) {
            // selected 曬應付項目 & 揀咗嘅新增自訂項目 & 揀咗嘅new add product
            _selectedRow = _tableData.filter(el => {
              let found = null
              if (partners.includes(el.order_id) || (el.order_id === -1 && el.order_type === 'product')) {
                found = _selectedRow.find(elm => elm.id === el.id)
              }
              return el.order_id === selectedItem.order_id || found
            })
          }
        } else if (selectedItem.order_id === -1) {
          partners = [-4, -5]
          if (this.enableCombineNextAndNew) {
            partners.push(-2)
          }
          if (this.enableCombineUnpaidAndNew || (this.enableCombineNextAndUnpaid && this.enableCombineNextAndNew)) {
            partners.push(-3)
          }
          // 商品可以同下月應付同一張單
          if (selectedItem.order_type === 'product') {
            const foundPossibleNextItems = _tableData.filter(el => el.order_id === -2).map(el => el.id)
            possibleItems = [...possibleItems, ...foundPossibleNextItems]
          }
        } else if (selectedItem.order_id > -1) {
          // 如果parent有order而又冇揀，children都要unselect
          const foundParentSelected = _parentSelectedRow.find(el => {
            const found = _parentTableData.find(elm => elm.id === el.id)
            return found && found.order_id === selectedItem.order_id
          })
          if (!foundParentSelected) {
            _selectedRow = []
          } else {
            _selectedRow = _tableData.filter(el => el.order_id === selectedItem.order_id)
          }
        }

        if (partners.length > 0) {
          const foundPossibleItems = _tableData.filter(el => partners.includes(el.order_id)).map(el => el.id)
          possibleItems = [...possibleItems, ...foundPossibleItems]
        }
      } else {
        possibleItems = _tableData.map(el => el.id)
      }
      _selectedRow = _selectedRow.filter(el => possibleItems.includes(el.id))

      let { tableData: _childTableData, selectedRow: _childSelectedRow } = this._getUpdateTableData(
        _tableData,
        _selectedRow,
      )

      _childTableData.forEach(el => {
        if (!possibleItems.includes(el.id)) el.disabled = true
        if (this.$validate.DataValid(this.orderId) && el.order_id === -5) el.disabled = true
      })

      return { tableData: _childTableData, selectedRow: _childSelectedRow }
    },
    _getUpdateSiblingTableData() {
      const previousTab = this.paymentItemTab.substring('tab_'.length)
      let _tableData = []
      let _selectedRow = []
      let _mainTableData = []
      let _mainSelectedRow = []

      if (this.currentTabType === 'course') {
        _tableData = JSON.parse(JSON.stringify(this.courseTableData))
        _selectedRow = JSON.parse(JSON.stringify(this.courseSelectedRow))
      } else if (this.currentTabType === 'package') {
        _tableData = JSON.parse(JSON.stringify(this.packageTableData))
        _selectedRow = JSON.parse(JSON.stringify(this.packageSelectedRow))
      } else if (this.currentTabType === 'month_pass') {
        _tableData = JSON.parse(JSON.stringify(this.monthPassTableData))
        _selectedRow = JSON.parse(JSON.stringify(this.monthPassSelectedRow))
      }

      if (previousTab === 'course') {
        _mainTableData = JSON.parse(JSON.stringify(this.courseTableData))
        _mainSelectedRow = JSON.parse(JSON.stringify(this.courseSelectedRow))
      } else if (previousTab === 'package') {
        _mainTableData = JSON.parse(JSON.stringify(this.packageTableData))
        _mainSelectedRow = JSON.parse(JSON.stringify(this.packageSelectedRow))
      } else if (previousTab === 'month_pass') {
        _mainTableData = JSON.parse(JSON.stringify(this.monthPassTableData))
        _mainSelectedRow = JSON.parse(JSON.stringify(this.monthPassSelectedRow))
      }

      // -- handle new custom item, 睇下from table 有冇揀custom item
      let haveCustomSelect = false
      for (let i = 0; i < _mainSelectedRow.length; i++) {
        const found = _mainTableData.find(el => el.id === _mainSelectedRow[i].id)
        if (found && found.order_id === -4) {
          haveCustomSelect = true
          break
        }
      }
      // 如果有揀custom item，filter 走order_id != -1 && order_id != -2 && order_id != -4 && order_id != -5
      if (haveCustomSelect) {
        const partners = [-1, -2, -4, -5]
        if (this.enableCombineNextAndUnpaid) {
          partners.push(-3)
        }
        _selectedRow = _selectedRow.filter(selected =>
          _tableData.find(el => el.id === selected.id && partners.includes(el.order_id)),
        )
      }
      // filter 走冇揀嘅custom item
      for (let i = _selectedRow.length - 1; i >= 0; i--) {
        const found = _tableData.find(el => el.id === _selectedRow[i].id)
        if (found && found.order_id === -4) {
          const foundInMain = _mainSelectedRow.find(el => el.id === _selectedRow[i].id)
          if (!foundInMain) _selectedRow.splice(i, 1)
        }
      }
      // 加返冇揀嘅custom item落去
      for (let i = 0; i < _mainSelectedRow.length; i++) {
        const found = _mainTableData.find(el => el.id === _mainSelectedRow[i].id)
        if (found && found.order_id === -4) {
          const foundInSibling = _selectedRow.find(el => el.id === _mainSelectedRow[i].id)
          if (!foundInSibling) _selectedRow.push({ id: _mainSelectedRow[i].id })
        }
      }

      return { tableData: _tableData, selectedRow: _selectedRow }
    },

    getGroupBy(type) {
      let tableData = []
      if (type === 'course') {
        tableData = this.courseTableData
      } else if (type === 'package') {
        tableData = this.packageTableData
      } else if (type === 'product') {
        tableData = this.productTableData
      } else if (type === 'month_pass') {
        tableData = this.monthPassTableData
      }

      const groups = tableData.map(el => el.group)
      if (
        groups.includes('unpaid') ||
        groups.includes('nextMonth') ||
        groups.includes('order') ||
        groups.includes('custom') ||
        groups.includes('skip')
      ) {
        return 'group'
      }

      return null
    },
    addItemToGroup(list, item) {
      const _item = JSON.parse(JSON.stringify(item))
      if (_item.group !== 'custom') {
        const firstCustomIndex = list.findIndex(el => el.group === 'custom')
        if (firstCustomIndex > -1) {
          list.splice(firstCustomIndex, 0, _item)
          return
        }
      }
      const lastIndex = list.findLastIndex(el => el.group === _item.group)
      if (lastIndex > -1) {
        list.splice(lastIndex + 1, 0, _item)
      } else {
        list.push(_item)
      }
    },

    getSearchCenterId() {
      const selectedSchool = this.gfGetUserSelectedSchool()
      if (selectedSchool > -1) {
        return selectedSchool
      } else if (this.$validate.DataValid(this.studentData.schools)) {
        return this.studentData.schools[0]
      }

      return -1
    },

    _forcePaid() {
      // if(this.isAppMode(['UAT','T50'])){
      //   return false;
      // }
      // if (this.currentTabType === 'course') {
      //   // 如果揀嘅lesson係待付款嘅lesson
      //   const foundUnpaid = this.courseSelectedRow.find(el => {
      //     const found = this.courseTableData.find(elm => elm.id === el.id)
      //     return found && found.order_id === -3
      //   })
      //   if (foundUnpaid) return true
      // } else if (this.currentTabType === 'package') {
      //   // 如果揀嘅package有包埋未付款lesson
      //   let includedUnpaid = false
      //   const unpaidLessonIds = this.allUnpaidLessonDataStatic.map(el => el.id)
      //   for (let i = 0; i < this.packageSelectedRow.length; i++) {
      //     const found = this.packageTableData.find(el => el.id === this.packageSelectedRow[i].id)
      //     if (found) {
      //       for (let j = 0; j < found.selected_lesson_id_list.length; j++) {
      //         if (unpaidLessonIds.includes(found.selected_lesson_id_list[j])) {
      //           includedUnpaid = true
      //           break
      //         }
      //       }
      //     }

      //     if (includedUnpaid) break
      //   }

      //   if (includedUnpaid) return true
      // }

      return false
    },

    // -- (兄弟姊妹 - 繳交學費)
    async navSiblingPayment(id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      if (!this.gDisableStudentCenter) {
        try {
          const student = await this.$Fetcher.GetStudentById(id)
          const selectedSchool = this.gfGetUserSelectedSchool()
          if (
            selectedSchool > -1 &&
            student.schools.length > 0 &&
            !student.schools.includes(-1) &&
            !student.schools.includes(selectedSchool)
          ) {
            this.$store.dispatch('setLoading', true)
            this.changeCenterAlert.studentName = student.student_name
            if (student.schools.length === 1) {
              const centerName = await this._getCenterName(student.schools[0])
              this.$store.dispatch('setLoading', false)

              const confirm = await this.confirmRef.show({
                message: this.$t('message.confirmChangeCenter', {
                  name: student.student_name,
                  center: centerName,
                }),
              })
              if (confirm) {
                const adminSchools = this.gfGetUserSchools()
                if (!adminSchools.includes(student.schools[0])) {
                  this.showAlert({
                    title: '',
                    message: 'message.adminNotBelongsCenter',
                    isError: true,
                  })
                  return
                } else {
                  this.gfExpiredSettingLogo()
                  this.gfUpdateUserSelectedSchool(student.schools[0])
                }
              } else {
                return
              }
            } else {
              this.changeCenterAlert.centerOptions = []
              const centers = await this.$Fetcher.GetSchoolsByIdList(student.schools)
              for (let i = 0; i < student.schools.length; i++) {
                const found = centers.find(el => el.id === student.schools[i])
                if (found) {
                  this.changeCenterAlert.centerOptions.push({ value: student.schools[i], text: found.name })
                }
              }
              this._handleNavSchool(id)
              this.changeCenterAlert.schoolId = student.schools[0]
              this.$store.dispatch('setLoading', false)
              return
            }
          }
        } catch {}
      }

      this.$router.push({ name: 'PayTuitionPayment', params: { id } })
    },
    async _getCenterName(school_id) {
      try {
        const data = await this.$Fetcher.GetSchoolById(school_id)
        return data.name
      } catch {
        return ''
      }
    },
    async _handleNavSchool(studentId) {
      this.$refs.confirmChangeCenterMulti.setLoading(false)
      const confirm = await this.$refs.confirmChangeCenterMulti.show()
      if (confirm) {
        if (this.$validate.DataValid(this.changeCenterAlert.schoolId) && this.changeCenterAlert.schoolId > -1) {
          const adminSchools = this.gfGetUserSchools()
          if (!adminSchools.includes(this.changeCenterAlert.schoolId)) {
            this.showAlert({
              title: '',
              message: 'message.adminNotBelongsCenter',
              isError: true,
            })
            this._handleNavSchool(studentId)
            return
          } else {
            this.gfUpdateUserSelectedSchool(this.changeCenterAlert.schoolId)
          }
          this.$refs.confirmChangeCenterMulti.hide()

          this.gfExpiredSettingLogo()
          if (studentId === this.id) {
            this.$router.go()
          } else {
            this.$router.push({ name: 'PayTuitionPayment', params: { id: studentId } })
          }
        } else {
          this.$refs.confirmChangeCenterMulti.hide()
        }
      }
    },

    // -- Discount related
    onDiscountMethodChanged() {
      this.formData.discount_type = ''
      this.formData.discount_value = ''
      this.formData.discount_coupon_code = null
      this.appliedCoupon = null
      if (this.formData.discount_method === 'code') {
        this.searchCoupons()
      }
    },
    async searchCoupons(keyword = '') {
      this.couponSearching = true
      try {
        const data = await this.$Fetcher.GetCouponsByUser(this.id)
        let filteredData = [...data]
        if (keyword) {
          filteredData = data.filter(el => el.code.toLowerCase().indexOf(keyword.trim().toLowerCase()) > -1)
        }
        this.couponOptions = filteredData.map(el => {
          return { value: el.code, text: `${el.name} (${el.code})` }
        })
      } catch {
        this.couponOptions = []
      }

      this.couponSearching = false
    },
    async onCouponChanged() {
      this.formData.discount_type = ''
      this.formData.discount_value = ''
      this.appliedCoupon = null

      if (this.$validate.DataValid(this.formData.discount_coupon_code)) {
        this.couponSearching = true
        try {
          const data = await this.$Fetcher.CheckCoupon({
            code: this.formData.discount_coupon_code,
            student_id: this.id,
            center_id: -1,
          })
          this.formData.discount_type = data.discount_type
          if (data.discount_type === 'percentage') {
            this.formData.discount_value = 100 - data.discount_value
          } else {
            this.formData.discount_value = data.discount_value
          }
          this.appliedCoupon = data
        } catch (err) {
          this.$common.error(err)
          this.$store.dispatch('toggleSnack', { message: err, type: 'error' })
        }
        this.couponSearching = false
      }
    },

    // ============= 搜尋 ==============
    async openAddSearchDialog(type) {
      if (this.$store.getters.isLoading) return
      // -- reset table
      this.searchFilter.page = 1
      this.searchTableTotal = 0
      this.searchTableData = []
      this.searchFilter.keyword = ''
      this.tempSelectedLesson = []

      // -- reset course search
      this.addCourseFilter.type = 'weekday'
      this.clearAddCourseFilter()

      // -- reset package search
      this.tempSelectedPackage = null

      // -- reset month pass search
      this.tempSelectedMonthPass = null

      // -- open dialog
      if (type === 'course') {
        this.searchTableData = []
        this.openSearchCourse()
      } else if (type === 'product') {
        this.$refs.addProductDialog.show('search_product')
        this.searchProducts()
      } else if (type === 'package') {
        this.$refs.addPackageDialog.show('search_package')
        this.isSearching = true
        this.searchTableData = []

        await this.getStudentRemainLessonCount()
        this.searchPackages()
      } else if (type === 'month_pass') {
        this.addCourseFilter.type = 'singleDate' // 月票可以任揀月票期限內嘅lesson
        this.$refs.addMonthPassDialog.show('search_month_pass')
        this.isSearching = true
        this.searchTableData = []
        this.searchMonthPasses()
      }
    },

    async openSearchCourse() {
      this.isSearching = true
      this.$refs.addCourseDialog.show('search_lesson')

      if (this.tutorOptions.length < 1) {
        await this._getTutorOptions()
      }
      this._getCourseNameOption()
      this.searchCourses()
    },
    async _getCourseNameOption() {
      if (this.courseNameOptions.length < 1 && !this.courseNameSearching) {
        this.courseNameSearching = true
        const centerId = await this.getSearchCenterId()
        this.courseNameOptions = await this.$Fetcher.GetAllCourseNames(centerId)
        this.courseNameSearching = false
      }
    },
    async _getTutorOptions() {
      try {
        let payload = {}
        const centerId = await this.getSearchCenterId()
        if (centerId > -1) {
          payload['center'] = [centerId]
        }
        const { data } = await this.$Fetcher.GetStaffs(payload)
        this.tutorOptions = data.map(el => {
          return {
            value: el.id,
            text: el.name,
          }
        })
        this.tutorOptions.unshift({ value: -1, text: this.$t('allTutors') })
      } catch {}
    },
    isItemSelected(id) {
      if (
        this.currentTabType === 'package' ||
        (this.currentTabType === 'course' && this.addCourseFilter.type === 'singleDate') ||
        this.currentTabType === 'month_pass' ||
        this.currentTabType === 'assign_month_pass'
      ) {
        const found = this.searchTableSelectedRow.find(elm => elm.id === id)
        if (found) return true
      }
      return false
    },
    onSearchTableOptionsChange() {
      const courseOpen = this.$refs.addCourseDialog.isOpen()
      const packageOpen = this.$refs.addPackageDialog.isOpen()
      const productOpen = this.$refs.addProductDialog.isOpen()
      const monthPassOpen = this.$refs.addMonthPassDialog.isOpen()
      if (courseOpen) {
        this.searchCourses()
      } else if (packageOpen) {
        this.searchPackages()
      } else if (productOpen) {
        this.searchProducts()
      } else if (monthPassOpen) {
        this.searchMonthPasses()
      }
    },

    // =========== 修改項目資料 ===========
    // -- (mini action: Edit)
    async handleEditItem(id, type, newOpen = true) {
      if (newOpen) {
        if (this.$store.getters.isLoading || type === 'online_course') return

        // reset data
        this.editItemData.type = type
        this.editItemData.discount_type = ''
        this.editItemData.discount_value = ''
        this.editItemData.original_price = 0
        this.editItemData.selectedRow = []
        this.editTableData = []
        this.$refs.editFormDialog.setInfo(id)

        let target = null
        if (type === 'course') {
          target = this.courseTableData.find(el => el.id === id)
          if (target) {
            this.$common.logData(target, '修改項目資料 (課程)')
            if (target.order_type === 'skip') {
              return
            } else if (target.order_type === 'custom') {
              this.handleAddCustomItem(id)
              return
            } else if (this.$validate.DataValid(target.lesson_data_list)) {
              this.editTableData = target.lesson_data_list.map(lessonData => {
                return {
                  id: lessonData.id,
                  date: lessonData.date,
                  start_time: lessonData.start_time,
                  end_time: lessonData.end_time,
                  trial: target.trial_lesson_ids.includes(lessonData.id),
                  order_id: target.order_id,
                }
              })
              this.editItemData.selectedRow = this.editTableData.filter(el =>
                (target.selected_lesson_id_list || []).includes(el.id),
              )
            }
          }
        } else if (type === 'product') {
          // -- Edit product item
          target = this.productTableData.find(el => el.id === id)
          if (target) {
            this.$common.logData(target, '修改項目資料 (商品)')
            const inventory = await this._getUpdatedProductInventory(target.product_id)
            // -- edit product table data
            this.editTableData = [
              {
                id: target.id,
                item_name: target.item_name,
                qty: target.qty,
                inventory: inventory,
              },
            ]
          }
        } else if (type === 'package') {
          target = this.packageTableData.find(el => el.id === id)
          if (target) {
            this.$common.logData(target, '修改項目資料 (套票)')

            if (target.order_type === 'custom') {
              this.handleAddCustomItem(id)
              return
            } else if (this.$validate.DataValid(target.lesson_data_list)) {
              this.editTableData = target.lesson_data_list.map(lessonData => {
                return {
                  id: lessonData.id,
                  course_name: lessonData.course_name,
                  date: lessonData.date,
                  start_time: lessonData.start_time,
                  end_time: lessonData.end_time,
                }
              })
            }
          }
        } else if (type === 'month_pass') {
          target = this.monthPassTableData.find(el => el.id === id)
          if (target) {
            this.$common.logData(target, '修改項目資料 (月票)')

            if (target.order_type === 'custom') {
              this.handleAddCustomItem(id)
              return
            } else if (this.$validate.DataValid(target.lesson_data_list)) {
              this.editTableData = target.lesson_data_list.map(lessonData => {
                return {
                  id: lessonData.id,
                  course_name: lessonData.course_name,
                  date: lessonData.date,
                  start_time: lessonData.start_time,
                  end_time: lessonData.end_time,
                }
              })
            }
          }
        } else if (type === 'assign_month_pass') {
          target = this.assignLessonTableData.find(el => el.id === id)
          if (this.$validate.DataValid(target.lesson_data_list)) {
            this.editTableData = target.lesson_data_list.map(lessonData => {
              return {
                id: lessonData.id,
                date: lessonData.date,
                start_time: lessonData.start_time,
                end_time: lessonData.end_time,
              }
            })
            this.editItemData.selectedRow = this.editTableData.filter(el =>
              (target.selected_lesson_id_list || []).includes(el.id),
            )
          }
        }

        // set price details
        if (target) {
          if (this.$validate.regexFloating(target.unit_price)) {
            this.editItemData.original_price = parseFloat(target.unit_price)
          }

          if (this.$validate.DataValid(target.discount_type)) {
            this.editItemData.discount_type = target.discount_type

            if (this.$validate.regexFloating(target.discount_value)) {
              this.editItemData.discount_value = target.discount_value
            }
          }
        } else {
          return
        }
      } else {
        this.$refs.editFormDialog.setLoading(false)
      }

      const confirm = await this.$refs.editFormDialog.show()
      if (confirm) {
        let target = null
        if (type === 'course') {
          if (this.editItemData.selectedRow.length < 1) {
            this.showAlert({
              title: 'message.operationalError',
              message: 'message.atLeastOneLesson',
              isError: true,
            })
            this.handleEditItem(id, type, false)
            return
          }
          target = this.courseTableData.find(el => el.id === id)
        } else if (type === 'product') {
          target = this.productTableData.find(el => el.id === id)
          const newUpdate = this.editTableData.find(el => el.id === id)
          if (newUpdate && target) {
            target.qty = newUpdate.qty
          }
        } else if (type === 'package') {
          target = this.packageTableData.find(el => el.id === id)
        } else if (type === 'month_pass') {
          target = this.monthPassTableData.find(el => el.id === id)
        } else if (type === 'assign_month_pass') {
          if (this.editItemData.selectedRow.length < 1) {
            this.showAlert({
              title: 'message.operationalError',
              message: 'message.atLeastOneLesson',
              isError: true,
            })
            this.handleEditItem(id, type, false)
            return
          }
          target = this.assignLessonTableData.find(el => el.id === id)
        }

        if (target) {
          // - update selected date class
          if (type === 'course' || type === 'assign_month_pass') {
            target.selected_lesson_id_list = this.editItemData.selectedRow.map(el => el.id)
            target.dates = this.editItemData.selectedRow.map(el => el.date)
            // #bug
            // target.lesson_prices = this.editItemData.selectedRow.map(el => el.price)
            target.qty = target.selected_lesson_id_list.length
            let monthLabels = []
            target.dates.forEach(date => {
              const label = `${date.substring(0, 4)}/${date.substring(5, 7)}`
              if (!monthLabels.includes(label)) {
                monthLabels.push(label)
              }
            })
            target.month_label = monthLabels.join('\n')

            if (type === 'course') {
              target.trial_lesson_ids = this.editTableData.filter(el => el.trial).map(el => el.id)
            }
          }

          if (type !== 'assign_month_pass') {
            target.discount_type = this.editItemData.discount_type
            target.discount_value =
              this.editItemData.discount_type && this.$validate.regexFloating(this.editItemData.discount_value)
                ? parseFloat(this.editItemData.discount_value)
                : null
            target.discount_price = this.editDiscountPrice
            // #bug
            target.total = this.$formatter.formatMoney(this.getUnitPrice(target) * target.qty)
          }
        }

        this.$refs.editFormDialog.hide()
      }
    },
    _getUpdatedProductInventory(id) {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await this.$Fetcher.GetProductById(id)
          let inventory = data.inventory
          if (this.$validate.DataValid(this.orderId)) {
            // release返個qty出黎
            const found = this.orderData.product_list.find(el => el.id === id)
            if (found) {
              inventory += found.amount
            }
          }
          resolve(inventory)
        } catch {
          resolve(0)
        }
      })
    },

    // -- (mini action: Delete)
    async handleDeleteAction(delete_id, type) {
      let alertConfirm = false
      if (!this.isAppMode(['T01'])) {
        if (type === 'course' || type === 'package' || type === 'month_pass') {
          if (this.$validate.DataValid(this.orderId)) {
            alertConfirm = true
          } else {
            if (!this.enableSelectDropLesson && type === 'course') {
              const found = this.courseTableData.find(el => el.id === delete_id)
              if (found.order_id === -2) {
                alertConfirm = true
              }
            }
          }
        }
      }

      let confirmObj = {}
      if (alertConfirm) {
        confirmObj = {
          message: 'message.deleteOrderLessonWithRemove',
          enableShowRemindCheckbox: true,
          key: 'deleteWithRemove',
        }
      } else {
        confirmObj = {
          isDelete: true,
          enableShowRemindCheckbox: true,
          key: 'deleteItem',
        }
      }
      const confirm = await this.confirmRef.show(confirmObj)
      if (confirm) {
        if (type === 'product') {
          const { tableData, selectedRow } = this._deleteRow(this.productTableData, this.productSelectedRow, delete_id)
          this.productTableData = tableData
          this.productSelectedRow = selectedRow
        } else if (type === 'assign_month_pass') {
          const { tableData, selectedRow } = this._deleteRow(
            this.assignLessonTableData,
            this.assignLessonSelectedRow,
            delete_id,
          )
          this.assignLessonTableData = tableData
          this.assignLessonSelectedRow = selectedRow
        } else {
          const { tableData, selectedRow } = this._deleteRow(this.courseTableData, this.courseSelectedRow, delete_id)
          this.courseTableData = tableData
          this.courseSelectedRow = selectedRow

          const { tableData: packageTableData, selectedRow: packageSelectedRow } = this._deleteRow(
            this.packageTableData,
            this.packageSelectedRow,
            delete_id,
          )
          this.packageTableData = packageTableData
          this.packageSelectedRow = packageSelectedRow

          let { tableData: monthPassTableData, selectedRow: monthPassSelectedRow } = this._deleteRow(
            this.monthPassTableData,
            this.monthPassSelectedRow,
            delete_id,
          )
          // 重新分配過曬啲date & reset start end date
          const found = this.monthPassTableData.find(el => el.id === delete_id)
          if (found && found.order_type === 'month_pass' && found.order_id === -1) {
            this.monthPassTableData = monthPassTableData
            this.monthPassSelectedRow = monthPassSelectedRow

            const newMonthPassItems = this.monthPassTableData.filter(
              el => el.order_type === 'month_pass' && el.order_id === -1,
            )
            let allSelectedLessons = []
            for (let i = 0; i < newMonthPassItems.length; i++) {
              allSelectedLessons = allSelectedLessons.concat(newMonthPassItems[i].lesson_data_list)
            }
            this._reallocateMonthPassLessons(allSelectedLessons)
            this._resetMonthPassRowDeleteBtn()
          } else {
            this.monthPassTableData = monthPassTableData
            this.monthPassSelectedRow = monthPassSelectedRow
          }
        }
      }
    },
    _deleteRow(tableData, selectedRow, delete_id) {
      const _tableData = JSON.parse(JSON.stringify(tableData))
      const _selectedRow = JSON.parse(JSON.stringify(selectedRow))

      const targetPos = _tableData.findIndex(el => el.id === delete_id)
      if (targetPos > -1) {
        if (
          (_tableData[targetPos].order_id !== -1 || _tableData[targetPos].order_type === 'month_pass') &&
          _tableData[targetPos + 1] &&
          _tableData[targetPos + 1].order_id === _tableData[targetPos].order_id &&
          !_tableData[targetPos].readonly &&
          _tableData[targetPos + 1].readonly
        ) {
          _tableData[targetPos + 1].readonly = false
        }
        _tableData.splice(targetPos, 1)
      }

      const targetSelectedPos = _selectedRow.findIndex(el => el.id === delete_id)
      if (targetSelectedPos > -1) _selectedRow.splice(targetSelectedPos, 1)

      return { tableData: _tableData, selectedRow: _selectedRow }
    },

    // -- (選擇課堂)
    openEditLesson(type) {
      switch (type) {
        case 'month_pass':
          this._openMonthPassEditLesson()
          break
        case 'package':
          this._openPackageEditLesson()
          break
      }
    },

    // ========= Course Related =========
    parseCourseTableData(item, lessonData = [], isSingleLesson = false, isNew = true) {
      this.rowId += 1

      let valid_lessons = JSON.parse(JSON.stringify(lessonData))
      if (!this.$validate.DataValid(item.order_id) && (!this.$validate.DataValid(this.orderId) || isNew)) {
        const selectedDate = this.$formatter.convertDate(item.date)
        let dateMin = this.$formatter.convertDate()
        if (this.$validate.isDateLess(selectedDate, dateMin)) {
          dateMin = this.$formatter.convertDate(item.date)
        }
        valid_lessons = valid_lessons.filter(el => {
          if (el.id === item.id || isSingleLesson) {
            return true
          } else {
            // --- filter 走過咗期嘅lesson, 而又係揀咗個堂之前嘅堂
            const date = this.$formatter.convertDate(el.date)
            return !this.$validate.isDateLess(date, dateMin)
          }
        })
      }

      let monthLabels = []
      valid_lessons.forEach(el => {
        const label = `${el.date.substring(0, 4)}/${el.date.substring(5, 7)}`
        if (!monthLabels.includes(label)) {
          monthLabels.push(label)
        }
      })

      let group = 'new'
      if (this.$validate.DataValid(item.order_id)) {
        if (item.order_id === -3) {
          group = 'unpaid'
        } else if (item.order_id === -2) {
          group = 'nextMonth'
        }
      }

      let _item = { ...item }
      _item['discount_price'] = this.getDiscountPrice(item.unit_price, item.discount_type, item.discount_value)

      return {
        id: this.rowId,
        course_name: _item.course_name,
        lesson_type: _item.lesson_type,
        lesson_data_list: lessonData,
        // lessons_price2: valid_lessons.map(el => el.price),
        selected_lesson_id_list: valid_lessons.map(el => el.id),
        month_label: monthLabels.join('\n'),
        dates: valid_lessons.map(el => el.date),
        unit_price: _item.unit_price,
        qty: valid_lessons.length,
        total: this.$formatter.formatMoney(this.getUnitPrice(_item) * valid_lessons.length),
        discount_type: _item.discount_type || '',
        discount_value: _item.discount_value || null,
        discount_price: _item.discount_price || null,
        order_id: this.$validate.DataValid(_item.order_id) ? _item.order_id : -1,
        is_single_lesson: isSingleLesson,
        group: group,
        order_type: 'course',
        trial_lesson_ids: [],
      }
    },
    parseSkipToLessonData(lesson) {
      this.rowId += 1
      return {
        id: this.rowId,
        course_name: lesson.course_name,
        lesson_type: lesson.lesson_type,
        lesson_data_list: [lesson],
        selected_lesson_id_list: [lesson.id],
        month_label: `${lesson.date.substring(0, 4)}/${lesson.date.substring(5, 7)}`,
        dates: [lesson.date],
        unit_price: 0,
        qty: 1,
        total: 0,
        discount_type: '',
        discount_value: null,
        discount_price: null,
        order_id: -5,
        is_single_lesson: true,
        group: 'skip',
        order_type: 'skip',
      }
    },

    onCourseSelectedRowChanged() {
      const { tableData, selectedRow } = this._getUpdateTableData(this.courseTableData, this.courseSelectedRow)
      this.courseTableData = tableData
      this.courseSelectedRow = selectedRow

      // -- handle product
      const { tableData: productTableData, selectedRow: productSelectedRow } = this._getUpdateChildTableData(
        this.productTableData,
        this.productSelectedRow,
        this.courseTableData,
        this.courseSelectedRow,
      )
      this.productTableData = productTableData
      this.productSelectedRow = productSelectedRow

      if (this._forcePaid()) {
        this.formData.status = 'paid'
      }
      if (this.formData.is_redeem) {
        this._onUsePointSelected()
      }
    },

    // -- 報讀新課程
    async searchCourses() {
      this.isSearching = true
      this.searchTableData = []

      let payload = {
        controller_name: 'search_lesson',
        filter_page: this.searchFilter.page - 1,
        filter_limit: this.searchFilter.limit,
        join_tutor_data: true,
        filter_item: [],
      }
      const centerId = await this.getSearchCenterId()
      if (centerId > -1) payload['center_id'] = centerId

      const startDate = this.$formatter.convertDate()
      if (this.isAppMode(['T11', 'T17'])) {
        // 可以揀當月過咗期嘅lesson
        startDate.setDate(1)
      } else if (this.isAppMode(['T14'])) {
        // 可以攞一個月前嘅lesson
        startDate.setDate(1)
        startDate.setMonth(startDate.getMonth() - 1)
      }
      payload['filter_item'].push({ key: 'start_date', value: this.$formatter.formatDate(startDate) })

      if (this.$validate.DataValid(this.addCourseFilter.keyword)) {
        payload['filter_item'].push({ key: 'course_name', value: this.addCourseFilter.keyword })
      }
      if (this.$validate.DataValid(this.addCourseFilter.tutor) && this.addCourseFilter.tutor > -1) {
        payload['filter_item'].push({ key: 'staff_id', value: this.addCourseFilter.tutor })
      }
      if (this.$validate.DataValid(this.addCourseFilter.grade) && this.addCourseFilter.grade !== 'all') {
        payload['filter_item'].push({ key: 'grade', value: this.addCourseFilter.grade })
      }
      if (this.addCourseFilter.type === 'weekday') {
        // 套票available change from t37
        // payload['filter_item'].push({ key: 'lesson_type', value: 'regular' })
        if (this.$validate.DataValid(this.addCourseFilter.weekdays, true)) {
          const weekdays = this.addCourseFilter.weekdays.map(el => parseInt(el))
          payload['filter_item'].push({ key: 'weekdays', value: weekdays })
        }
      }
      if (this.$validate.DataValid(this.addCourseFilter.dateRange, true) && this.addCourseFilter.dateRange[0]) {
        const foundPos = payload.filter_item.findIndex(el => el.key === 'start_date')
        if (
          this.addCourseFilter.dateRange.length > 1 &&
          this.addCourseFilter.dateRange[1] &&
          this.addCourseFilter.dateRange[1] !== this.addCourseFilter.dateRange[0]
        ) {
          payload['filter_item'][foundPos].value = this.addCourseFilter.dateRange[0]
          payload['filter_item'].push({ key: 'end_date', value: this.addCourseFilter.dateRange[1] })
        } else {
          payload['filter_item'].splice(foundPos, 1)
          payload['filter_item'].push({ key: 'date', value: this.addCourseFilter.dateRange[0] })
        }
      }

      try {
        const { data, total } = await this.$Fetcher.GetLessons(payload)
        this.searchTableTotal = total
        this.searchTableData = data.map(el => {
          let selected = false
          let tableData = []
          if (this.currentTabType === 'course') {
            tableData = this.courseTableData
          } else if (this.enableMultiPackage && this.currentTabType === 'package') {
            tableData = this.packageTableData

            const rowId = this.$refs.editFormDialog.getInfo()
            if (this.$validate.DataValid(rowId)) {
              tableData = this.packageTableData.filter(row => row.id !== rowId)
            }
          } else if (this.currentTabType === 'assign_month_pass') {
            tableData = this.assignLessonTableData
          }
          for (let i = 0; i < tableData.length; i++) {
            if (
              this.$validate.DataValid(tableData[i].selected_lesson_id_list) &&
              tableData[i].selected_lesson_id_list.includes(el.id)
            ) {
              selected = true
              break
            }
          }

          let disabled = false
          let temp_disabled = false
          let applied = el.student_ids.includes(this.id)
          if (this.currentTabType === 'month_pass' && this.tempSelectedMonthPass) {
            if (this.searchTableSelectedRow.length) {
              let start = ''
              if (this.tempSelectedMonthPass.type === 'months') {
                if (this.addCourseFilter.selectedMonth) {
                  start = `${this.addCourseFilter.selectedMonth}-01`
                }
              } else {
                start = this.searchTableSelectedRow[0].date
              }
              const { min, max } = this._getMonthPassMinMaxDate(this.tempSelectedMonthPass, start)
              if (min && max) {
                const minDate = this.$formatter.convertDate(min)
                const maxDate = this.$formatter.convertDate(max)

                if (this.$validate.isDateLess(this.$formatter.convertDate(el.date), minDate)) {
                  if (this.$validate.DataValid(this.orderId) && this.tempSelectedMonthPass.type === 'months') {
                    disabled = true
                  } else {
                    temp_disabled = true
                  }
                }

                if (this.$validate.isDateGreater(this.$formatter.convertDate(el.date), maxDate)) {
                  if (this.$validate.DataValid(this.orderId) && this.tempSelectedMonthPass.type === 'months') {
                    disabled = true
                  } else {
                    temp_disabled = true
                  }
                }
              }
            }
          } else if (this.currentTabType === 'assign_month_pass') {
            if (!this.otherMonthPassLessonDates.includes(el.date)) {
              disabled = true
            }
          }

          if (this.$validate.DataValid(this.orderId)) {
            const foundLessonInOrder = this.orderData.lesson_list.find(item => item.id === el.id)
            if (foundLessonInOrder) {
              applied = false
            }
          }

          return {
            id: el.id, // lesson id
            lesson_type: el.lesson_type,
            course_id: el.course_id,
            regular_id: el.regular_id,
            course_name: el.course_name,
            course_code: el.course_code,
            date: el.date,
            start_time: el.start_time,
            end_time: el.end_time,
            grade: el.grade,
            tutor: el.tutor_data_list.map(t => t.name).join(', '),
            current_student_num: el.current_student_num,
            max_student: el.max_student,
            unit_price: el.price,
            selected: selected,
            applied: applied,
            unavailable: this.currentTabType === 'month_pass' && this.otherMonthPassLessonDates.includes(el.date),
            disabled: disabled,
            temp_disabled: temp_disabled,
          }
        })
      } catch (err) {
        this.$common.error(err)
        this.searchTableData = []
        if (this.searchFilter.page === 1) {
          this.searchTableTotal = 0
        }
      } finally {
        this.isSearching = false
        this.$common.logData(this.searchTableData, 'searchTableData')
      }
    },
    clearAddCourseFilter() {
      this.addCourseFilter.weekdays = []
      this.addCourseFilter.dateRange = []
      this.addCourseFilter.keyword = ''
      this.addCourseFilter.tutor = null
      this.addCourseFilter.grade = ''
      this.addCourseFilter.packageLessonRule = 'auto'
      this.searchFilter.page = 1
      this.searchTableTotal = 0
      this.searchTableData = []
      this.searchTableSelectedRow = []
    },
    onCourseFilterChange(event) {
      const courseOpen = this.$refs.addCourseDialog.isOpen()
      if (courseOpen) {
        if (event) {
          if (event.key === 'lesson_type') {
            this.clearAddCourseFilter()
          }
          this.searchFilter.page = 1
          this.searchTableTotal = 0
        }
        this.searchCourses()
      }
    },

    handleAddCourseActionClick(action) {
      if (action === true) {
        if (this.currentTabType === 'course' && this.addCourseFilter.type === 'singleDate') {
          this.handleSingleLessonConfirm()
        } else if (this.currentTabType === 'package') {
          this.handlePackageLessonConfirm(false)
        } else if (this.currentTabType === 'month_pass') {
          this.handleMonthPassLessonConfirm()
        } else if (this.currentTabType === 'assign_month_pass') {
          this.handleAssignLessonConfirm()
        }
      } else if (action === false) {
        if (this.currentTabType === 'package') {
          this.handlePackageLessonConfirm(true)
        } else if (this.currentTabType === 'month_pass') {
          this.handleMonthPassLessonConfirm(true)
        }
      }
    },

    // -- (刪除)
    handleSelectedRowCancel(id) {
      if (this.currentTabType === 'package') {
        this.handlePackageLessonSelected(id)
      } else if (this.currentTabType === 'course' && this.addCourseFilter.type === 'singleDate') {
        const foundPos = this.searchTableSelectedRow.findIndex(el => el.id === id)
        if (foundPos > -1) {
          this.searchTableSelectedRow.splice(foundPos, 1)
        }
        this.tempSelectedLesson = JSON.parse(JSON.stringify(this.searchTableSelectedRow))
      } else if (this.currentTabType === 'month_pass') {
        this.handleMonthPassLessonSelected(id)
      } else if (this.currentTabType === 'assign_month_pass') {
        this.handleAssignLessonSelected(id)
      }
    },

    // -- (報名)
    async handleAddNewCourse(lesson_id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const targetLesson = this.searchTableData.find(el => el.id === lesson_id)
      this.$common.logData(targetLesson, '報讀新課程')
      if (this.$validate.DataValid(targetLesson)) {
        // -- 已經applied咗，reject
        if (targetLesson.applied) {
          this.$store.dispatch('toggleSnack', { message: 'message.lessonRepeat', type: 'error' })
          return
        }
        // -- 已達人數上限，remind
        if (targetLesson.max_student > -1 && targetLesson.current_student_num >= targetLesson.max_student) {
          const confirm = await this.confirmRef.show({
            title: 'message.confirmToApplyCourse',
            message: 'message.reachedUpperLimitConfirmApply',
            enableShowRemindCheckbox: true,
            key: 'exceedStudent',
          })
          if (!confirm) return
        }

        if (this.currentTabType === 'course') {
          this.tableLoading = true
          this.$store.dispatch('setLoading', true)

          if (this.addCourseFilter.type === 'weekday') {
            // 報讀課程後續所有課堂
            try {
              // --- Get 該lesson course所有堂
              // 如果相關課程已added，將lesson加至該課程的selected_lesson_id_list中
              // 否則，加新課程，並把所有相關lesson加至該課程的selected_lesson_id_list中（包括target lesson）

              let payload = {
                filter_item: [
                  { key: 'course_code', value: targetLesson.course_code },
                  { key: 'course_id', value: targetLesson.course_id },
                  { key: 'lesson_type', value: 'regular' },
                ],
              }
              // T14 要4堂為一組咁攞，其他照常一個月為一組咁攞
              // if (this.isAppMode(['T14'])) {
              //   payload['filter_item'].push({ key: 'start_date', value: targetLesson.date })
              // } else {
                const targetYear = targetLesson.date.substring(0, 4)
                const targetMonth = targetLesson.date.substring(5, 7)
                payload['filter_item'].push({ key: 'start_date', value: `${targetYear}-${targetMonth}-01` })

                const endDate = this.$formatter.convertDate(`${targetYear}-${targetMonth}-01`)
                endDate.setMonth(endDate.getMonth() + this.previewMonths)
                endDate.setDate(0)
                payload['filter_item'].push({ key: 'end_date', value: this.$formatter.formatDate(endDate) })
              // }

              const centerId = await this.getSearchCenterId()
              if (centerId > -1) payload['center_id'] = centerId

              const { data } = await this.$Fetcher.GetLessons(payload)
              let relatedLesson = data.filter(el => {
                if (el.student_ids.includes(this.id)) {
                  if (this.$validate.DataValid(this.orderId)) {
                    const foundInOrder = this.orderData.lesson_list.find(elm => elm.id === el.id)
                    if (foundInOrder) return true
                  }
                  return false
                }

                return true
              })
              // if (this.isAppMode(['T14'])) {
              //   // 4堂為一組
              //   relatedLesson = relatedLesson.splice(0, 4)
              // }

              let existCourse = -1
              if (this.$validate.DataValid(this.courseTableData)) {
                for (let i = 0; i < this.courseTableData.length; i++) {
                  if (!this.courseTableData[i].is_single_lesson && this.courseTableData[i].order_id === -1) {
                    const lessonIds = this.courseTableData[i].lesson_data_list.map(e => e.id)
                    for (let k = 0; k < relatedLesson.length; k++) {
                      if (lessonIds.includes(relatedLesson[k].id)) {
                        existCourse = i
                        break
                      }
                    }
                  }
                }
              }

              let newCourse = this.parseCourseTableData(targetLesson, relatedLesson)
              if (existCourse > -1) {
                newCourse.id = this.courseTableData[existCourse].id
                newCourse.trial_lesson_ids = this.courseTableData[existCourse].trial_lesson_ids
                this.$set(this.courseTableData, existCourse, newCourse)

                const foundSelected = this.courseSelectedRow.find(el => el.id === newCourse.id)
                if (!foundSelected) {
                  this.courseSelectedRow.push({ id: newCourse.id })
                }
              } else {
                this.addItemToGroup(this.courseTableData, newCourse)
                this.courseSelectedRow.push({ id: newCourse.id })
              }

              let partners = [-1, -4, -5]
              if (this.enableCombineNextAndNew) {
                partners.push(-2)
              }
              if (this.enableCombineUnpaidAndNew || (this.enableCombineNextAndUnpaid && this.enableCombineNextAndNew)) {
                partners.push(-3)
              }
              for (let i = this.courseSelectedRow.length - 1; i >= 0; i--) {
                const found = this.courseTableData.find(el => el.id === this.courseSelectedRow[i].id)
                if (!partners.includes(found.order_id)) {
                  this.courseSelectedRow.splice(i, 1)
                }
              }
            } catch (err) {
              this.$common.error(err)
            } finally {
              this.$store.dispatch('setLoading', false)
              this.tableLoading = false
            }
          } else {
            // 報讀單一課堂
            const foundPos = this.searchTableSelectedRow.findIndex(el => el.id === lesson_id)
            if (foundPos < 0) {
              this.searchTableSelectedRow.push(targetLesson)
            }
            this.tempSelectedLesson = JSON.parse(JSON.stringify(this.searchTableSelectedRow))
            this.tableLoading = false
            this.$store.dispatch('setLoading', false)
            return
          }
        } else if (this.currentTabType === 'package' && this.addCourseFilter.type === 'weekday') {
          this.handlePackageLessonSelected(lesson_id)
          return
        } else if (this.currentTabType === 'month_pass') {
          this.handleMonthPassLessonSelected(lesson_id)
          return
        } else if (this.currentTabType === 'assign_month_pass') {
          this.handleAssignLessonSelected(lesson_id)
          return
        }
      }

      this.$refs.addCourseDialog.hide()
    },

    // -- 報讀單一課堂（確認）
    handleSingleLessonConfirm() {
      if (this.searchTableSelectedRow.length < 1) {
        this.$store.dispatch('toggleSnack', {
          message: 'message.atLeastOneLesson',
          type: 'error',
        })
        return
      }

      // 分group
      const grouped = []
      this.searchTableSelectedRow.forEach(item => {
        const found = grouped.find(
          group => group[0].course_id === item.course_id && group[0].course_code === item.course_code,
        )
        if (found) {
          found.push(item)
        } else {
          grouped.push([item])
        }
      })

      grouped.forEach(group => {
        group.sort((a, b) => this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`))

        /**
         * 如果table有existing嘅course，將new added加落去
         */
        let newCourse = null
        for (let i = 0; i < this.courseTableData.length; i++) {
          if (
            this.courseTableData[i].is_single_lesson &&
            this.courseTableData[i].order_id === -1 &&
            this.courseTableData[i].lesson_data_list[0].course_id === group[0].course_id &&
            this.courseTableData[i].lesson_data_list[0].course_code === group[0].course_code
          ) {
            // 同一個course
            const lessonIds = this.courseTableData[i].lesson_data_list.map(e => e.id)
            const lesson_data_list = JSON.parse(JSON.stringify(this.courseTableData[i].lesson_data_list))
            const selected_lesson_id_list = JSON.parse(JSON.stringify(this.courseTableData[i].selected_lesson_id_list))
            for (let k = 0; k < group.length; k++) {
              if (!lessonIds.includes(group[k].id)) {
                lesson_data_list.push(group[k])
              }
              if (!selected_lesson_id_list.includes(group[k].id)) {
                selected_lesson_id_list.push(group[k].id)
              }
            }

            lesson_data_list.sort((a, b) =>
              this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`),
            )

            const temp_lesson_data_list = lesson_data_list.filter(el => selected_lesson_id_list.includes(el.id))
            newCourse = this.parseCourseTableData(temp_lesson_data_list[0], temp_lesson_data_list, true)
            newCourse['id'] = this.courseTableData[i].id
            newCourse['trial_lesson_ids'] = this.courseTableData[i].trial_lesson_ids
            newCourse['lesson_data_list'] = lesson_data_list
            this.$set(this.courseTableData, i, newCourse)
            break
          }
        }

        if (newCourse === null) {
          newCourse = this.parseCourseTableData(group[0], group, true)
          this.addItemToGroup(this.courseTableData, newCourse)
        }

        const foundSelected = this.courseSelectedRow.find(el => el.id === newCourse.id)
        if (!foundSelected) this.courseSelectedRow.push({ id: newCourse.id })
      })

      let partners = [-1, -4, -5]
      if (this.enableCombineNextAndNew) {
        partners.push(-2)
      }
      if (this.enableCombineUnpaidAndNew || (this.enableCombineNextAndUnpaid && this.enableCombineNextAndNew)) {
        partners.push(-3)
      }
      for (let i = this.courseSelectedRow.length - 1; i >= 0; i--) {
        const found = this.courseTableData.find(el => el.id === this.courseSelectedRow[i].id)
        if (!partners.includes(found.order_id)) {
          this.courseSelectedRow.splice(i, 1)
        }
      }

      this.$refs.addCourseDialog.hide()
    },

    // ========= Product Related =========
    parseProductTableData(item) {
      this.rowId += 1

      let _item = { ...item }
      _item['discount_price'] = this.getDiscountPrice(item.unit_price, item.discount_type, item.discount_value)

      return {
        id: this.rowId,
        product_id: _item.id,
        item_name: _item.item_name,
        qty: _item.qty,
        inventory: _item.inventory || 0,
        unit_price: _item.unit_price,
        total: this.$formatter.formatMoney(this.getUnitPrice(_item) * _item.qty),
        discount_type: _item.discount_type || '',
        discount_value: _item.discount_value || null,
        discount_price: _item.discount_price || null,
        points: _item.points || 0,
        order_id: this.$validate.DataValid(_item.order_id) ? _item.order_id : -1,
        order_type: 'product',
        group: 'new',
      }
    },

    onProductSelectedRowChanged() {
      const { tableData, selectedRow } = this._getUpdateTableData(this.productTableData, this.productSelectedRow)
      this.productTableData = tableData
      this.productSelectedRow = selectedRow
      if (this.currentTabType === 'course') {
        const { tableData: courseTableData, selectedRow: courseSelectedRow } = this._getUpdateChildTableData(
          this.courseTableData,
          this.courseSelectedRow,
          this.productTableData,
          this.productSelectedRow,
        )
        this.courseTableData = courseTableData
        this.courseSelectedRow = courseSelectedRow
      } else if (this.currentTabType === 'package') {
        const { tableData: packageTableData, selectedRow: packageSelectedRow } = this._getUpdateChildTableData(
          this.packageTableData,
          this.packageSelectedRow,
          this.productTableData,
          this.productSelectedRow,
        )
        this.packageTableData = packageTableData
        this.packageSelectedRow = packageSelectedRow
      } else if (this.currentTabType === 'month_pass') {
        const { tableData: monthPassTableData, selectedRow: monthPassSelectedRow } = this._getUpdateChildTableData(
          this.monthPassTableData,
          this.monthPassSelectedRow,
          this.productTableData,
          this.productSelectedRow,
        )
        this.monthPassTableData = monthPassTableData
        this.monthPassSelectedRow = monthPassSelectedRow
      }

      if (this._forcePaid()) {
        this.formData.status = 'paid'
      }
      if (this.formData.is_redeem) {
        this._onUsePointSelected()
      }
    },

    // -- 新增產品
    onProductFilterChange() {
      this.searchFilter.page = 1
      this.searchTableTotal = 0
      this.searchProducts()
    },
    async searchProducts() {
      this.isSearching = true
      this.searchTableData = []

      let payload = {
        controller_name: 'search_product',
        filter_page: this.searchFilter.page - 1,
        filter_limit: this.searchFilter.limit,
        filter_item: [{ key: 'status', value: 'active' }],
      }
      const centerId = await this.getSearchCenterId()
      if (centerId > -1) payload['center_id'] = centerId
      if (this.$validate.DataValid(this.searchFilter.keyword)) {
        payload.filter_item.push({ key: 'name', value: this.searchFilter.keyword })
      }

      try {
        const { data, total } = await this.$Fetcher.GetProducts(payload)
        this.searchTableTotal = total
        this.searchTableData = data.map(el => {
          const selected = this.productTableData.find(item => item.product_id === el.id && item.order_id === -1)
          let qty = 1
          if (selected) {
            qty = selected.qty
          }
          return {
            id: el.id,
            item_name: el.name,
            inventory: el.inventory,
            qty: qty,
            unit_price: el.price,
            points: el.points,
          }
        })
      } catch (err) {
        this.$common.error(err)
      } finally {
        this.isSearching = false
      }
    },
    // -- (選擇)
    handleAddNewProduct(id) {
      const targetProduct = this.searchTableData.find(el => el.id === id)
      if (targetProduct) {
        const existed = this.productTableData.find(el => el.product_id === id && el.order_id < 0)
        if (existed) {
          existed.qty = targetProduct.qty
          existed.total = this.$formatter.formatMoney(this.getUnitPrice(existed) * existed.qty)

          const foundSelected = this.productSelectedRow.find(el => el.id === existed.id)
          if (!foundSelected) {
            this.productSelectedRow.push({ id: existed.id })
          }
        } else {
          const newProduct = this.parseProductTableData(targetProduct)
          this.addItemToGroup(this.productTableData, newProduct)
          this.productSelectedRow.push({ id: newProduct.id })
        }

        let partners = [-1, -4, -5]
        if (this.enableCombineNextAndNew) {
          partners.push(-2)
        }
        if (this.enableCombineUnpaidAndNew || (this.enableCombineNextAndUnpaid && this.enableCombineNextAndNew)) {
          partners.push(-3)
        }
        for (let i = this.productSelectedRow.length - 1; i >= 0; i--) {
          const found = this.productTableData.find(el => el.id === this.productSelectedRow[i].id)
          if (!partners.includes(found.order_id)) {
            this.productSelectedRow.splice(i, 1)
          }
        }
      }

      this.$refs.addProductDialog.hide()
    },

    // ========= Package Related =========
    parsePackageTableData(item) {
      this.rowId += 1

      let selected_lessons = item.selected_lessons || []
      selected_lessons = JSON.parse(JSON.stringify(selected_lessons))

      let _item = { ...item }
      _item['discount_price'] = this.getDiscountPrice(item.unit_price, item.discount_type, item.discount_value)

      return {
        id: this.rowId,
        package_id: _item.id,
        item_name: _item.item_name,
        lesson_count: _item.lesson_count,
        unit_price: _item.unit_price,
        // lessons_price1: selected_lessons.map(el => el.price),
        total: this.$formatter.formatMoney(this.getUnitPrice(_item)),
        lesson_data_list: selected_lessons,
        selected_lesson_id_list: selected_lessons.map(el => el.id),
        dates: selected_lessons.map(el => el.date),
        max_lesson_count: _item.max_lesson_count || _item.lesson_count,
        discount_type: _item.discount_type || '',
        discount_value: _item.discount_value || null,
        discount_price: _item.discount_price || null,
        order_id: this.$validate.DataValid(_item.order_id) ? _item.order_id : -1,
        qty: 1,
        order_type: 'package',
        select_rule: _item.select_rule,
        group: 'new',
      }
    },

    onPackageSelectedRowChanged() {
      const { tableData, selectedRow } = this._getUpdateTableData(this.packageTableData, this.packageSelectedRow)
      this.packageTableData = tableData
      this.packageSelectedRow = selectedRow

      // -- handle product
      const { tableData: productTableData, selectedRow: productSelectedRow } = this._getUpdateChildTableData(
        this.productTableData,
        this.productSelectedRow,
        this.packageTableData,
        this.packageSelectedRow,
      )
      this.productTableData = productTableData
      this.productSelectedRow = productSelectedRow

      if (this._forcePaid()) {
        this.formData.status = 'paid'
      }

      if (this.formData.is_redeem) {
        this._onUsePointSelected()
      }
    },

    async getStudentRemainLessonCount() {
      if (this.remainPackageLessonCountInit) {
        try {
          const quota = await this.$Fetcher.GetStudentPackageInfo(this.studentData.student_id)
          this.pendingPackageLessonCount = quota.quota_used_pending
          this.availablePackageLessonCount = quota.quota_available
        } catch (err) {
          this.$common.error(err)
          this.availablePackageLessonCount = 0
          this.pendingPackageLessonCount = 0
        }
      }

      // 減返而家已經用咗嘅quota
      this.remainPackageLessonCount = this.availablePackageLessonCount
      if (this.enableMultiPackage) {
        for (let i = 0; i < this.packageTableData.length; i++) {
          if (this.packageTableData[i].order_type === 'package' && this.packageTableData[i].order_id === -1) {
            const rest = this.packageTableData[i].selected_lesson_id_list.length - this.packageTableData[i].lesson_count
            if (rest > 0) {
              this.remainPackageLessonCount -= rest
            }
          }
        }
      }
      this.$common.logData(this.remainPackageLessonCount, 'remainPackageLessonCount')
      this.remainPackageLessonCountInit = false
    },

    // -- 選擇套票
    onPackageFilterChange() {
      this.searchFilter.page = 1
      this.searchTableTotal = 0
      this.searchPackages()
    },
    async searchPackages() {
      this.isSearching = true
      this.searchTableData = []

      let payload = {
        controller_name: 'search_package',
        filter_page: this.searchFilter.page - 1,
        filter_limit: this.searchFilter.limit,
        filter_item: [],
      }
      const centerId = await this.getSearchCenterId()
      if (centerId > -1) {
        payload['filter_item'].push({ key: 'center_id', value: centerId })
      }
      if (this.$validate.DataValid(this.searchFilter.keyword)) {
        payload['filter_item'].push({ key: 'package_name', value: this.searchFilter.keyword })
      }

      try {
        const { data, total } = await this.$Fetcher.GetPackages(payload)
        this.searchTableTotal = total
        this.searchTableData = data.map(el => {
          return {
            id: el.id,
            item_name: el.name,
            lesson_count: el.lesson_count,
            unit_price: el.price,
            total: el.price,
          }
        })
      } catch (err) {
        this.$common.error(err)
        if (this.searchFilter.page === 1) {
          this.searchTableTotal = 0
        }
      } finally {
        this.isSearching = false
      }
    },
    // -- (選擇)
    async handleAddNewPackage(id) {
      const targetPackage = this.searchTableData.find(el => el.id === id)
      if (!targetPackage) return
      this.tempSelectedPackage = JSON.parse(JSON.stringify(targetPackage))
      this.tempSelectedPackage.max_lesson_count = targetPackage.lesson_count
      this.tempSelectedPackage.selected_lessons = []

      this.$refs.addPackageDialog.hide()

      // -- reset table
      this.searchFilter.page = 1
      this.searchTableTotal = 0
      this.searchTableData = []
      this.tempSelectedLesson = []

      // -- reset course search
      this.clearAddCourseFilter()
      this.addCourseFilter.type = 'weekday'

      this.unpaidLessonTableData = []
      this.unpaidLessonSelectedRow = []
      this.unpaidLessonFilter.page = 1

      this.allUnpaidLessonDataStatic = await this._getUnpaidLesson()
      this.allUnpaidLessonData = [...this.allUnpaidLessonDataStatic]
      // filter 走已經揀咗嘅unpaid lesson
      if (this.enableMultiPackage) {
        for (let i = 0; i < this.packageTableData.length; i++) {
          if (this.packageTableData[i].order_type === 'package' && this.packageTableData[i].order_id === -1) {
            this.allUnpaidLessonData = this.allUnpaidLessonData.filter(
              el => !this.packageTableData[i].selected_lesson_id_list.includes(el.id),
            )
          }
        }
      }
      this.$common.logData(this.allUnpaidLessonData, 'Student Unpaid Lessons')

      // Open "unpaid" lesson modal if any. Otherwise, open course modal
      if (this.allUnpaidLessonData.length > 0) {
        this.getUnpaidLessonTableData()
        this.handleSelectUnpaidLesson()
      } else {
        this.openSearchCourse()
      }
    },
    _getUnpaidLesson() {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await this.$Fetcher.GetStudentUnpaidLessons(this.studentData.student_id)
          data.sort((a, b) =>
            this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`),
          )

          resolve(data)
        } catch (err) {
          this.$common.error(err)
          resolve([])
        }
      })
    },
    getUnpaidLessonTableData() {
      if (this.allUnpaidLessonData.length) {
        const startIndex = (this.unpaidLessonFilter.page - 1) * this.unpaidLessonFilter.limit
        this.unpaidLessonTableData = this.allUnpaidLessonData.slice(
          startIndex,
          startIndex + this.unpaidLessonFilter.limit,
        )
      } else {
        this.unpaidLessonTableData = []
      }
    },

    addNewPackage() {
      const rowId = this.$refs.editFormDialog.getInfo()
      if (this.$validate.DataValid(rowId)) {
        for (let i = 0; i < this.packageTableData.length; i++) {
          if (this.packageTableData[i].id === rowId) {
            this.packageTableData[i]['lesson_data_list'] = this.tempSelectedPackage.selected_lessons
            this.packageTableData[i]['selected_lesson_id_list'] = this.tempSelectedPackage.selected_lessons.map(
              el => el.id,
            )
            this.packageTableData[i]['dates'] = this.tempSelectedPackage.selected_lessons.map(el => el.date)
            break
          }
        }
      } else {
        if (!this.enableMultiPackage) {
          // 每次只可買一個套票
          this.packageTableData = this.packageTableData.filter(item => item.order_id !== -1)
        }
        let newPackage = this.parsePackageTableData({
          ...this.tempSelectedPackage,
          select_rule: this.addCourseFilter.packageLessonRule,
        })
        this.addItemToGroup(this.packageTableData, newPackage)
        this.packageSelectedRow.push({ id: newPackage.id })
        this.$common.logData(this.packageTableData, 'packageTableData')

        let partners = [-1, -4, -5]
        if (this.enableCombineNextAndNew) {
          partners.push(-2)
        }
        if (this.enableCombineUnpaidAndNew || (this.enableCombineNextAndUnpaid && this.enableCombineNextAndNew)) {
          partners.push(-3)
        }
        for (let i = this.packageSelectedRow.length - 1; i >= 0; i--) {
          const found = this.packageTableData.find(el => el.id === this.packageSelectedRow[i].id)
          if (found && !partners.includes(found.order_id)) {
            this.packageSelectedRow.splice(i, 1)
          }
        }
      }
    },

    // -- 修改項目資料 (選擇課堂)
    async _openPackageEditLesson() {
      const id = this.$refs.editFormDialog.getInfo()
      if (this.$validate.DataValid(id)) {
        const found = this.packageTableData.find(el => el.id === id)
        if (found) {
          // -- reset table
          this.searchFilter.page = 1
          this.searchTableTotal = 0
          this.searchTableData = []

          // -- reset course search
          this.clearAddCourseFilter()
          this.addCourseFilter.type = 'weekday'

          this.unpaidLessonTableData = []
          this.unpaidLessonSelectedRow = []
          this.unpaidLessonFilter.page = 1

          this.addCourseFilter.packageLessonRule = 'manually'
          this.tempSelectedPackage = {
            id: found.package_id,
            lesson_count: found.lesson_count,
            max_lesson_count: found.lesson_count,
            selected_lessons: [...found.lesson_data_list],
          }
          this.tempSelectedLesson = [...found.lesson_data_list]
          this.searchTableSelectedRow = [...found.lesson_data_list]

          this.isSearching = true
          this.$refs.addCourseDialog.show('search_lesson')
          this.allUnpaidLessonDataStatic = await this._getUnpaidLesson()
          if (this.$validate.DataValid(this.orderId)) {
            this.allUnpaidLessonDataStatic = [...this.allUnpaidLessonDataStatic, ...this.orderData.unpaid_lesson_datas]
          }
          this.allUnpaidLessonData = [...this.allUnpaidLessonDataStatic]

          this.openSearchCourse()
        }
      }
    },

    // === 選擇「未付款」課堂
    async handleSelectUnpaidLesson() {
      this.$refs.unpaidLessonFormDialog.setLoading(false)
      const confirm = await this.$refs.unpaidLessonFormDialog.show()
      if (confirm === true || confirm === false) {
        // -- (繼續 / 報讀其他課程)
        this._handleUnpaidLessonSubmit()
      } else {
        this.$refs.unpaidLessonFormDialog.hide()
      }
    },
    async _handleUnpaidLessonSubmit() {
      // --- 如果有"未指派課堂"，又有unpaid，要揀曬啲unpaid lesson先可以再apply新lesson
      if (
        this.remainPackageLessonCount > 0 &&
        ((this.allUnpaidLessonData.length >= this.remainPackageLessonCount &&
          this.unpaidLessonSelectedRow.length < this.remainPackageLessonCount) ||
          (this.allUnpaidLessonData.length <= this.remainPackageLessonCount &&
            this.unpaidLessonSelectedRow.length < this.allUnpaidLessonData.length))
      ) {
        this.$store.dispatch('toggleSnack', {
          message: 'message.requiredUnpaidLesson',
          type: 'error',
        })
        this.handleSelectUnpaidLesson()
        return
      }

      this.tempSelectedPackage.selected_lessons = []
      this.tempSelectedLesson = []
      this.unpaidLessonSelectedRow.forEach(item => {
        const found = this.allUnpaidLessonData.find(el => el.id === item.id)
        if (found) {
          this.tempSelectedPackage.selected_lessons.push(found)
          this.tempSelectedLesson.push(found)
        }
      })

      if (this.unpaidLessonSelectedRow.length < this.remainPackageLessonCount + this.tempSelectedPackage.lesson_count) {
        // Case 已選unpaid lessons 少於 "未指派課堂" + 新package課堂
        if (this.unpaidLessonSelectedRow.length < this.remainPackageLessonCount) {
          /**
           * Case 已選unpaid lessons 少於 "未指派課堂"，問會唔會apply落新課堂
           * -> 會，加落quota -> 繼續報名新課堂
           * -> 不會 -> 繼續報名新課堂
           */

          const allApplyCount =
            this.tempSelectedPackage.lesson_count + this.remainPackageLessonCount - this.unpaidLessonSelectedRow.length

          const confirmCombine = await this.confirmRef.show({
            title: 'message.restPackageApplyCourse',
            confirmBtnText: this.$t('allApplyToCourse', { count: allApplyCount }),
            cancelBtnText: this.$t('continueToApplyCourse', {
              count: this.tempSelectedPackage ? this.tempSelectedPackage.lesson_count : 0,
            }),
          })
          if (confirmCombine) {
            this.tempSelectedPackage.max_lesson_count =
              this.tempSelectedPackage.lesson_count + this.remainPackageLessonCount
          }
        } else {
          this.tempSelectedPackage.max_lesson_count =
            this.remainPackageLessonCount + this.tempSelectedPackage.lesson_count
        }

        // -> 繼續報名新課堂
        this.$refs.unpaidLessonFormDialog.hide()
        this.openSearchCourse()
        return
      } else if (
        this.unpaidLessonSelectedRow.length >
        this.remainPackageLessonCount + this.tempSelectedPackage.lesson_count
      ) {
        // Case 已選unpaid lessons 大於 "未指派課堂" + 新package課堂 -> reject
        this.$store.dispatch('toggleSnack', {
          message: 'message.lessonCountNotEnough',
          type: 'error',
        })
        this.handleSelectUnpaidLesson()
        return
      }

      // Case 已選unpaid lessons 等於 "未指派課堂" + 新package課堂 -> add package in table
      this.addNewPackage()
      this.$refs.unpaidLessonFormDialog.hide()
    },
    onUnpaidLessonSelectedRowChanged() {
      if (this.tempSelectedPackage) {
        if (
          this.unpaidLessonSelectedRow.length >=
          this.tempSelectedPackage.lesson_count + this.remainPackageLessonCount
        ) {
          const selectedIds = this.unpaidLessonSelectedRow.map(el => el.id)
          this.allUnpaidLessonData.forEach(el => {
            if (!selectedIds.includes(el.id)) {
              el.disabled = true
            } else {
              el.disabled = false
            }
          })
        } else {
          this.allUnpaidLessonData.forEach(el => (el.disabled = false))
        }
      }
    },

    // -- 報讀新課程 (報名)
    onPackageRuleChanged() {
      if (this.currentTabType === 'package') {
        this.tempSelectedPackage.selected_lessons = this.tempSelectedPackage.selected_lessons.filter(item => {
          if (this.allUnpaidLessonData.length) {
            const foundUnpaid = this.allUnpaidLessonData.find(el => el.id === item.id)
            return foundUnpaid
          }
          return false
        })
        this.tempSelectedLesson = JSON.parse(JSON.stringify(this.tempSelectedPackage.selected_lessons))
        this.searchTableSelectedRow = []
      } else if (this.currentTabType === 'month_pass') {
        this.tempSelectedMonthPass.selected_lessons = []
        this.tempSelectedLesson = []
        this.searchTableSelectedRow = []
        if (this.$validate.DataValid(this.orderId)) {
          this.tempSelectedMonthPass.selected_lessons = JSON.parse(JSON.stringify(this.orderData.lesson_datas))
          this.tempSelectedLesson = JSON.parse(JSON.stringify(this.orderData.lesson_datas))
          this.searchTableSelectedRow = JSON.parse(JSON.stringify(this.orderData.lesson_datas))
        }
      } else if (this.currentTabType === 'assign_month_pass') {
        this.tempSelectedLesson = []
        this.searchTableSelectedRow = []
      }
    },
    async handlePackageLessonSelected(lesson_id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      this.$store.dispatch('setLoading', true)
      try {
        const targetLesson = this.searchTableData.find(el => el.id === lesson_id)
        const foundPos = this.searchTableSelectedRow.findIndex(el => el.id === lesson_id)

        if (this.addCourseFilter.packageLessonRule === 'manually') {
          // 手動選擇報讀課堂
          const foundTemp = this.tempSelectedPackage.selected_lessons.findIndex(el => el.id === lesson_id)
          if (foundPos > -1) {
            this.searchTableSelectedRow.splice(foundPos, 1)
            if (foundTemp > -1) {
              this.tempSelectedPackage.selected_lessons.splice(foundTemp, 1)
            }
          } else {
            if (this.tempSelectedPackage.selected_lessons.length >= this.tempSelectedPackage.max_lesson_count) {
              this.$store.dispatch('setLoading', false)
              this.$store.dispatch('toggleSnack', {
                message: 'message.lessonCountNotEnough',
                type: 'error',
              })
              return
            }
            this.searchTableSelectedRow.push(targetLesson)
            if (foundTemp < 0) {
              this.tempSelectedPackage.selected_lessons.push(targetLesson)

              const foundUnpaids = this.tempSelectedPackage.selected_lessons.filter(item => {
                const foundUnpaid = this.allUnpaidLessonData.find(el => el.id === item.id)
                return foundUnpaid
              })
              const foundNews = this.tempSelectedPackage.selected_lessons.filter(item => {
                const foundUnpaid = this.allUnpaidLessonData.find(el => el.id === item.id)
                return !foundUnpaid
              })
              foundNews.sort((a, b) =>
                this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`),
              )

              this.tempSelectedPackage.selected_lessons = [...foundUnpaids, ...foundNews]
            }
          }
          this.tempSelectedLesson = JSON.parse(JSON.stringify(this.tempSelectedPackage.selected_lessons))
        } else {
          // 自動報讀
          if (foundPos > -1) {
            this.searchTableSelectedRow.splice(foundPos, 1)

            for (let i = this.tempSelectedPackage.selected_lessons.length - 1; i >= 0; i--) {
              if (this.tempSelectedPackage.selected_lessons[i].course_code === targetLesson.course_code) {
                const foundUnpaid = this.allUnpaidLessonData.find(
                  el => el.id === this.tempSelectedPackage.selected_lessons[i].id,
                )
                if (!foundUnpaid) {
                  this.tempSelectedPackage.selected_lessons.splice(i, 1)
                }
              }
            }
          } else {
            const foundSameCourse = this.searchTableSelectedRow.findIndex(
              el => el.course_code === targetLesson.course_code,
            )
            if (foundSameCourse > -1) {
              this.searchTableSelectedRow.splice(foundSameCourse, 1)
            }
            this.searchTableSelectedRow.push(targetLesson)
          }

          // -- 搵related lesson
          const unpaid_selected_lessons = this.tempSelectedPackage.selected_lessons.filter(item => {
            const foundUnpaid = this.allUnpaidLessonData.find(el => el.id === item.id)
            return foundUnpaid
          })
          const restCount = this.tempSelectedPackage.max_lesson_count - unpaid_selected_lessons.length
          let relatedLessons = await this._getAutoLessonPreview(restCount)

          // 將order而又冇揀到嘅lesson，塞返入去
          if (this.$validate.DataValid(this.orderId)) {
            const rowId = this.$refs.editFormDialog.getInfo()
            if (this.searchTableSelectedRow.length) {
              const allSelectedLessons = this.packageTableData.reduce((list, item) => {
                if (item.id !== rowId) {
                  return [...list, ...item.selected_lesson_id_list]
                }

                return list
              }, [])
              const remainLessons = this.orderData.lesson_datas.filter(item => !allSelectedLessons.includes(item.id))
              for (let i = 0; i < this.searchTableSelectedRow.length; i++) {
                const parent = this.searchTableSelectedRow[i]
                const parentDate = this.$formatter.convertDate(parent.date, parent.start_time)
                const lessons = remainLessons.filter(item => {
                  if (item.course_code !== parent.course_code) return false

                  const d = this.$formatter.convertDate(item.date, item.start_time)
                  return d.getTime() >= parentDate.getTime()
                })
                for (let x = 0; x < lessons.length; x++) {
                  const found = relatedLessons.find(el => el.id === lessons[x].id)
                  if (!found) {
                    relatedLessons.push(lessons[x])
                  }
                }
              }
            }
          }

          relatedLessons.sort((a, b) =>
            this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`),
          )
          relatedLessons = relatedLessons.slice(0, restCount)
          this.tempSelectedPackage.selected_lessons = [...unpaid_selected_lessons, ...relatedLessons]
          this.tempSelectedLesson = JSON.parse(JSON.stringify(this.tempSelectedPackage.selected_lessons))
        }
        this.$common.logData(this.searchTableSelectedRow, 'searchTableSelectedRow')
        this.$common.logData(this.tempSelectedLesson, 'Selected Lessons')
      } catch (err) {
        this.$common.error(err)
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },
    // -- (報名 - 確認)
    async handlePackageLessonConfirm(skip = false) {
      if (skip) {
        this.tempSelectedPackage.selected_lessons = this.tempSelectedPackage.selected_lessons.filter(item => {
          const foundUnpaid = this.allUnpaidLessonData.find(el => el.id === item.id)
          return foundUnpaid
        })
      } else {
        // 冇揀lesson，reject
        const newAddLessons = this.tempSelectedPackage.selected_lessons.filter(item => {
          const foundUnpaid = this.allUnpaidLessonData.find(el => el.id === item.id)
          return !foundUnpaid
        })
        if (newAddLessons.length < 1) {
          this.$store.dispatch('toggleSnack', {
            message: 'message.atLeastOneLesson',
            type: 'error',
          })
          return
        }
        // 如果揀自動render lesson，而唔夠堂數，問要唔要加lesson
        if (
          this.addCourseFilter.packageLessonRule === 'auto' &&
          this.tempSelectedPackage.selected_lessons.length < this.tempSelectedPackage.max_lesson_count
        ) {
          this.createLessonCount =
            this.tempSelectedPackage.max_lesson_count - this.tempSelectedPackage.selected_lessons.length

          this.createLessonCourseOptions = this.searchTableSelectedRow.map(el => {
            return {
              value: el.regular_id,
              text: el.course_name,
            }
          })
          this.createLessonRegularId = this.createLessonCourseOptions[0].value

          this._handleAddMoreLesson()
          return
        }
      }

      if (this.tempSelectedPackage.selected_lessons.length > this.tempSelectedPackage.max_lesson_count) {
        this.$store.dispatch('toggleSnack', {
          message: 'message.lessonCountNotEnough',
          type: 'error',
        })
        return
      }

      this.tempSelectedLesson = JSON.parse(JSON.stringify(this.tempSelectedPackage.selected_lessons))
      this.addNewPackage()
      this.$refs.addCourseDialog.hide()
      this.$refs.editFormDialog.hide()
    },

    // -- 新增課堂
    async _handleAddMoreLesson(newOpen = true) {
      if (newOpen) {
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }

        const std_data = await this.$Fetcher.GetCourseStudents(this.course_code)
        console.log("this.$Fetcher.GetCourseStudents", std_data)
        this.course_students = std_data.map(item => {
          return {
            ...item,
            class_student_name:
              item.student_name +
              (this.isAppMode(['T46']) ? ` ${item.student_nickname} (${this.gfGetGradeText(item.grade)})` : ''),
          }
        })
        console.log(this.course_students)

      } else {
        this.$refs.addLessonFormDialog.setLoading(false)
      }

      const confirm = await this.$refs.addLessonFormDialog.show()
      if (confirm === true) {
        this.$store.dispatch('setLoading', true)
        let selected_students = [];
        for(let i=0; i<this.selected_course_students.length; i++){
          selected_students.push(this.selected_course_students[i].id)
        }
        try {
          let payload = {
            days: parseInt(this.createLessonCount),
          }
          payload['selected_students'] = selected_students
          const lessons = await this.$Fetcher.ExtendRegularLesson(this.createLessonRegularId, payload)

          let tempLessons = [...this.tempSelectedPackage.selected_lessons, ...lessons]

          const unpaidLessons = []
          let newAddLessons = []

          tempLessons.forEach(item => {
            const foundUnpaid = this.allUnpaidLessonData.find(el => el.id === item.id)
            if (foundUnpaid) {
              unpaidLessons.push(item)
            } else {
              newAddLessons.push(item)
            }
          })

          const rest = this.tempSelectedPackage.max_lesson_count - unpaidLessons.length
          newAddLessons.sort((a, b) =>
            this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`),
          )
          newAddLessons = newAddLessons.slice(0, rest)
          this.tempSelectedPackage.selected_lessons = [...unpaidLessons, ...newAddLessons]
          this.tempSelectedLesson = JSON.parse(JSON.stringify(this.tempSelectedPackage.selected_lessons))

          setTimeout(() => {
            this.$refs.addLessonFormDialog.hide()
            this.$store.dispatch('setLoading', false)
            this.addNewPackage()
            this.$refs.addCourseDialog.hide()
            this.$refs.editFormDialog.hide()
          }, 500)
        } catch (err) {
          this.$common.error(err)
          this.showAlert({
            title: 'message.createFail',
            message: err,
            isError: true,
          })
          this.$store.dispatch('setLoading', false)
          this._handleAddMoreLesson(false)
        }
      } else if (confirm === false) {
        this.addNewPackage()
        this.$refs.addCourseDialog.hide()
        this.$refs.editFormDialog.hide()
      }
    },

    // =========== 自訂項目 related ===========
    parseCustomItemTableData(item) {
      this.rowId += 1

      let _item = { ...item }
      _item['discount_price'] = this.getDiscountPrice(item.unit_price, item.discount_type, item.discount_value)

      return {
        id: this.rowId,
        group: 'custom',
        item_name: _item.name,
        course_name: _item.name,
        unit_price: _item.unit_price,
        qty: _item.qty,
        item_description: _item.description,
        total: this.$formatter.formatMoney(this.getUnitPrice(_item) * _item.qty),
        discount_type: _item.discount_type || '',
        discount_value: _item.discount_value || null,
        discount_price: _item.discount_price || null,
        order_id: this.$validate.DataValid(_item.order_id) ? _item.order_id : -4,
        order_type: 'custom',
        lesson_data_list: [],
        selected_lesson_id_list: [],
        package_id: -1,
        inventory: 0,
        month_pass_id: -1,
        type: '',
        days: 0,
        select_rule: '',
      }
    },
    async handleAddCustomItem(id = null, newOpen = true) {
      if (newOpen) {
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }

        await this.$refs.addCustomItemFormDialog.resetForm()
        this.customItemFormData.name = ''
        this.customItemFormData.description = ''
        this.customItemFormData.qty = 1
        this.customItemFormData.price = ''
        if (this.$validate.DataValid(id)) {
          let found = this.courseTableData.find(el => el.id === id)
          if (!found) {
            found = this.packageTableData.find(el => el.id === id)
          }
          if (!found) {
            found = this.monthPassTableData.find(el => el.id === id)
          }
          if (!found) return

          this.customItemFormData.name = found.item_name
          this.customItemFormData.description = found.item_description
          this.customItemFormData.qty = found.qty
          this.customItemFormData.price = found.unit_price
        }
      } else {
        this.$refs.addCustomItemFormDialog.setLoading(false)
      }

      const confirm = await this.$refs.addCustomItemFormDialog.show()
      if (confirm) {
        if (!this.disabledInOldVersion) {
          if (this.$validate.DataValid(id)) {
            const obj = {
              course_name: this.customItemFormData.name,
              item_name: this.customItemFormData.name,
              unit_price: parseFloat(this.customItemFormData.price),
              qty: parseInt(this.customItemFormData.qty),
              item_description: this.customItemFormData.description,
            }
            for (let i = 0; i < this.courseTableData.length; i++) {
              if (this.courseTableData[i].id === id) {
                for (let key in obj) {
                  this.courseTableData[i][key] = obj[key]
                }
                this.courseTableData[i].total = this.$formatter.formatMoney(
                  this.getUnitPrice(this.courseTableData[i]) * obj.qty,
                )
                break
              }
            }

            for (let i = 0; i < this.packageTableData.length; i++) {
              if (this.packageTableData[i].id === id) {
                for (let key in obj) {
                  this.packageTableData[i][key] = obj[key]
                }
                this.packageTableData[i].total = this.$formatter.formatMoney(
                  this.getUnitPrice(this.packageTableData[i]) * obj.qty,
                )
                break
              }
            }

            for (let i = 0; i < this.monthPassTableData.length; i++) {
              if (this.monthPassTableData[i].id === id) {
                for (let key in obj) {
                  this.monthPassTableData[i][key] = obj[key]
                }
                this.monthPassTableData[i].total = this.$formatter.formatMoney(
                  this.getUnitPrice(this.monthPassTableData[i]) * obj.qty,
                )
                break
              }
            }
          } else {
            let newItem = this.parseCustomItemTableData({
              name: this.customItemFormData.name,
              description: this.customItemFormData.description,
              qty: parseInt(this.customItemFormData.qty),
              unit_price: parseFloat(this.customItemFormData.price),
            })
            for (let i = this.courseSelectedRow.length - 1; i >= 0; i--) {
              const found = this.courseTableData.find(el => el.id === this.courseSelectedRow[i].id)
              const partners = [-1, -2, -4, -5]
              if (this.enableCombineNextAndUnpaid) {
                partners.push(-3)
              }
              if (!found || !partners.includes(found.order_id)) {
                this.courseSelectedRow.splice(i, 1)
              }
            }

            for (let i = this.packageSelectedRow.length - 1; i >= 0; i--) {
              const found = this.packageTableData.find(el => el.id === this.packageSelectedRow[i].id)
              if (!found || (found.order_id !== -1 && found.order_id !== -4 && found.order_id !== -5)) {
                this.packageSelectedRow.splice(i, 1)
              }
            }

            for (let i = this.monthPassSelectedRow.length - 1; i >= 0; i--) {
              const found = this.monthPassTableData.find(el => el.id === this.monthPassSelectedRow[i].id)
              if (!found || (found.order_id !== -1 && found.order_id !== -4 && found.order_id !== -5)) {
                this.monthPassSelectedRow.splice(i, 1)
              }
            }

            this.addItemToGroup(this.courseTableData, newItem)
            this.courseSelectedRow.push({ id: newItem.id })
            this.addItemToGroup(this.packageTableData, newItem)
            this.packageSelectedRow.push({ id: newItem.id })
            this.addItemToGroup(this.monthPassTableData, newItem)
            this.monthPassSelectedRow.push({ id: newItem.id })
          }
        }

        this.$refs.addCustomItemFormDialog.hide()
      }
    },

    // ============ 購買月票 ==============
    parseMonthPassTableData(item) {
      this.rowId += 1

      let selected_lessons = item.selected_lessons || []
      selected_lessons = JSON.parse(JSON.stringify(selected_lessons))

      let _item = { ...item }
      _item['discount_price'] = this.getDiscountPrice(item.unit_price, item.discount_type, item.discount_value)

      return {
        id: this.rowId,
        month_pass_id: _item.id,
        item_name: _item.item_name,
        type: _item.type,
        days: _item.days || 0,
        unit_price: _item.unit_price,
        // lessons_price3: selected_lessons.map(el => el.price),
        total: this.$formatter.formatMoney(this.getUnitPrice(_item) * _item.qty),
        lesson_data_list: selected_lessons,
        selected_lesson_id_list: selected_lessons.map(el => el.id),
        dates: selected_lessons.map(el => el.date),
        discount_type: _item.discount_type || '',
        discount_value: _item.discount_value || null,
        discount_price: _item.discount_price || null,
        order_id: this.$validate.DataValid(_item.order_id) ? _item.order_id : -1,
        qty: _item.qty,
        order_type: 'month_pass',
        select_rule: _item.select_rule,
        group: 'new',
        select_month: _item.select_month || '',
        from_order: _item.from_order || false,
        order_qty: _item.order_qty || 1,
      }
    },

    onMonthPassSelectedRowChanged() {
      const { tableData, selectedRow } = this._getUpdateTableData(this.monthPassTableData, this.monthPassSelectedRow)
      this.monthPassTableData = tableData
      this.monthPassSelectedRow = selectedRow

      // -- handle product
      const { tableData: productTableData, selectedRow: productSelectedRow } = this._getUpdateChildTableData(
        this.productTableData,
        this.productSelectedRow,
        this.monthPassTableData,
        this.monthPassSelectedRow,
      )
      this.productTableData = productTableData
      this.productSelectedRow = productSelectedRow

      if (this._forcePaid()) {
        this.formData.status = 'paid'
      }
      if (this.formData.is_redeem) {
        this._onUsePointSelected()
      }
    },

    _reallocateMonthPassLessons(allLessons = []) {
      let allSelectedLessons = JSON.parse(JSON.stringify(allLessons))
      allSelectedLessons.sort((a, b) =>
        this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`),
      )

      const newMonthPassItems = this.monthPassTableData.filter(
        el => el.order_type === 'month_pass' && el.order_id === -1,
      )

      let startDate = null
      if (allSelectedLessons.length) {
        let start = ''
        if (newMonthPassItems[0].type === 'months') {
          start = `${newMonthPassItems[0].select_month}-01`
        } else {
          start = allSelectedLessons[0].date
        }
        const { min } = this._getMonthPassMinMaxDate(null, start)
        if (min) {
          startDate = this.$formatter.convertDate(min)
        }
      }

      for (let i = 0; i < newMonthPassItems.length; i++) {
        const found = this.monthPassTableData.find(el => el.id === newMonthPassItems[i].id)
        found.lesson_data_list = []
        found.selected_lesson_id_list = []
        found.dates = []

        if (startDate) {
          let _startDate = this.$formatter.convertDate(this.$formatter.formatDate(startDate))
          let _endDate = null
          if (newMonthPassItems[i].type === 'months') {
            let months = 0
            if (i !== 0) {
              for (let j = 0; j < i; j++) {
                months += newMonthPassItems[j].qty
              }
            }
            _startDate.setMonth(_startDate.getMonth() + months)
            _startDate.setDate(1)
            _endDate = this.$formatter.convertDate(
              `${_startDate.getFullYear()}-${this.$formatter.pad(_startDate.getMonth() + 1)}-01`,
            )
            _endDate.setMonth(_endDate.getMonth() + newMonthPassItems[i].qty)
            _endDate.setDate(0)
          } else if (newMonthPassItems[i].type === 'days') {
            let days = 0
            if (i !== 0) {
              for (let j = 0; j < i; j++) {
                days += newMonthPassItems[j].qty * newMonthPassItems[j].days
              }
            }
            _startDate.setDate(_startDate.getDate() + days)
            _endDate = this.$formatter.convertDate(this.$formatter.formatDate(_startDate))
            _endDate.setDate(_endDate.getDate() - 1 + newMonthPassItems[i].qty * newMonthPassItems[i].days)
          }

          found.lesson_data_list = allSelectedLessons.filter(lesson => {
            const selectedDate = this.$formatter.convertDate(lesson.date)
            return (
              this.$validate.isDateEqual(selectedDate, _startDate) ||
              this.$validate.isDateEqual(selectedDate, _endDate) ||
              (this.$validate.isDateGreater(selectedDate, _startDate) &&
                this.$validate.isDateLess(selectedDate, _endDate))
            )
          })
          found.selected_lesson_id_list = found.lesson_data_list.map(el => el.id)
          found.dates = found.lesson_data_list.map(el => el.date)
          allSelectedLessons = allSelectedLessons.filter(lesson => !found.selected_lesson_id_list.includes(lesson.id))
        }
      }
    },
    _resetMonthPassRowDeleteBtn() {
      // handle 月票 hidden delete button
      let newMonthPassCount = 0
      const newMonthPassItems = this.monthPassTableData.filter(
        el => el.order_type === 'month_pass' && el.order_id === -1,
      )
      for (let i = 0; i < this.monthPassTableData.length; i++) {
        this.monthPassTableData[i].disabledDelete = false

        if (this.monthPassTableData[i].order_type === 'month_pass' && this.monthPassTableData[i].order_id === -1) {
          this.monthPassTableData[i].readonly = false

          if (newMonthPassCount !== newMonthPassItems.length - 1 || this.monthPassTableData[i].from_order) {
            this.monthPassTableData[i].disabledDelete = true
          }
          if (newMonthPassCount !== 0 || this.monthPassTableData[i].from_order) {
            this.monthPassTableData[i].readonly = true
          }
          newMonthPassCount += 1
        }
      }
    },
    _getMonthPassMinMaxDate(monthPass = null, start_date = '') {
      let startDate = null
      let endDate = null
      if (this.$validate.DataValid(start_date)) {
        startDate = this.$formatter.convertDate(start_date)
      }
      const newMonthPassItems = this.monthPassTableData.filter(
        el => el.order_type === 'month_pass' && el.order_id === -1,
      )
      if (newMonthPassItems.length) {
        if (newMonthPassItems[0].type === 'days') {
          let days = 0
          for (let i = 0; i < newMonthPassItems.length; i++) {
            if (!monthPass || newMonthPassItems[i].month_pass_id !== monthPass.id) {
              days += newMonthPassItems[i].qty * newMonthPassItems[i].days
            }
          }
          if (monthPass) {
            days += monthPass.qty * monthPass.days
          }
          if (!startDate && newMonthPassItems[0].lesson_data_list.length) {
            startDate = this.$formatter.convertDate(newMonthPassItems[0].lesson_data_list[0].date)
          }

          if (startDate) {
            endDate = this.$formatter.convertDate(this.$formatter.formatDate(startDate))
            endDate.setDate(endDate.getDate() - 1 + days)
          }
        } else if (newMonthPassItems[0].type === 'months') {
          let months = 0
          for (let i = 0; i < newMonthPassItems.length; i++) {
            if (!monthPass || newMonthPassItems[i].month_pass_id !== monthPass.id) {
              months += newMonthPassItems[i].qty
            }
          }
          if (monthPass) {
            months += monthPass.qty
          }
          if (!startDate) {
            startDate = this.$formatter.convertDate(`${newMonthPassItems[0].select_month}-01`)
          }
          startDate.setDate(1)
          endDate = this.$formatter.convertDate(this.$formatter.formatDate(startDate))
          endDate.setMonth(endDate.getMonth() + months)
          endDate.setDate(0)
        }
      } else if (monthPass && startDate) {
        if (monthPass.type === 'days') {
          endDate = this.$formatter.convertDate(this.$formatter.formatDate(startDate))
          endDate.setDate(endDate.getDate() - 1 + monthPass.qty * monthPass.days)
        } else if (monthPass.type === 'months') {
          endDate = this.$formatter.convertDate(this.$formatter.formatDate(startDate))
          endDate.setMonth(endDate.getMonth() + monthPass.qty)
          endDate.setDate(0)
        }
      }

      return {
        min: startDate ? this.$formatter.formatDate(startDate) : null,
        max: endDate ? this.$formatter.formatDate(endDate) : null,
      }
    },

    async _getAutoLessonPreview(maxCount = -1) {
      let lessons = []
      try {
        if (this.searchTableSelectedRow.length) {
          this.searchTableSelectedRow.sort((a, b) =>
            this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`),
          )

          const courseCodes = this.searchTableSelectedRow.map(el => el.course_code)
          const minDate = this.$formatter.convertDate(this.searchTableSelectedRow[0].date)
          minDate.setDate(minDate.getDate() - 1)

          let payload = {
            student_id: this.studentData.student_id,
            date: this.$formatter.formatDate(minDate),
            course_codes: courseCodes,
            selected_first_lessons: this.searchTableSelectedRow.map(el => {
              return {
                course_code: el.course_code,
                date: el.date,
                start_time: el.start_time,
              }
            }),
          }
          if (maxCount > -1) {
            payload['max_count'] = maxCount
          }
          lessons = await this.$Fetcher.GetPackageLessonsPreview(payload)
        }
      } catch {}

      return lessons
    },

    // -- 選擇月票
    onMonthPassFilterChange() {
      this.searchFilter.page = 1
      this.searchTableTotal = 0
      this.searchMonthPasses()
    },
    async searchMonthPasses() {
      this.isSearching = true
      this.searchTableData = []

      let payload = {
        controller_name: 'search_month_pass',
        filter_page: this.searchFilter.page - 1,
        filter_limit: this.searchFilter.limit,
        filter_item: [],
      }
      if (this.$validate.DataValid(this.searchFilter.keyword)) {
        payload.filter_item.push({ key: 'name', value: this.searchFilter.keyword })
      }

      try {
        const { data, total } = await this.$Fetcher.GetMonthPasses(payload)
        this.searchTableTotal = total
        this.searchTableData = data.map(el => {
          const selected = this.monthPassTableData.find(
            item => item.month_pass_id === el.id && item.order_id === -1 && item.order_type === 'month_pass',
          )
          let qty = 1
          let min = 1
          if (selected) {
            qty = selected.qty
            min = selected.order_qty
          }
          return {
            ...el,
            item_name: el.name,
            unit_price: el.price,
            qty: qty,
            qty_min: min,
          }
        })
      } catch (err) {
        this.$common.error(err)
      } finally {
        this.isSearching = false
      }
    },
    // -- (選擇)
    handleAddNewMonthPass(id) {
      const targetMonthPass = this.searchTableData.find(el => el.id === id)
      if (!targetMonthPass) return

      // -- check 每張訂單只可買一種月票類型
      if (this.monthPassTableData.length) {
        const newItems = this.monthPassTableData.find(el => el.order_type === 'month_pass' && el.order_id === -1)
        if (newItems && newItems.type !== targetMonthPass.type) {
          this.$store.dispatch('toggleSnack', {
            message: 'message.oneOrderOneMonthPassType',
            type: 'error',
          })
          return
        }
      }

      this.$refs.addMonthPassDialog.hide()

      // -- reset
      this.clearAddCourseFilter()
      this.addCourseFilter.selectedMonth = ''

      this.tempSelectedMonthPass = JSON.parse(JSON.stringify(targetMonthPass))
      this.tempSelectedMonthPass.selected_lessons = []
      this.tempSelectedLesson = []
      // 搵月票可選日期範圍
      const newMonthPassItems = this.monthPassTableData.filter(
        el => el.order_type === 'month_pass' && el.order_id === -1,
      )
      if (newMonthPassItems.length) {
        this.addCourseFilter.packageLessonRule = newMonthPassItems[0].select_rule
        this.addCourseFilter.selectedMonth = newMonthPassItems[0].select_month

        const { min, max } = this._getMonthPassMinMaxDate(this.tempSelectedMonthPass)
        if (min && max) {
          this.addCourseFilter.dateRange = [min, max]
        }
        for (let i = 0; i < newMonthPassItems.length; i++) {
          this.tempSelectedLesson = this.tempSelectedLesson.concat(newMonthPassItems[i].lesson_data_list)
        }
        // 如果更新咗Qty之後，start/end可能改變，filter走唔係範圍內嘅日期
        if (min && max) {
          const startDate = this.$formatter.convertDate(min)
          const endDate = this.$formatter.convertDate(max)
          this.tempSelectedLesson = this.tempSelectedLesson.filter(lesson => {
            const date = this.$formatter.convertDate(lesson.date)
            return (
              this.$validate.isDateEqual(date, startDate) ||
              this.$validate.isDateEqual(date, endDate) ||
              (this.$validate.isDateGreater(date, startDate) && this.$validate.isDateLess(date, endDate))
            )
          })
        }
        // 將啲lesson加返落selected row
        for (let i = 0; i < this.tempSelectedLesson.length; i++) {
          if (newMonthPassItems[0].select_rule === 'auto') {
            const foundSameCourse = this.searchTableSelectedRow.find(
              el =>
                el.course_id === this.tempSelectedLesson[i].course_id &&
                el.course_code === this.tempSelectedLesson[i].course_code,
            )
            if (!foundSameCourse) {
              this.searchTableSelectedRow.push(this.tempSelectedLesson[i])
            }
          } else {
            this.searchTableSelectedRow.push(this.tempSelectedLesson[i])
          }
        }
      }

      this._openSearchMonthPassCourse()
    },
    async _openSearchMonthPassCourse() {
      // -- reset table
      this.searchFilter.page = 1
      this.searchTableTotal = 0
      this.searchTableData = []

      // -- reset course search
      this.addCourseFilter.type = 'singleDate'

      this.isSearching = true
      this.$refs.addCourseDialog.show('search_lesson')
      if (this.tutorOptions.length < 1) {
        await this._getTutorOptions()
      }
      this._getCourseNameOption()
      this.$common.logData(this.tempSelectedMonthPass, 'Selected 月票')
      if (this.tempSelectedMonthPass.type === 'months' && !this.addCourseFilter.selectedMonth) return
      this.searchCourses()
    },

    // -- 報讀新課程 (報名)
    async handleMonthPassLessonSelected(lesson_id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      this.$store.dispatch('setLoading', true)
      try {
        const targetLesson = this.searchTableData.find(el => el.id === lesson_id)
        const foundPos = this.searchTableSelectedRow.findIndex(el => el.id === lesson_id)

        let selectedLessons = []
        if (this.addCourseFilter.packageLessonRule === 'manually') {
          // 手動選擇報讀課堂
          const foundTemp = this.tempSelectedLesson.findIndex(el => el.id === lesson_id)

          if (foundPos > -1) {
            this.searchTableSelectedRow.splice(foundPos, 1)
            if (foundTemp > -1) {
              this.tempSelectedLesson.splice(foundTemp, 1)
            }
          } else {
            this.searchTableSelectedRow.push(targetLesson)
            if (foundTemp < 0) {
              this.tempSelectedLesson.push(targetLesson)
            }
          }
          selectedLessons = [...this.tempSelectedLesson]
        } else {
          // 自動報讀
          if (foundPos > -1) {
            this.searchTableSelectedRow.splice(foundPos, 1)
            for (let i = this.tempSelectedLesson.length - 1; i >= 0; i--) {
              if (this.tempSelectedLesson[i].course_code === targetLesson.course_code) {
                this.tempSelectedLesson.splice(i, 1)
              }
            }
          } else {
            const foundSameCourse = this.searchTableSelectedRow.findIndex(
              el => el.course_code === targetLesson.course_code,
            )
            if (foundSameCourse > -1) {
              this.searchTableSelectedRow.splice(foundSameCourse, 1)
            }
            this.searchTableSelectedRow.push(targetLesson)
          }

          // 搵related lesson
          selectedLessons = await this._getAutoLessonPreview()

          if (this.$validate.DataValid(this.orderId)) {
            this.searchTableSelectedRow.forEach(item => {
              const aDate = this.$formatter.convertDate(item.date, item.start_time)
              this.orderData.lesson_datas.forEach(el => {
                if (el.course_code === item.course_code) {
                  const found = selectedLessons.find(elm => elm.id === el.id)
                  if (!found) {
                    const bDate = this.$formatter.convertDate(el.date, el.start_time)
                    if (
                      (item.date === el.date && item.start_time === el.start_time) ||
                      bDate.getTime() >= aDate.getTime()
                    ) {
                      selectedLessons.push(el)
                    }
                  }
                }
              })
            })
          }
        }

        if (this.searchTableSelectedRow.length) {
          this.searchTableSelectedRow.sort((a, b) =>
            this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`),
          )
          // 攞係日期範圍內的lesson
          let start = ''
          if (this.tempSelectedMonthPass.type === 'months') {
            if (this.addCourseFilter.selectedMonth) {
              start = `${this.addCourseFilter.selectedMonth}-01`
            }
          } else {
            start = this.searchTableSelectedRow[0].date
          }
          const { min, max } = this._getMonthPassMinMaxDate(this.tempSelectedMonthPass, start)
          if (min && max) {
            const minDateNode = this.$formatter.convertDate(min)
            const maxDateNode = this.$formatter.convertDate(max)
            selectedLessons = selectedLessons.filter(el => {
              const selectedDate = this.$formatter.convertDate(el.date)
              return (
                this.$validate.isDateEqual(selectedDate, minDateNode) ||
                this.$validate.isDateEqual(selectedDate, maxDateNode) ||
                (this.$validate.isDateGreater(selectedDate, minDateNode) &&
                  this.$validate.isDateLess(selectedDate, maxDateNode))
              )
            })
          }
        }

        this.tempSelectedLesson = JSON.parse(JSON.stringify(selectedLessons))
        this.tempSelectedLesson.sort((a, b) =>
          this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`),
        )
      } catch (err) {
        this.$common.error(err)
      } finally {
        this.$store.dispatch('setLoading', false)

        // check 跟揀咗第一堂，filter走唔係範圍內嘅lesson
        const selectedLessonIds = this.tempSelectedLesson.map(el => el.id)
        for (let i = this.searchTableSelectedRow.length - 1; i >= 0; i--) {
          if (!selectedLessonIds.includes(this.searchTableSelectedRow[i].id)) {
            this.searchTableSelectedRow.splice(i, 1)
          }
        }

        // 將範圍內之後嘅lesson暫時disable唔比揀。如果月票係type "months"，唔係該月份嘅唔比揀
        let maxDate = null
        let minDate = null
        if (this.searchTableSelectedRow.length) {
          let start = ''
          if (this.tempSelectedMonthPass.type === 'months') {
            if (this.addCourseFilter.selectedMonth) {
              start = `${this.addCourseFilter.selectedMonth}-01`
            }
          } else {
            start = this.searchTableSelectedRow[0].date
          }

          const { min, max } = this._getMonthPassMinMaxDate(this.tempSelectedMonthPass, start)
          if (min && max) {
            maxDate = this.$formatter.convertDate(max)
            minDate = this.$formatter.convertDate(min)
          }
        }
        for (let i = 0; i < this.searchTableData.length; i++) {
          this.searchTableData[i].temp_disabled = false

          if (
            this.tempSelectedMonthPass.type === 'months' &&
            minDate !== null &&
            this.$validate.isDateLess(this.$formatter.convertDate(this.searchTableData[i].date), minDate)
          ) {
            this.searchTableData[i].temp_disabled = true
          }

          if (
            maxDate !== null &&
            this.$validate.isDateGreater(this.$formatter.convertDate(this.searchTableData[i].date), maxDate)
          ) {
            this.searchTableData[i].temp_disabled = true
          }
        }

        this.$common.logData(this.searchTableSelectedRow, 'searchTableSelectedRow')
        this.$common.logData(this.tempSelectedLesson, 'Selected Lessons')
      }
    },
    onMonthPassMonthChanged() {
      if (this.tempSelectedMonthPass) {
        // reset start_date & end_date
        const start = `${this.addCourseFilter.selectedMonth}-01`
        const { min, max } = this._getMonthPassMinMaxDate(this.tempSelectedMonthPass, start)
        if (min && max) {
          this.addCourseFilter.dateRange = [min, max]
        }

        this.tempSelectedLesson = []
        this.searchTableSelectedRow = []
        this._openSearchMonthPassCourse()
      }
    },
    // -- (報名 - 確認)
    async handleMonthPassLessonConfirm(skip = false) {
      if (this.tempSelectedMonthPass.type === 'months' && this.$refs && this.$refs.monthPassForm) {
        const validate = await this.$refs.monthPassForm.validate()
        if (!validate) return
      }

      if (skip === true) {
        this.tempSelectedLesson = []
      } else {
        if (this.tempSelectedLesson.length < 1) {
          this.$store.dispatch('toggleSnack', {
            message: 'message.atLeastOneLesson',
            type: 'error',
          })
          return
        }
      }

      let foundIndex = -1
      for (let i = 0; i < this.monthPassTableData.length; i++) {
        if (
          this.monthPassTableData[i].month_pass_id === this.tempSelectedMonthPass.id &&
          this.monthPassTableData[i].order_type === 'month_pass' &&
          this.monthPassTableData[i].order_id === -1
        ) {
          foundIndex = i
          break
        }
      }

      let newMonthPass = this.parseMonthPassTableData({
        ...this.tempSelectedMonthPass,
        select_rule: this.addCourseFilter.packageLessonRule,
        select_month: this.addCourseFilter.selectedMonth,
        discount_type: foundIndex > -1 ? this.monthPassTableData[foundIndex].discount_type : '',
        discount_value: foundIndex > -1 ? this.monthPassTableData[foundIndex].discount_value : null,
        discount_price: foundIndex > -1 ? this.monthPassTableData[foundIndex].discount_price : null,
        from_order: this.monthPassTableData[foundIndex]?.from_order || false,
        order_qty: this.monthPassTableData[foundIndex]?.order_qty || 1,
      })

      if (foundIndex > -1) {
        newMonthPass['id'] = this.monthPassTableData[foundIndex].id
        this.$set(this.monthPassTableData, foundIndex, newMonthPass)
      } else {
        this.addItemToGroup(this.monthPassTableData, newMonthPass)
        this.monthPassSelectedRow.push({ id: newMonthPass.id })
      }

      const newMonthPassItems = this.monthPassTableData.filter(
        el => el.order_type === 'month_pass' && el.order_id === -1,
      )
      for (let i = 0; i < newMonthPassItems.length; i++) {
        const found = this.monthPassTableData.find(el => el.id === newMonthPassItems[i].id)
        found.select_month = newMonthPass.select_month
        found.select_rule = newMonthPass.select_rule
      }

      for (let i = this.monthPassSelectedRow.length - 1; i >= 0; i--) {
        const found = this.monthPassTableData.find(el => el.id === this.monthPassSelectedRow[i].id)
        if (found && found.order_id !== -1 && found.order_id !== -4 && found.order_id !== -5) {
          this.monthPassSelectedRow.splice(i, 1)
        }
      }

      // 重新分配過曬啲date
      this._reallocateMonthPassLessons(this.tempSelectedLesson)
      this._resetMonthPassRowDeleteBtn()
      this.$refs.addCourseDialog.hide()
      this.$refs.editFormDialog.hide()
      this.$common.logData(this.monthPassTableData, 'monthPassTableData')
    },

    // -- 修改項目資料 (選擇課堂)
    _openMonthPassEditLesson() {
      const id = this.$refs.editFormDialog.getInfo()
      if (this.$validate.DataValid(id)) {
        const found = this.monthPassTableData.find(el => el.id === id)
        if (found) {
          this.tempSelectedMonthPass = {
            rowId: id,
            id: found.month_pass_id,
            item_name: found.item_name,
            type: found.type,
            days: found.days,
            unit_price: found.unit_price,
            selected_lessons: [...found.lesson_data_list],
            qty: found.qty,
          }

          this.clearAddCourseFilter()
          this.addCourseFilter.packageLessonRule = found.select_rule
          if (found.type === 'months') {
            this.addCourseFilter.selectedMonth = found.select_month
          }
          const { min, max } = this._getMonthPassMinMaxDate()
          if (min && max) {
            this.addCourseFilter.dateRange = [min, max]
          }
          this.tempSelectedLesson = []

          const newMonthPassItems = this.monthPassTableData.filter(
            el => el.order_type === 'month_pass' && el.order_id === -1,
          )
          for (let i = 0; i < newMonthPassItems.length; i++) {
            this.tempSelectedLesson = this.tempSelectedLesson.concat(newMonthPassItems[i].lesson_data_list)
            if (found.select_rule === 'auto') {
              for (let j = 0; j < newMonthPassItems[i].lesson_data_list.length; j++) {
                const foundSameCourse = this.searchTableSelectedRow.find(
                  el =>
                    el.course_id === newMonthPassItems[i].lesson_data_list[j].course_id &&
                    el.course_code === newMonthPassItems[i].lesson_data_list[j].course_code,
                )
                if (!foundSameCourse) {
                  this.searchTableSelectedRow.push(newMonthPassItems[i].lesson_data_list[j])
                }
              }
            } else {
              this.searchTableSelectedRow = this.searchTableSelectedRow.concat(newMonthPassItems[i].lesson_data_list)
            }
          }

          this._openSearchMonthPassCourse()
        }
      }
    },

    // ============ 報讀月票 ==============
    parseAssignLessonTableData(item, lessonData = []) {
      this.rowId += 1

      const selected_lessons = JSON.parse(JSON.stringify(lessonData))
      let monthLabels = []
      selected_lessons.forEach(el => {
        const label = `${el.date.substring(0, 4)}/${el.date.substring(5, 7)}`
        if (!monthLabels.includes(label)) {
          monthLabels.push(label)
        }
      })
      return {
        id: this.rowId,
        item_name: item.course_name,
        lesson_type: item.lesson_type,
        lesson_data_list: lessonData,
        // lessons_price4: selected_lessons.map(el => el.price),
        selected_lesson_id_list: selected_lessons.map(el => el.id),
        month_label: monthLabels.join('\n'),
        dates: selected_lessons.map(el => el.date),
        qty: selected_lessons.length,
        order_id: -1,
        order_type: 'assign_month_pass',
      }
    },

    formatMonthPassDate(date) {
      return date ? `${date.substring(8, 10)}/${date.substring(5, 7)}/${date.substring(0, 4)}` : ''
    },
    _getExistMonthPassTableData() {
      const startIndex = (this.existMonthPass.page - 1) * this.existMonthPass.limit
      const endIndex = startIndex + this.existMonthPass.limit
      this.existMonthPass.tableData = []
      for (let i = startIndex; i < endIndex; i++) {
        if (this.existMonthPass.allData[i]) {
          this.existMonthPass.tableData.push(this.existMonthPass.allData[i])
        }
      }
    },

    // -- (報讀課程)
    openAssignMonthPass(id = null) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      this.tempSelectedLesson = []
      this.clearAddCourseFilter()

      if (id !== null) {
        const found = this.existMonthPass.tableData.find(el => el.id === id)
        if (found) {
          if (found.dates.length) {
            this.addCourseFilter.dateRange = [found.dates[0].start_date, found.dates[found.dates.length - 1].end_date]
          }
        }
      }

      // -- reset table
      this.searchFilter.page = 1
      this.searchTableTotal = 0
      this.searchTableData = []

      // -- reset course search
      this.addCourseFilter.type = 'singleDate'

      this.searchTableData = []
      this.openSearchCourse()
    },
    // -- 報讀新課程 (報名)
    async handleAssignLessonSelected(lesson_id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      this.$store.dispatch('setLoading', true)
      try {
        const targetLesson = this.searchTableData.find(el => el.id === lesson_id)
        const foundPos = this.searchTableSelectedRow.findIndex(el => el.id === lesson_id)

        let selectedLessons = []
        if (this.addCourseFilter.packageLessonRule === 'manually') {
          // 手動選擇報讀課堂
          const foundTemp = this.tempSelectedLesson.findIndex(el => el.id === lesson_id)
          if (foundPos > -1) {
            this.searchTableSelectedRow.splice(foundPos, 1)
            if (foundTemp > -1) {
              this.tempSelectedLesson.splice(foundTemp, 1)
            }
          } else {
            this.searchTableSelectedRow.push(targetLesson)
            if (foundTemp < 0) {
              this.tempSelectedLesson.push(targetLesson)
            }
          }
          selectedLessons = [...this.tempSelectedLesson]
        } else {
          // 自動報讀
          if (foundPos > -1) {
            this.searchTableSelectedRow.splice(foundPos, 1)

            for (let i = this.tempSelectedLesson.length - 1; i >= 0; i--) {
              if (this.tempSelectedLesson[i].course_code === targetLesson.course_code) {
                this.tempSelectedLesson.splice(i, 1)
              }
            }
          } else {
            const foundSameCourse = this.searchTableSelectedRow.findIndex(
              el => el.course_code === targetLesson.course_code,
            )
            if (foundSameCourse > -1) {
              this.searchTableSelectedRow.splice(foundSameCourse, 1)
            }
            this.searchTableSelectedRow.push(targetLesson)
          }

          // 搵related lesson
          selectedLessons = await this._getAutoLessonPreview()
        }

        selectedLessons = selectedLessons.filter(el => this.otherMonthPassLessonDates.includes(el.date))
        this.tempSelectedLesson = JSON.parse(JSON.stringify(selectedLessons))
        this.tempSelectedLesson.sort((a, b) =>
          this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`),
        )
      } catch (err) {
        this.$common.error(err)
      } finally {
        this.$store.dispatch('setLoading', false)
        this.$common.logData(this.searchTableSelectedRow, 'searchTableSelectedRow')
        this.$common.logData(this.tempSelectedLesson, 'Selected Lessons')
      }
    },
    // -- (報名 - 確認)
    handleAssignLessonConfirm() {
      if (this.searchTableSelectedRow.length < 1) {
        this.$store.dispatch('toggleSnack', {
          message: 'message.atLeastOneLesson',
          type: 'error',
        })
        return
      }

      let groups = []
      this.tempSelectedLesson.forEach(lesson => {
        let insert = false
        for (let i = 0; i < this.assignLessonTableData.length; i++) {
          if (
            this.assignLessonTableData[i].lesson_data_list[0].course_id === lesson.course_id &&
            this.assignLessonTableData[i].lesson_data_list[0].course_code === lesson.course_code
          ) {
            const foundExist = this.assignLessonTableData[i].lesson_data_list.find(el => el.id === lesson.id)
            if (!foundExist) {
              this.assignLessonTableData[i].lesson_data_list.push(lesson)
            }
            if (!this.assignLessonTableData[i].selected_lesson_id_list.includes(lesson.id)) {
              this.assignLessonTableData[i].selected_lesson_id_list.push(lesson.id)
            }
            insert = true
            break
          }
        }

        if (!insert) {
          const found = groups.find(
            lessons => lessons[0].course_id === lesson.course_id && lessons[0].course_code === lesson.course_code,
          )
          if (found) {
            found.push(lesson)
          } else {
            groups.push([lesson])
          }
        }
      })

      if (groups.length) {
        groups.forEach(lessons => {
          const newItem = this.parseAssignLessonTableData(lessons[0], lessons)
          this.addItemToGroup(this.assignLessonTableData, newItem)
          this.assignLessonSelectedRow.push({ id: newItem.id })
        })
      }

      for (let i = 0; i < this.assignLessonTableData.length; i++) {
        this.assignLessonTableData[i].lesson_data_list.sort((a, b) =>
          this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`),
        )
        const monthLabels = []
        this.assignLessonTableData[i].dates = []
        this.assignLessonTableData[i].lesson_data_list.forEach(lesson => {
          if (this.assignLessonTableData[i].selected_lesson_id_list.includes(lesson.id)) {
            this.assignLessonTableData[i].dates.push(lesson.date)
            const label = `${lesson.date.substring(0, 4)}/${lesson.date.substring(5, 7)}`
            if (!monthLabels.includes(label)) {
              monthLabels.push(label)
            }
          }
        })

        this.assignLessonTableData[i].month_label = monthLabels.join('\n')
        this.assignLessonTableData[i].qty = this.assignLessonTableData[i].selected_lesson_id_list.length
      }

      this.$common.logData(this.assignLessonTableData, 'assignLessonTableData')

      this.$refs.addCourseDialog.hide()
    },

    // -- 確認
    async handleAssignLessonSubmit() {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      this.$store.dispatch('setLoading', true)
      // 如果冇揀到item，reject
      if (this.assignLessonSelectedRow.length < 1) {
        this.showAlert({
          title: 'message.operationalError',
          message: 'message.atLeastOneItem',
          isError: true,
        })
        this.$store.dispatch('setLoading', false)
        return
      }

      try {
        const lessonIds = this.assignLessonTableData.reduce((list, item) => {
          return list.concat(item.selected_lesson_id_list)
        }, [])
        await this.$Fetcher.AddStudentToLessonWithMonthPass(this.studentData.student_id, lessonIds)
        this.$store.dispatch('setLoading', false)
        this.$store.dispatch('toggleSnack', {
          message: 'message.saveSuccess',
          type: 'success',
          refresh: true,
        })
      } catch (err) {
        this.$common.error(err)
        this.$store.dispatch('setLoading', false)
        this.showAlert({
          title: 'message.saveFail',
          message: err,
          isError: true,
        })
      }
    },

    // ========== 待付款/待審核訂單 =========
    resetPage() {
      this.paymentTypeTab = 'tab_course'
      this.paymentItemTab = 'tab_course'
      if (this.displayTabs.length) {
        this.paymentTypeTab = `tab_${this.displayTabs[0]}`
        this.paymentItemTab = `tab_${this.displayTabs[0]}`
      }
      this.formData.is_redeem = false
      this.formData.discount_type = ''
      this.formData.discount_value = ''
      this.formData.status = 'paid'
      if (this.isAppMode(['T49', 'T75'])){
        this.formData.status = 'pending'
      }
      this.formData.payment_method = 'cash'
      this.formData.payment_images = []
      this.formData.remark = ''
      this.formData.pdf_remark = ''
      this.formData.sign = ''
      this.formData.order_create_date = ''
      this.formData.order_create_time = ''
      this.formData.pay_date = ''
      this.formData.pay_time = ''
      this.formData.subtotal = 0
      this.formData.custom_invoice_number = ''
      this.formData.discount_method = 'manually'
      this.formData.discount_coupon_code = null
      this.appliedCoupon = null
      this.couponOptions = []

      this.courseTableData = []
      this.courseSelectedRow = []
      this.nextPreviewOrder = null
      this.nextPreviewOrderAdd = 1
      this.prevPreviewOrder = null

      this.productTableData = []
      this.productSelectedRow = []

      this.packageTableData = []
      this.packageSelectedRow = []

      this.monthPassTableData = []
      this.monthPassSelectedRow = []
      this.otherMonthPassLessonDates = []
      this.existMonthPass.tableData = []
      this.existMonthPass.limit = this.isAppMode(['T37', 'T40', 'T45']) ? 20 : 5
      this.existMonthPass.page = 1
      this.existMonthPass.total = 0
      this.existMonthPass.allData = []
      this.assignLessonTableData = []
      this.assignLessonSelectedRow = []

      this.unpaidTableData = []

      this.onlineCourseTableData = []
      this.onlineCourseSelectedRow = []

      this.orderData.order_code = ''
      this.orderData.status = ''
      this.orderData.order_type = []
      this.orderData.unpaid_lesson_datas = []
      this.orderData.except_lesson_id_list = []
      this.orderData.custom_items = []
      this.orderData.lesson_list = []
      this.orderData.lesson_datas = []
      this.orderData.package_list = []
      this.orderData.product_list = []
      this.orderData.month_pass_list = []
      this.orderData.month_pass_selected_months = []
      this.orderData.discount_type = ''
      this.orderData.discount_value = ''
      this.orderData.is_redeem = false
      this.orderData.order_date = ''
      this.orderData.pay_date = ''
      this.orderData.debit_amount = 0
      this.orderData.real_subtotal = 0
      this.totalAmountInit = false
    },
    disableTab(type) {
      if (this.$store.getters.isLoading) return true

      if (this.$validate.DataValid(this.orderId)) {
        if (this.orderData.order_type.includes('skip') && type !== 'course') return true
        return (
          (this.orderData.order_type.includes('course') ||
            this.orderData.order_type.includes('package') ||
            this.orderData.order_type.includes('month_pass') ||
            this.orderData.order_type.includes('online_course')) &&
          !this.orderData.order_type.includes(type)
        )
      }

      return false
    },
    // -- (修改訂單)
    openEditOrder(id) {
      this.$router.replace({ query: { order: id } })
      this.getOrderById()
    },
    async getOrderById() {
      this.tableLoading = true
      this.resetPage()
      try {
        if (!this.canEditOrder) {
          throw 'message.noPermission'
        }
        const data = await this.$Fetcher.GetOrderById(this.orderId)
        if (data.student_id !== this.id) {
          throw 'message.orderStudentNotMatch'
        }
        if (data.status === 'void' || data.status === 'cancelled') {
          throw 'message.orderAlreadyVoid'
        }

        for (const key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            if (key === 'discount_value' && data['discount_type'] === 'percentage') {
              this.formData['discount_value'] = 100 - data['discount_value']
            } else {
              this.formData[key] = data[key]
            }
          }
        }
        if (data.payment_image_list.length) {
          this.formData.payment_images = data.payment_image_list.map(file => {
            return { file: file, name: file }
          })
        }
        this.formData.order_create_date = data.order_date.substring(0, 10)
        this.formData.order_create_time = data.order_date.substring(11, 16)
        this.formData.pay_date = data.pay_date.substring(0, 10)
        this.formData.pay_time = data.pay_date.substring(11, 16)
        if (data.coupon_data) {
          this.formData.discount_method = 'code'
          this.formData.discount_coupon_code = data.coupon_data.code
          this.appliedCoupon = await this._getOrderCoupon(data.coupon_data.id)
          if (!this.appliedCoupon) {
            this.appliedCoupon = data.coupon_data
          }
          await this.searchCoupons()
          const foundCoupon = this.couponOptions.find(el => el.value === data.coupon_data.code)
          if (!foundCoupon) {
            this.couponOptions.push({
              value: this.appliedCoupon.code,
              text: `${this.appliedCoupon.name} (${this.appliedCoupon.code})`,
            })
          }
        }

        for (const key in this.orderData) {
          if (this.$validate.DataValid(data[key])) {
            if (this.$validate.DataValid(data[key])) {
              if (key === 'discount_value' && data['discount_type'] === 'percentage') {
                this.orderData['discount_value'] = 100 - data['discount_value']
              } else {
                this.orderData[key] = data[key]
              }
            }
          }
        }
        this.orderData.order_code = await this.gfGenerateOrderId(data)

        let foundTab = 'tab_course'
        if (data.order_type.includes('course')) {
          foundTab = 'tab_course'

          // 分group
          const group = []
          for (let i = 0; i < data.lesson_list.length; i++) {
            const foundLesson = data.lesson_datas.find(el => el.id === data.lesson_list[i].id)
            if (foundLesson) {
              let insert = false
              const obj = {
                ...foundLesson,
                discount_type: data.lesson_list[i].discount_type,
                discount_value: data.lesson_list[i].discount_value,
                unit_price: foundLesson.price,
              }
              if (this.$validate.DataValid(obj['discount_type']) && this.$validate.DataValid(obj['discount_value'])) {
                if (obj['discount_type'] === 'percentage') {
                  obj['discount_value'] = 100 - obj['discount_value']
                }
              }

              if (foundLesson.lesson_type === 'regular') {
                for (let j = 0; j < group.length; j++) {
                  if (
                    group[j][0].lesson_type === 'regular' &&
                    group[j][0].regular_id === foundLesson.regular_id &&
                    group[j][0].price === foundLesson.price &&
                    group[j][0].discount_type === obj.discount_type &&
                    group[j][0].discount_value === obj.discount_value
                  ) {
                    // 調堂之後啲price有可能唔同
                    group[j].push(obj)
                    insert = true
                  }
                }
              }
              if (!insert) {
                group.push([obj])
              }
            }
          }

          for (let i = 0; i < group.length; i++) {
            let newItem = this.parseCourseTableData(group[i][0], group[i], true, false)
            newItem.trial_lesson_ids = data.trial_lesson.filter(lessonId =>
              newItem.selected_lesson_id_list.includes(lessonId),
            )
            this.addItemToGroup(this.courseTableData, newItem)
            this.courseSelectedRow.push({ id: newItem.id })
          }
        } else if (data.order_type.includes('package')) {
          foundTab = 'tab_package'
          const unpaidLesson = data.unpaid_lesson_datas.sort((a, b) =>
            this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`),
          )
          const newLesson = data.lesson_datas.sort((a, b) =>
            this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`),
          )
          let selectedLessons = [...unpaidLesson, ...newLesson]

          for (let i = 0; i < data.package_list.length; i++) {
            const foundPackage = data.package_datas.find(el => el.id === data.package_list[i].id)
            if (foundPackage) {
              const obj = {
                ...foundPackage,
                discount_type: data.package_list[i].discount_type,
                discount_value: data.package_list[i].discount_value,
                item_name: foundPackage.name,
                unit_price: foundPackage.price,
                selected_lessons: [],
              }
              if (this.$validate.DataValid(obj['discount_type']) && this.$validate.DataValid(obj['discount_value'])) {
                if (obj['discount_type'] === 'percentage') {
                  obj['discount_value'] = 100 - obj['discount_value']
                }
              }

              if (i !== data.package_list.length - 1) {
                obj['selected_lessons'] = selectedLessons.splice(0, foundPackage.lesson_count)
              } else {
                obj['selected_lessons'] = [...selectedLessons]
              }
              obj['selected_lessons'].sort((a, b) =>
                this.$formatter.sortDate(`${a.date}T${a.start_time}:00Z`, `${b.date}T${b.start_time}:00Z`),
              )

              const newItem = this.parsePackageTableData(obj)
              this.addItemToGroup(this.packageTableData, newItem)
              this.packageSelectedRow.push({ id: newItem.id })
            }
          }
        } else if (data.order_type.includes('month_pass')) {
          foundTab = 'tab_month_pass'
          const group = []
          for (let i = 0; i < data.month_pass_list.length; i++) {
            const foundInGroup = group.find(el => el.id === data.month_pass_list[i].id)
            if (foundInGroup) {
              foundInGroup.qty += 1
            } else {
              const found = data.month_pass_datas.find(el => el.id === data.month_pass_list[i].id)
              const obj = {
                ...found,
                discount_type: data.month_pass_list[i].discount_type,
                discount_value: data.month_pass_list[i].discount_value,
                qty: 1,
                item_name: found.name,
                unit_price: found.price,
                select_rule: 'manually',
                select_month: data.month_pass_selected_months.length ? data.month_pass_selected_months[0] : '',
                from_order: true,
              }
              if (this.$validate.DataValid(obj['discount_type']) && this.$validate.DataValid(obj['discount_value'])) {
                if (obj['discount_type'] === 'percentage') {
                  obj['discount_value'] = 100 - obj['discount_value']
                }
              }
              group.push(obj)
            }
          }
          for (let i = 0; i < group.length; i++) {
            group[i].order_qty = group[i].qty
            const newItem = this.parseMonthPassTableData(group[i])
            this.addItemToGroup(this.monthPassTableData, newItem)
            this.monthPassSelectedRow.push({ id: newItem.id })
          }

          this._reallocateMonthPassLessons(data.lesson_datas)
          this._resetMonthPassRowDeleteBtn()
          this.$common.logData(this.monthPassTableData, 'monthPassTableData')
        } else if (data.order_type.includes('online_course')) {
          foundTab = 'tab_online_course'

          this.rowId += 1
          const newItem = {
            id: this.rowId,
            order_type: 'online_course',
            item_name: data.online_course_data ? data.online_course_data.name : '',
            unit_price: data.online_course_data
              ? data.online_course_data.discount_price || data.online_course_data.price
              : 0,
            qty: 1,
            total: data.online_course_data
              ? data.online_course_data.discount_price || data.online_course_data.price
              : 0,
            order_id: -1,
          }
          this.onlineCourseTableData = [newItem]
          this.onlineCourseSelectedRow = [{ id: newItem.id }]
        }

        if (data.order_type.includes('custom')) {
          for (let i = 0; i < data.custom_items.length; i++) {
            const newItem = this.parseCustomItemTableData({
              ...data.custom_items[i],
              unit_price: data.custom_items[i].price,
              qty: data.custom_items[i].amount,
            })
            this.addItemToGroup(this.courseTableData, newItem)
            this.courseSelectedRow.push({ id: newItem.id })
            this.addItemToGroup(this.packageTableData, newItem)
            this.packageSelectedRow.push({ id: newItem.id })
            this.addItemToGroup(this.monthPassTableData, newItem)
            this.monthPassSelectedRow.push({ id: newItem.id })
          }
        }

        if (data.order_type.includes('product')) {
          for (let i = 0; i < data.product_list.length; i++) {
            const foundProduct = data.product_datas.find(el => el.id === data.product_list[i].id)
            if (foundProduct) {
              const obj = {
                ...foundProduct,
                discount_type: data.product_list[i].discount_type,
                discount_value: data.product_list[i].discount_value,
                qty: data.product_list[i].amount,
                item_name: foundProduct.name,
                unit_price: foundProduct.price,
              }
              if (this.$validate.DataValid(obj['discount_type']) && this.$validate.DataValid(obj['discount_value'])) {
                if (obj['discount_type'] === 'percentage') {
                  obj['discount_value'] = 100 - obj['discount_value']
                }
              }
              const newItem = this.parseProductTableData(obj)
              this.addItemToGroup(this.productTableData, newItem)
              this.productSelectedRow.push({ id: newItem.id })
            }
          }
        }

        if (data.order_type.includes('skip')) {
          for (let i = 0; i < data.skip_lessons.length; i++) {
            const foundLesson = data.skip_lessons_data.find(el => el.id === data.skip_lessons[i])
            if (foundLesson) {
              const newItem = this.parseSkipToLessonData(foundLesson)
              this.addItemToGroup(this.courseTableData, newItem)
              this.courseSelectedRow.push({ id: newItem.id })
            }
          }
        }

        this.paymentTypeTab = foundTab
        this.paymentItemTab = foundTab

        this.tableLoading = false
      } catch (err) {
        this.$common.error(err)
        this.$store.dispatch('toggleSnack', { type: 'error', message: err })
        this.$store.dispatch('toggleLoadingPage', false)
        this.handleCancelUpdateOrder()
      } finally {
        this.totalAmountInit = false
      }
    },
    async _getOrderCoupon(id) {
      try {
        const data = await this.$Fetcher.GetCouponById(id)
        return data
      } catch {}

      return null
    },
    // -- (取消更改訂單)
    handleCancelUpdateOrder() {
      this.resetPage()
      this.$router.replace({ query: {} })
      this.getPreviews()
    },

    // -- (作廢發票)
    async handleVoidOrder(orderId) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({
        title: 'message.confirmVoid',
        message: 'message.confirmVoidMsg',
      })
      if (confirm) {
        // this.$store.dispatch('setLoading', true)
        
          const quitConfirm = await this.confirmRef.show({
            title: 'message.quitAfterLesson',
            message: 'message.quitAfterLessonMsg',
            cancelBtnText: 'message.notQuitText',
            confirmBtnText: 'message.quitText',
          })
          if (quitConfirm) {
            this.$store.dispatch('setLoading', true)
            try {
              await this.$Fetcher.VoidOrder(orderId, true)
              this.$store.dispatch('setLoading', false)
              this.$store.dispatch('toggleSnack', {
                message: 'message.voidSuccess',
                type: 'success',
                refresh: true,
              })
              this.$router.go()
              // this.getOrderData(false)
            } catch (err) {
              this.$store.dispatch('setLoading', false)
              this.showAlert({
                title: 'message.voidFail',
                message: err,
                isError: true,
              })
            }
          }else{
            this.$store.dispatch('setLoading', true)
            try {
              await this.$Fetcher.VoidOrder(orderId)
              this.$store.dispatch('setLoading', false)
              this.$store.dispatch('toggleSnack', {
                message: 'message.voidSuccess',
                type: 'success',
                refresh: true,
              })
              this.$router.go()
              // this.getOrderData(false)
            } catch (err) {
              this.$store.dispatch('setLoading', false)
              this.showAlert({
                title: 'message.voidFail',
                message: err,
                isError: true,
              })
            }
          }

        // try {
        //   await this.$Fetcher.VoidOrder(orderId)
        //   this.$store.dispatch('setLoading', false)
        //   this.$store.dispatch('toggleSnack', {
        //     message: 'message.voidSuccess',
        //     type: 'success',
        //     refresh: true,
        //   })
        // } catch (err) {
        //   this.$store.dispatch('setLoading', false)
        //   this.showAlert({
        //     title: 'message.voidFail',
        //     message: err,
        //     isError: true,
        //   })
        // }
      }
    },

    // ============== 簽署 ================
    openSignPad() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      this.$refs.signaturePadDialog.show()
    },
    viewSign(sign) {
      if (sign.indexOf('data:image') > -1) {
        this.$store.dispatch('openMediaPopup', { media: sign })
      } else {
        this.$store.dispatch('openMediaPopup', { media: `${this.$mediaPath}${sign}` })
      }
    },
    onSignSubmit(sign) {
      this.formData.sign = sign
    },
    uploadSign(sign) {
      return new Promise(async (resolve, reject) => {
        if (sign) {
          if (sign.indexOf('data:image') > -1) {
            const payload = {
              upload_data: sign,
              upload_file_type: 'png',
            }
            try {
              const data = await this.$Fetcher.UploadFile(payload)
              resolve(data)
            } catch (err) {
              this.$common.error(err)
              resolve(false)
            }
          } else {
            resolve(sign)
          }
        } else {
          resolve('')
        }
      })
    },

    // =============== 付款 ================
    async handlePaymentSubmit() {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const checkSchool = await this.gfCheckSchoolSelected()
      if (!checkSchool) return

      // 如果payment method係cash又未簽名，reject
      if (this.isAppMode(['T21'])) {
        if (
          !this.formData.sign &&
          !this.formData.is_redeem &&
          this.formData.status !== 'pending' &&
          this.formData.payment_method === 'cash'
        ) {
          this.$store.dispatch('toggleSnack', { message: 'message.signRequired', type: 'error' })
          return
        }
      }

      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      this.$store.dispatch('setLoading', true)

      // 將啲item分返類
      let newItems = []
      let nextMonthItems = []
      let prevUnpaidItems = []
      let customItems = []
      let skipItems = []
      let productSelected = false
      let courseSelected = false
      let packageSelected = false
      let monthPassSelected = false
      let onlineCourseSelected = false

      this.productSelectedRow.forEach(item => {
        const found = this.productTableData.find(el => el.id === item.id)
        if (found) {
          productSelected = true
          if (found.order_id === -1) {
            newItems.push(found)
          }
        }
      })

      if (this.currentTabType === 'course') {
        this.courseSelectedRow.forEach(item => {
          const found = this.courseTableData.find(el => el.id === item.id)
          if (found) {
            courseSelected = true
            if (found.order_id === -5) {
              skipItems.push(found)
            } else if (found.order_id === -4) {
              customItems.push(found)
            } else if (found.order_id === -3) {
              prevUnpaidItems.push(found)
            } else if (found.order_id === -2) {
              nextMonthItems.push(found)
            } else if (found.order_id === -1) {
              newItems.push(found)
            }
          }
        })
      } else if (this.currentTabType === 'package') {
        this.packageSelectedRow.forEach(item => {
          const found = this.packageTableData.find(el => el.id === item.id)
          if (found) {
            packageSelected = true
            if (found.order_id === -4) {
              customItems.push(found)
            } else if (found.order_id === -1) {
              newItems.push(found)
            }
          }
        })

        // -- 如果apply多於一個package，reject
        if (!this.enableMultiPackage) {
          const newPackageItems = newItems.filter(el => el.order_type === 'package')
          if (newPackageItems.length > 1) {
            this.showAlert({
              title: 'message.operationalError',
              message: 'message.onceBuyOnePackage',
              isError: true,
            })
            this.$store.dispatch('setLoading', false)
            return
          }
        }
      } else if (this.currentTabType === 'month_pass') {
        this.monthPassSelectedRow.forEach(item => {
          const found = this.monthPassTableData.find(el => el.id === item.id)
          if (found) {
            monthPassSelected = true
            if (found.order_id === -4) {
              customItems.push(found)
            } else if (found.order_id === -1) {
              newItems.push(found)
            }
          }
        })
      } else if (this.currentTabType === 'online_course') {
        this.onlineCourseSelectedRow.forEach(item => {
          const found = this.onlineCourseTableData.find(el => el.id === item.id)
          if (found) {
            onlineCourseSelected = true
            if (found.order_id === -1) {
              newItems.push(found)
            }
          }
        })
      }

      // 如果冇揀到item，reject
      if (
        !productSelected &&
        ((this.currentTabType === 'course' && !courseSelected) ||
          (this.currentTabType === 'package' && !packageSelected) ||
          (this.currentTabType === 'month_pass' && !monthPassSelected) ||
          (this.currentTabType === 'online_course' && !onlineCourseSelected))
      ) {
        this.showAlert({
          title: 'message.operationalError',
          message: 'message.atLeastOneItem',
          isError: true,
        })
        this.$store.dispatch('setLoading', false)
        return
      }

      // 如果有唔同類型帳單，reject
      let count = 0
      if (newItems.length > 0) count++
      if (nextMonthItems.length > 0) {
        if (this.enableCombineNextAndNew) {
          if (count === 0) count++
        } else if (newItems.length > 0) {
          // check if product, ignore
          const productItems = newItems.filter(el => el.order_type === 'product')
          if (productItems.length !== newItems.length) count++
        } else {
          count++
        }
      }
      if (prevUnpaidItems.length > 0) {
        if (this.enableCombineNextAndUnpaid) {
          if (count === 0) count++

          if (!this.enableCombineUnpaidAndNew && newItems.length > 0) count++
        } else {
          if (this.enableCombineUnpaidAndNew) {
            if (count === 0) count++
          } else {
            count++
          }

          if (customItems.length > 0) count++
        }
      }
      if (count > 1) {
        this.showAlert({
          title: 'message.operationalError',
          message: 'message.onceNewOrEditOrder',
          isError: true,
        })
        this.$store.dispatch('setLoading', false)
        return
      }

      // 如果用積分換領
      if (this.formData.is_redeem) {
        // 如果用積分換領，又唔係新商品item，reject
        const productItems = newItems.filter(el => el.order_type === 'product')
        if (newItems.length < 1 || productItems.length !== newItems.length) {
          this.showAlert({
            title: 'message.operationalError',
            message: 'message.pointsCanOnlyApplyToNewProduct',
            isError: true,
          })
          this.$store.dispatch('setLoading', false)
          return
        }

        // 如果user沒有足夠積分，reject
        if (this.pointsCanUse < this.pointTotalAmount) {
          this.showAlert({
            title: 'message.operationalError',
            message: 'message.userPointsNotEnough',
            isError: true,
          })
          this.$store.dispatch('setLoading', false)
          return
        }
      }

      // 如果check到lesson有重覆，reject
      const courseItems = newItems.filter(el => el.order_type === 'course')
      const selected_lessons = []
      this.repeatLessons = []
      courseItems.forEach(item => {
        item.selected_lesson_id_list.forEach(id => {
          if (selected_lessons.includes(id)) {
            if (!this.repeatLessons.find(el => el.id === id)) {
              const found = item.lesson_data_list.find(el => el.id === id)
              this.repeatLessons.push(found)
            }
          } else {
            selected_lessons.push(id)
          }
        })
      })
      const packageItems = newItems.filter(el => el.order_type === 'package')
      packageItems.forEach(item => {
        item.selected_lesson_id_list.forEach(id => {
          if (selected_lessons.includes(id)) {
            if (!this.repeatLessons.find(el => el.id === id)) {
              const found = item.lesson_data_list.find(el => el.id === id)
              this.repeatLessons.push(found)
            }
          } else {
            selected_lessons.push(id)
          }
        })
      })
      const monthPassItems = newItems.filter(el => el.order_type === 'month_pass')
      monthPassItems.forEach(item => {
        item.selected_lesson_id_list.forEach(id => {
          if (selected_lessons.includes(id)) {
            if (!this.repeatLessons.find(el => el.id === id)) {
              const found = item.lesson_data_list.find(el => el.id === id)
              this.repeatLessons.push(found)
            }
          } else {
            selected_lessons.push(id)
          }
        })
      })
      if (this.repeatLessons.length > 0) {
        this.$refs.repeatLessonDialog.show()
        this.$store.dispatch('setLoading', false)
        return
      }

      this.$common.logData(newItems, 'New Items')
      this.$common.logData(nextMonthItems, 'Next Month Items')
      this.$common.logData(prevUnpaidItems, 'Unpaid Items')
      this.$common.logData(customItems, 'Custom Items')
      this.$common.logData(skipItems, 'Skip Items')

      if (this.$validate.DataValid(this.orderId)) {
        // --- check 洗唔洗renew order
        // course
        let isRenew = false
        if (!this.disabledEditItem) {
          // subtotal
          if (parseFloat(this.orderData.real_subtotal) != parseFloat(this.formData.subtotal)) {
            isRenew = true
          }

          // discount
          if (!isRenew) {
            if (
              (this.orderData.discount_type &&
                this.formData.discount_type &&
                this.orderData.discount_type !== this.formData.discount_type) ||
              (this.orderData.discount_type && !this.formData.discount_type) ||
              (!this.orderData.discount_type && this.formData.discount_type)
            ) {
              isRenew = true
            }
          }
          if (!isRenew) {
            if (
              (this.orderData.discount_value &&
                this.formData.discount_value &&
                this.orderData.discount_value != this.formData.discount_value) ||
              (this.orderData.discount_value && !this.formData.discount_value) ||
              (!this.orderData.discount_value && this.formData.discount_value)
            ) {
              isRenew = true
            }
          }

          // course
          if (!isRenew) {
            const courseItems = newItems.filter(el => el.order_type === 'course')
            if (courseItems.length > 0) {
              if (!this.orderData.order_type.includes('course')) {
                isRenew = true
              } else {
                const new_lesson_list = []
                courseItems.forEach(targetRow => {
                  targetRow.lesson_data_list.forEach(lesson => {
                    if (targetRow.selected_lesson_id_list.includes(lesson.id)) {
                      const get_item = this._getLessonToPayload(targetRow, lesson.id)
                      new_lesson_list.push(get_item)
                    }
                  })
                })
                if (new_lesson_list.length !== this.orderData.lesson_list.length) {
                  isRenew = true
                } else {
                  for (let i = 0; i < new_lesson_list.length; i++) {
                    const found = this.orderData.lesson_list.find(
                      el =>
                        el.id === new_lesson_list[i].id &&
                        el.discount_type === new_lesson_list[i].discount_type &&
                        el.discount_value === new_lesson_list[i].discount_value,
                    )
                    if (!found) {
                      isRenew = true
                      break
                    }
                  }
                }
              }
            } else if (this.orderData.order_type.includes('course')) {
              isRenew = true
            }
          }
          // custom item
          if (!isRenew) {
            if (customItems.length > 0) {
              if (!this.orderData.order_type.includes('custom')) {
                isRenew = true
              } else {
                const new_custom_items = customItems.map(targetRow => {
                  return {
                    name: targetRow.item_name,
                    description: targetRow.item_description,
                    price: parseFloat(targetRow.unit_price),
                    amount: targetRow.qty,
                  }
                })
                if (new_custom_items.length !== this.orderData.custom_items.length) {
                  isRenew = true
                } else {
                  for (let i = 0; i < new_custom_items.length; i++) {
                    const found = this.orderData.custom_items.find(
                      el =>
                        el.name === new_custom_items[i].name &&
                        el.description === new_custom_items[i].description &&
                        el.price === new_custom_items[i].price &&
                        el.amount === new_custom_items[i].amount,
                    )
                    if (!found) {
                      isRenew = true
                      break
                    }
                  }
                }
              }
            } else if (this.orderData.order_type.includes('custom')) {
              isRenew = true
            }
          }
          // package
          if (!isRenew) {
            const packageItems = newItems.filter(el => el.order_type === 'package')
            if (packageItems.length > 0) {
              if (!this.orderData.order_type.includes('package')) {
                isRenew = true
              } else {
                const new_package_list = packageItems.map(targetRow => {
                  const get_item = this._getPackageToPayload(targetRow)
                  return get_item
                })
                if (new_package_list.length !== this.orderData.package_list.length) {
                  isRenew = true
                } else {
                  for (let i = 0; i < new_package_list.length; i++) {
                    const found = this.orderData.package_list.find(
                      el =>
                        el.id === new_package_list[i].id &&
                        el.discount_type === new_package_list[i].discount_type &&
                        el.discount_value === new_package_list[i].discount_value,
                    )
                    if (!found) {
                      isRenew = true
                      break
                    }
                  }
                }

                if (!isRenew) {
                  const old_selected_lesson_ids = [
                    ...this.orderData.unpaid_lesson_datas.map(el => el.id),
                    ...this.orderData.lesson_list.map(el => el.id),
                  ]
                  let new_selected_lesson_ids = []
                  packageItems.forEach(targetRow => {
                    new_selected_lesson_ids = new_selected_lesson_ids.concat(targetRow.selected_lesson_id_list)
                  })
                  if (old_selected_lesson_ids.length !== new_selected_lesson_ids.length) {
                    isRenew = true
                  } else {
                    for (let i = 0; i < new_selected_lesson_ids.length; i++) {
                      if (!old_selected_lesson_ids.includes(new_selected_lesson_ids[i])) {
                        isRenew = true
                        break
                      }
                    }
                  }
                }
              }
            } else if (this.orderData.order_type.includes('package')) {
              isRenew = true
            }
          }
          // month pass
          if (!isRenew) {
            const monthPassItems = newItems.filter(el => el.order_type === 'month_pass')
            if (monthPassItems.length > 0) {
              if (!this.orderData.order_type.includes('month_pass')) {
                isRenew = true
              } else {
                const new_month_pass_list = []
                const new_selected_months = []
                let months = 0
                for (let i = 0; i < monthPassItems.length; i++) {
                  for (let j = 0; j < monthPassItems[i].qty; j++) {
                    const getItem = this._getMonthPassToPayload(monthPassItems[i])
                    new_month_pass_list.push(getItem)
                  }

                  if (monthPassItems[i].type === 'months') {
                    months += monthPassItems[i].qty
                  }
                }
                if (months > 0 && monthPassItems[0].select_month) {
                  let startDate = this.$formatter.convertDate(`${monthPassItems[0].select_month}-01`)
                  for (let i = 0; i < months; i++) {
                    new_selected_months.push(
                      `${startDate.getFullYear()}-${this.$formatter.pad(startDate.getMonth() + 1)}`,
                    )
                    startDate.setMonth(startDate.getMonth() + 1)
                  }
                }
                if (new_month_pass_list.length !== this.orderData.month_pass_list.length) {
                  isRenew = true
                } else {
                  for (let i = 0; i < new_month_pass_list.length; i++) {
                    const found = this.orderData.month_pass_list.find(
                      el =>
                        el.id === new_month_pass_list[i].id &&
                        el.discount_type === new_month_pass_list[i].discount_type &&
                        el.discount_value === new_month_pass_list[i].discount_value,
                    )
                    if (!found) {
                      isRenew = true
                      break
                    }
                  }
                }

                if (!isRenew) {
                  if (new_selected_months.length !== this.orderData.month_pass_selected_months.length) {
                    isRenew = true
                  } else {
                    for (let i = 0; i < new_selected_months.length; i++) {
                      if (new_selected_months[i] !== this.orderData.month_pass_selected_months[i]) {
                        isRenew = true
                        break
                      }
                    }
                  }
                }

                if (!isRenew) {
                  const old_selected_lesson_ids = this.orderData.lesson_list.map(el => el.id)
                  let new_selected_lesson_ids = []
                  monthPassItems.forEach(targetRow => {
                    new_selected_lesson_ids = new_selected_lesson_ids.concat(targetRow.selected_lesson_id_list)
                  })
                  if (old_selected_lesson_ids.length !== new_selected_lesson_ids.length) {
                    isRenew = true
                  } else {
                    for (let i = 0; i < new_selected_lesson_ids.length; i++) {
                      if (!old_selected_lesson_ids.includes(new_selected_lesson_ids[i])) {
                        isRenew = true
                        break
                      }
                    }
                  }
                }
              }
            } else if (this.orderData.order_type.includes('month_pass')) {
              isRenew = true
            }
          }
          // product
          if (!isRenew) {
            const productItems = newItems.filter(el => el.order_type === 'product')
            if (productItems.length > 0) {
              if (!this.orderData.order_type.includes('product')) {
                isRenew = true
              } else {
                const new_product_list = productItems.map(targetRow => {
                  const get_item = this._getProductToPayload(targetRow)
                  return get_item
                })
                if (new_product_list.length !== this.orderData.product_list.length) {
                  isRenew = true
                } else {
                  for (let i = 0; i < new_product_list.length; i++) {
                    const found = this.orderData.product_list.find(
                      el =>
                        el.id === new_product_list[i].id &&
                        el.discount_type === new_product_list[i].discount_type &&
                        el.discount_value === new_product_list[i].discount_value &&
                        el.amount === new_product_list[i].amount,
                    )
                    if (!found) {
                      isRenew = true
                      break
                    }
                  }
                }
              }
            } else if (this.orderData.order_type.includes('product')) {
              isRenew = true
            }
          }
        }

        if (isRenew) {
          await this.renewOrder(this.orderId, newItems, customItems, skipItems)
        } else {
          await this.updateOrder(this.orderId)
        }
        this.$store.dispatch('setLoading', false)
      } else {
        try {
          let uploadedSign = ''
          if (this.isAppMode(['T21'])) {
            if (
              !this.formData.is_redeem &&
              this.formData.status !== 'pending' &&
              this.formData.payment_method === 'cash'
            ) {
              uploadedSign = await this.uploadSign(this.formData.sign)
              if (uploadedSign !== false) {
                this.formData.sign = uploadedSign
              }
            }
          }

          if (nextMonthItems.length) {
            // 如果本期/下期應付項目有未選lesson，問要唔要退堂
            let confirmDropUnselect = false
            if (this.enableSelectDropLesson) {
              const { except_lesson_id_list } = this._getNextMonthOrderLessons(nextMonthItems)
              if (except_lesson_id_list.length > 0) {
                this.$store.dispatch('setLoading', false)
                const confirm = await this.confirmRef.show({
                  message: 'message.confirmRemoveUnselectedLesson',
                  confirmBtnText: 'ignoreDropAndPay',
                  cancelBtnText: 'confirmDrop',
                })
                confirmDropUnselect = !confirm
                this.$store.dispatch('setLoading', true)
              }
            }

            await this.genNextMonthOrder(
              nextMonthItems,
              customItems,
              newItems,
              uploadedSign,
              skipItems,
              confirmDropUnselect,
              prevUnpaidItems,
            )
          } else if (prevUnpaidItems.length) {
            await this.genPrevUnpaidOrder(prevUnpaidItems, customItems, newItems, uploadedSign, skipItems)
          } else if (newItems.length || customItems.length || skipItems.length) {
            await this.makeNewOrder(newItems, customItems, uploadedSign, skipItems)
          }

          this.$store.dispatch('setLoading', false)

          // --------- payment done
          if (this.payDoneAlert.counter !== null) {
            clearInterval(this.payDoneAlert.counter)
          }

          this.payDoneAlert.count = 5
          this.payDoneAlert.message = ''
          let start = this.$formatter.convertDate()
          this.payDoneAlert.counter = setInterval(() => {
            let current = this.$formatter.convertDate()
            let diff = Math.round((current.getTime() - start.getTime()) / 1000)
            this.payDoneAlert.count = 5 - diff
            if (this.payDoneAlert.count < 0) this.payDoneAlert.count = 0

            // 倒數完，留喺頁面
            if (this.payDoneAlert.count <= 0) {
              this.$refs.payDoneAlert.hide()
              clearInterval(this.payDoneAlert.counter)
              this.payDoneAlert.counter = null
              this.resetPage()
              this.getPreviews()
            }
          }, 1000)
          if (this.isAppMode(['T21']) && uploadedSign === false) {
            this.payDoneAlert.message = 'message.paymentSuccessSignFail'
          }
          const confirm = await this.$refs.payDoneAlert.show()
          if (this.payDoneAlert.count > 0) {
            this.$refs.payDoneAlert.hide()
            clearInterval(this.payDoneAlert.counter)
            this.payDoneAlert.counter = null
            if (confirm === true) {
              // 留喺頁面
              this.resetPage()
              this.getPreviews()
            } else if (confirm === false) {
              // go order list
              this.$router.push({ name: 'OrderList', params: { sid: this.id } })
            }
          }

          // --------- End of payment done
        } catch (err) {
          this.showAlert({
            title: 'message.paymentFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },

    _getExceptLessons(selectedLessonIds, lesson) {
      return new Promise(async (resolve, reject) => {
        try {
          let payload = {
            filter_item: [
              { key: 'course_code', value: lesson.course_code },
              { key: 'course_id', value: lesson.course_id },
              { key: 'start_date', value: lesson.date },
            ],
          }
          const centerId = await this.getSearchCenterId()
          if (centerId > -1) {
            payload['center_id'] = centerId
          }
          const { data } = await this.$Fetcher.GetLessons(payload)
          const excepts = data.filter(el => !selectedLessonIds.includes(el.id))
          resolve(excepts)
        } catch (err) {
          this.$common.error(err)
          resolve([])
        }
      })
    },
    _getLessonToPayload(targetRow, lesson_id) {
      let discount_value = null
      if (this.$validate.DataValid(targetRow.discount_type) && this.$validate.DataValid(targetRow.discount_value)) {
        if (targetRow.discount_type === 'percentage') {
          discount_value = 100 - targetRow.discount_value
        } else if (targetRow.discount_type === 'fix_amount') {
          discount_value = targetRow.discount_value
        }
      }

      return {
        id: lesson_id,
        discount_type: discount_value !== null ? targetRow.discount_type : '',
        discount_value: discount_value || 0,
      }
    },
    _getProductToPayload(targetRow) {
      let discount_value = null
      if (this.$validate.DataValid(targetRow.discount_type) && this.$validate.DataValid(targetRow.discount_value)) {
        if (targetRow.discount_type === 'percentage') {
          discount_value = 100 - targetRow.discount_value
        } else if (targetRow.discount_type === 'fix_amount') {
          discount_value = targetRow.discount_value
        }
      }

      return {
        id: targetRow.product_id,
        amount: targetRow.qty,
        discount_type: discount_value !== null ? targetRow.discount_type : '',
        discount_value: discount_value !== null ? discount_value : 0,
      }
    },
    _getPackageToPayload(targetRow) {
      let discount_value = null
      if (this.$validate.DataValid(targetRow.discount_type) && this.$validate.DataValid(targetRow.discount_value)) {
        if (targetRow.discount_type === 'percentage') {
          discount_value = 100 - targetRow.discount_value
        } else if (targetRow.discount_type === 'fix_amount') {
          discount_value = targetRow.discount_value
        }
      }

      return {
        id: targetRow.package_id,
        discount_type: discount_value !== null ? targetRow.discount_type : '',
        discount_value: discount_value !== null ? discount_value : 0,
      }
    },
    _getMonthPassToPayload(targetRow) {
      let discount_value = null
      if (this.$validate.DataValid(targetRow.discount_type) && this.$validate.DataValid(targetRow.discount_value)) {
        if (targetRow.discount_type === 'percentage') {
          discount_value = 100 - targetRow.discount_value
        } else if (targetRow.discount_type === 'fix_amount') {
          discount_value = targetRow.discount_value
        }
      }

      return {
        id: targetRow.month_pass_id,
        discount_type: discount_value !== null ? targetRow.discount_type : '',
        discount_value: discount_value !== null ? discount_value : 0,
      }
    },
    async _getNewOrderPayload(items, customItems = [], sign = '', skipItems = []) {
      const centerId = await this.getSearchCenterId()
      const getUser = this.gfGetCurrentUserData()

      let payload = {
        student_id: this.studentData.student_id,
        school_id: centerId,
        remark: this.formData.remark,
        pdf_remark: this.formData.pdf_remark,
        payment_method: '',
        lesson_id_list: [],
        product_id_list: [],
        except_lesson_id_list: [],
        subtotal: 0,
        status: this.formData.status,
        discount_type: '',
        discount_value: 0,
        custom_items: [],
        staff_id: getUser.id,
      }
      if (this.formData.is_redeem) {
        // 使用積分
        payload['is_redeem'] = true
        payload['subtotal'] = this.pointTotalAmount
        payload['status'] = 'paid'
      } else {
        payload['subtotal'] = parseFloat(this.formData.subtotal)
        payload['payment_method'] = this.formData.payment_method
        if (this.formData.payment_images.length) {
          if (!this.gDisableMultiplePaymentImg) {
            payload['payment_image'] = ''
            payload['payment_image_list'] = this.formData.payment_images.map(el => el.file)
          } else {
            payload['payment_image'] = this.formData.payment_images[0].file
          }
        }
      }

      const courseItems = items.filter(el => el.order_type === 'course')
      const packageItems = items.filter(el => el.order_type === 'package')
      const productItems = items.filter(el => el.order_type === 'product')
      const monthPassItems = items.filter(el => el.order_type === 'month_pass')

      // -- handle product_id_list
      payload['product_id_list'] = productItems.map(targetRow => this._getProductToPayload(targetRow))

      // -- handle lesson_id_list & except_lesson_id_list
      if (courseItems.length > 0) {
        let trialLessonIds = []
        // 先handle 報讀課程
        courseItems.forEach(targetRow => {
          if (!targetRow.is_single_lesson) {
            targetRow.lesson_data_list.forEach(lesson => {
              if (targetRow.selected_lesson_id_list.includes(lesson.id)) {
                const get_item = this._getLessonToPayload(targetRow, lesson.id)
                payload['lesson_id_list'].push(get_item)
              } else {
                payload['except_lesson_id_list'].push(lesson.id)
              }
            })
          }

          if (this.$validate.DataValid(targetRow.trial_lesson_ids)) {
            targetRow.trial_lesson_ids.forEach(id => {
              if (targetRow.selected_lesson_id_list.includes(id)) {
                trialLessonIds.push(id)
              }
            })
          }
        })

        // handle 報讀單一課堂
        for (let x = 0; x < courseItems.length; x++) {
          const targetRow = courseItems[x]
          if (targetRow.is_single_lesson) {
            if (targetRow.lesson_type === 'regular') {
              let get_excepts = await this._getExceptLessons(
                targetRow.selected_lesson_id_list,
                targetRow.lesson_data_list[0],
              )

              const foundsInRegular = courseItems.filter(
                el =>
                  !el.is_single_lesson &&
                  el.lesson_data_list[0].course_id === targetRow.lesson_data_list[0].course_id &&
                  el.lesson_data_list[0].course_code === targetRow.lesson_data_list[0].course_code,
              )

              // except_lesson_id_list 唔包括 報讀課程(auto grab) 之後嘅堂
              if (foundsInRegular.length > 0) {
                const firstDates = foundsInRegular.map(el => el.lesson_data_list[0].date)
                firstDates.sort((a, b) => this.$formatter.sortDate(a, b))

                const first_regular_date = this.$formatter.convertDate(firstDates[0].date)
                for (let i = get_excepts.length - 1; i >= 0; i--) {
                  const except_date = this.$formatter.convertDate(get_excepts[i].date)

                  const remove = this.$validate.isDateGreater(except_date, first_regular_date)
                  if (remove) {
                    get_excepts.splice(i, 1)
                  }
                }
              }

              const get_except_ids = get_excepts.map(el => el.id)
              payload['except_lesson_id_list'] = [...payload['except_lesson_id_list'], ...get_except_ids]
            }

            // must after except_lesson_id_list handling
            targetRow.lesson_data_list.forEach(lesson => {
              if (targetRow.selected_lesson_id_list.includes(lesson.id)) {
                const get_item = this._getLessonToPayload(targetRow, lesson.id)
                payload['lesson_id_list'].push(get_item)
              }
            })
          }
        }

        const lesson_ids = payload['lesson_id_list'].map(el => el.id)
        payload['except_lesson_id_list'] = payload['except_lesson_id_list'].filter(id => !lesson_ids.includes(id))
        const unique_except = []
        payload['except_lesson_id_list'].forEach(id => {
          if (!unique_except.includes(id)) {
            unique_except.push(id)
          }
        })
        payload['except_lesson_id_list'] = unique_except

        // 如果lesson冇變過，攞返order嘅 except_lesson_id_list
        if (this.$validate.DataValid(this.orderId)) {
          let isLessonRenew = false
          if (payload['lesson_id_list'].length === this.orderData.lesson_list.length) {
            for (let i = 0; i < payload['lesson_id_list'].length; i++) {
              const found = this.orderData.lesson_list.find(el => el.id === payload['lesson_id_list'][i].id)
              if (!found) {
                isLessonRenew = true
                break
              }
            }
          } else {
            isLessonRenew = true
          }

          if (!isLessonRenew) {
            payload['except_lesson_id_list'] = this.orderData.except_lesson_id_list
          }
        }

        // -- trial_lesson
        if (trialLessonIds.length > 0) {
          payload['trial_lesson'] = []
          payload['lesson_id_list'].forEach(el => {
            if (trialLessonIds.includes(el.id)) {
              payload['trial_lesson'].push(el.id)
            }
          })
        }
      } else if (packageItems.length > 0) {
        payload['unpaid_lesson_id_list'] = []

        if (this.enableMultiPackage) {
          payload['selected_only'] = true
          payload['package_id_list'] = packageItems.map(targetRow => this._getPackageToPayload(targetRow))
        } else {
          payload['package_id'] = packageItems[0].package_id
        }

        let totalLessonCount = 0
        let totalSelectedLesson = 0
        const unpaidLessons = await this._getUnpaidLesson()
        packageItems.forEach(targetRow => {
          if (targetRow.select_rule === 'manually') {
            payload['selected_only'] = true
          }
          totalLessonCount += targetRow.lesson_count
          targetRow.lesson_data_list.forEach(lesson => {
            if (targetRow.selected_lesson_id_list.includes(lesson.id)) {
              totalSelectedLesson += 1

              let isUnpaid = false
              const foundUnpaid = unpaidLessons.find(el => el.id === lesson.id)
              if (
                foundUnpaid ||
                (this.$validate.DataValid(lesson.student_ids) && lesson.student_ids.includes(this.id))
              ) {
                isUnpaid = true
              }

              // 如果係renew，唔會將order嘅lesson擺去 unpaid_lesson_id_list 到
              if (isUnpaid && this.$validate.DataValid(this.orderId)) {
                const foundInOrder = this.orderData.lesson_list.find(el => el.id === lesson.id)
                if (foundInOrder) {
                  isUnpaid = false
                }
              }

              if (isUnpaid) {
                payload['unpaid_lesson_id_list'].push(lesson.id)
              } else {
                payload['lesson_id_list'].push({
                  id: lesson.id,
                  discount_type: '',
                  discount_value: 0,
                })
              }
            }
          })
        })
        payload['use_remain'] = totalSelectedLesson > totalLessonCount ? true : false
        if (this.$validate.DataValid(this.orderId)) {
          payload['selected_only'] = true
        }
      } else if (monthPassItems.length > 0) {
        payload['monthly_id_list'] = []
        payload['selected_months'] = []
        let months = 0
        for (let i = 0; i < monthPassItems.length; i++) {
          for (let j = 0; j < monthPassItems[i].qty; j++) {
            const getItem = this._getMonthPassToPayload(monthPassItems[i])
            payload['monthly_id_list'].push(getItem)
          }

          if (monthPassItems[i].type === 'months') {
            months += monthPassItems[i].qty
          }
        }
        if (months > 0 && monthPassItems[0].select_month) {
          let startDate = this.$formatter.convertDate(`${monthPassItems[0].select_month}-01`)
          for (let i = 0; i < months; i++) {
            payload['selected_months'].push(
              `${startDate.getFullYear()}-${this.$formatter.pad(startDate.getMonth() + 1)}`,
            )
            startDate.setMonth(startDate.getMonth() + 1)
          }
        }

        monthPassItems.forEach(targetRow => {
          targetRow.lesson_data_list.forEach(lesson => {
            if (targetRow.selected_lesson_id_list.includes(lesson.id)) {
              payload['lesson_id_list'].push({
                id: lesson.id,
                discount_type: '',
                discount_value: 0,
              })
            }
          })
        })
      }

      // -- handle 新增自訂項目 custom_items
      if (customItems.length > 0) {
        payload['custom_items'] = customItems.map(targetRow => {
          return {
            name: targetRow.item_name,
            description: targetRow.item_description,
            price: parseFloat(targetRow.unit_price),
            amount: targetRow.qty,
          }
        })
      }

      // -- 最外面discount
      if (
        !this.formData.is_redeem &&
        this.$validate.DataValid(this.formData.discount_type) &&
        this.$validate.DataValid(this.formData.discount_value)
      ) {
        payload['discount_type'] = this.formData.discount_type

        let discount_value = 0
        if (this.formData.discount_type === 'percentage') {
          discount_value = 100 - parseFloat(this.formData.discount_value)
        } else if (this.formData.discount_type === 'fix_amount') {
          discount_value = parseFloat(this.formData.discount_value)
        }
        payload['discount_value'] = discount_value

        if (this.appliedCoupon) {
          payload['coupon_code'] = this.appliedCoupon.code
        }
      }

      if (payload['status'] === 'paid') {
        // -- pay date
        payload['pay_date'] = await this.$XHR.serverTime()

        // -- 審核付款經手人
        payload['approver_id'] = getUser.id
      }

      if (this.isAppMode(['T21'])) {
        payload['sign'] = ''
        if (payload['status'] !== 'pending' && payload['payment_method'] === 'cash' && sign !== false) {
          payload['sign'] = sign
        }
      }

      // -- skip_lessons
      if (skipItems.length) {
        payload['skip_lessons'] = skipItems.reduce((list, item) => list.concat(item.selected_lesson_id_list || []), [])
      }

      // -- 自訂訂單編號
      if (this.isAppMode(['DEV', 'T21'])) {
        payload['custom_invoice_number'] = this.formData.custom_invoice_number
      }

      return payload
    },
    async _getPreviewOrderPayload(newItems = [], customItems = [], sign = '', skipItems = []) {
      const getUser = this.gfGetCurrentUserData()
      let payload = {
        student_id: this.studentData.student_id,
        lesson_id_list: [],
        product_id_list: [],
        remark: this.formData.remark,
        pdf_remark: this.formData.pdf_remark,
        payment_method: this.formData.payment_method,
        status: this.formData.status,
        payment_image: '',
        subtotal: parseFloat(this.formData.subtotal),
        staff_id: getUser.id,
      }

      // -- payment record image
      if (this.formData.payment_images.length) {
        if (!this.gDisableMultiplePaymentImg) {
          payload['payment_image_list'] = this.formData.payment_images.map(el => el.file)
        } else {
          payload['payment_image'] = this.formData.payment_images[0].file
        }
      } else if (!this.gDisableMultiplePaymentImg) {
        payload['payment_image_list'] = []
      }

      // -- handle product_id_list
      const productItems = newItems.filter(el => el.order_type === 'product')
      payload['product_id_list'] = productItems.map(targetRow => this._getProductToPayload(targetRow))

      // -- handle 新增自訂項目 custom_items
      if (customItems.length > 0) {
        payload['custom_items'] = customItems.map(targetRow => {
          return {
            name: targetRow.item_name,
            description: targetRow.item_description,
            price: parseFloat(targetRow.unit_price),
            amount: targetRow.qty,
          }
        })
      }

      // -- discount
      if (
        this.$validate.DataValid(this.formData.discount_type) &&
        this.$validate.DataValid(this.formData.discount_value)
      ) {
        payload['discount_type'] = this.formData.discount_type

        let discount_value = 0
        if (this.formData.discount_type === 'percentage') {
          discount_value = 100 - parseFloat(this.formData.discount_value)
        } else if (this.formData.discount_type === 'fix_amount') {
          discount_value = parseFloat(this.formData.discount_value)
        }
        payload['discount_value'] = discount_value

        if (this.appliedCoupon) {
          payload['coupon_code'] = this.appliedCoupon.code
        }
      }

      // -- sign
      if (this.isAppMode(['T21'])) {
        payload['sign'] = ''
        if (payload['status'] !== 'pending' && payload['payment_method'] === 'cash' && sign !== false) {
          payload['sign'] = sign
        }
      }

      // -- skip_lessons
      if (skipItems.length) {
        payload['skip_lessons'] = skipItems.reduce((list, item) => list.concat(item.selected_lesson_id_list || []), [])
      }

      // -- 審核付款經手人
      if (payload['status'] === 'paid') {
        payload['approver_id'] = getUser.id
      }

      return payload
    },

    // -- for order_id = -1
    makeNewOrder(items, customItems = [], sign = '', skipItems = []) {
      return new Promise(async (resolve, reject) => {
        try {
          const payload = await this._getNewOrderPayload(items, customItems, sign, skipItems)
          await this.$Fetcher.NewOrder(payload)
          resolve(true)
        } catch (err) {
          this.$common.error(err)
          reject(`[NEW] ${this.$t(err)}`)
        }
      })
    },
    // -- for order_id > -1 & status = 'pending'
    async renewOrder(orderId, items, customItems = [], skipItems = []) {
      try {
        let uploadedSign = ''
        if (this.isAppMode(['T21'])) {
          if (
            !this.formData.is_redeem &&
            this.formData.status !== 'pending' &&
            this.formData.payment_method === 'cash'
          ) {
            uploadedSign = await this.uploadSign(this.formData.sign)
            if (uploadedSign !== false) {
              this.formData.sign = uploadedSign
            }
          }
        }

        const payload = await this._getNewOrderPayload(items, customItems, uploadedSign, skipItems)
        let updatePayload = { ...payload }
        const newOrderDate = `${this.formData.order_create_date}T${this.formData.order_create_time}:00Z`
        if (newOrderDate.substring(0, 16) !== this.orderData.order_date.substring(0, 16)) {
          updatePayload['order_date'] = newOrderDate
        }
        if (updatePayload['status'] === 'paid' && this.formData.pay_date && this.formData.pay_time) {
          const newPayDate = `${this.formData.pay_date}T${this.formData.pay_time}:00Z`
          if (newPayDate.substring(0, 16) !== this.orderData.pay_date.substring(0, 16)) {
            updatePayload['pay_date'] = newPayDate
          }
        }

        await this.$Fetcher.RenewOrder(orderId, updatePayload)
        const vm = this
        setTimeout(() => {
          vm.$store.dispatch('setLoading', false)
          if (vm.isAppMode(['T21']) && uploadedSign === false) {
            vm.showAlert({
              title: 'message.updateSuccess',
              message: 'message.paymentSuccessSignFail',
              isError: false,
            })
          } else {
            vm.$store.dispatch('toggleSnack', {
              message: 'message.updateSuccess',
              type: 'success',
            })
          }
          vm.handleCancelUpdateOrder()
        }, 500)
      } catch (err) {
        this.$common.error(err)
        this.$store.dispatch('setLoading', false)
        this.showAlert({
          title: 'message.updateFail',
          message: err,
          isError: true,
        })
      }
    },
    // -- for order_id > -1 & status != 'pending'
    async updateOrder(orderId) {
      const getUser = this.gfGetCurrentUserData()

      let payload = {
        remark: this.formData.remark,
        pdf_remark: this.formData.pdf_remark,
        payment_method: this.formData.payment_method,
        status: this.formData.status,
        payment_image: '',
        staff_id: getUser.id,
      }

      // -- 付款記錄Image
      if (this.formData.payment_images.length) {
        if (!this.gDisableMultiplePaymentImg) {
          payload['payment_image_list'] = this.formData.payment_images.map(el => el.file)
        } else {
          payload['payment_image'] = this.formData.payment_images[0].file
        }
      } else if (!this.gDisableMultiplePaymentImg) {
        payload['payment_image_list'] = []
      }
      if (this.orderData.is_redeem) {
        delete payload['payment_method']
        delete payload['payment_image']
      }

      // -- 建立日期
      const newOrderDate = `${this.formData.order_create_date}T${this.formData.order_create_time}:00Z`
      if (newOrderDate.substring(0, 16) !== this.orderData.order_date.substring(0, 16)) {
        payload['order_date'] = newOrderDate
      }
      // -- 付款日期
      if (payload['status'] === 'paid' && this.formData.pay_date && this.formData.pay_time) {
        const newPayDate = `${this.formData.pay_date}T${this.formData.pay_time}:00Z`
        if (newPayDate.substring(0, 16) !== this.orderData.pay_date.substring(0, 16)) {
          payload['pay_date'] = newPayDate
        }
      }

      // -- 審批經手人
      if (payload['status'] === 'paid' && this.orderData.status !== 'paid') {
        payload['approver_id'] = getUser.id
      }

      // -- 自訂訂單編號
      if (this.isAppMode(['DEV', 'T21'])) {
        payload['custom_invoice_number'] = this.formData.custom_invoice_number
      }

      try {
        // -- 電子簽名
        let uploadedSign = ''
        if (this.isAppMode(['T21'])) {
          if (
            !this.formData.is_redeem &&
            this.formData.status !== 'pending' &&
            this.formData.payment_method === 'cash'
          ) {
            uploadedSign = await this.uploadSign(this.formData.sign)
            if (uploadedSign !== false) {
              this.formData.sign = uploadedSign
            }
          }

          payload['sign'] = ''
          if (uploadedSign !== false) {
            payload['sign'] = uploadedSign
          }
        }

        await this.$Fetcher.UpdateOrder(orderId, payload)
        const vm = this
        setTimeout(() => {
          vm.$store.dispatch('setLoading', false)
          if (vm.isAppMode(['T21']) && uploadedSign === false) {
            vm.showAlert({
              title: 'message.updateSuccess',
              message: 'message.paymentSuccessSignFail',
              isError: false,
            })
          } else {
            vm.$store.dispatch('toggleSnack', {
              message: 'message.updateSuccess',
              type: 'success',
            })
          }
          vm.handleCancelUpdateOrder()
        }, 500)
      } catch (err) {
        this.$common.error(err)
        this.$store.dispatch('setLoading', false)
        this.showAlert({
          title: 'message.updateFail',
          message: err,
          isError: true,
        })
      }
    },
    // -- for order_id = -2
    genNextMonthOrder(
      items,
      customItems = [],
      newItems = [],
      sign = '',
      skipItems = [],
      confirmDropUnselect = false,
      prevUnpaidItems = [],
    ) {
      return new Promise(async (resolve, reject) => {
        const getPayload = await this._getPreviewOrderPayload(newItems, customItems, sign, skipItems)
        let payload = {
          ...getPayload,
          except_lesson_id_list: [],
          exit_attendance: confirmDropUnselect || false,
        }
        if (this.gEnableRegularPeriod && !this.gDisableSettingByCenter) {
          const centerId = await this.getSearchCenterId()
          payload['school_id'] = centerId
        }

        // -- handle lesson_id_list & except_lesson_id_list
        const { lesson_id_list, except_lesson_id_list } = this._getNextMonthOrderLessons(items)
        payload['lesson_id_list'] = lesson_id_list
        payload['except_lesson_id_list'] = except_lesson_id_list
        // new lessons
        if (this.enableCombineNextAndNew) {
          const newCourseItems = newItems.filter(el => el.order_type === 'course')
          newCourseItems.forEach(targetRow => {
            targetRow.lesson_data_list.forEach(lesson => {
              if (targetRow.selected_lesson_id_list.includes(lesson.id)) {
                const get_item = this._getLessonToPayload(targetRow, lesson.id)
                payload['lesson_id_list'].push(get_item)
              }
            })
          })
        }
        // unpaid lessons
        if (this.enableCombineNextAndUnpaid && this.$validate.DataValid(prevUnpaidItems, true)) {
          this.prevPreviewOrder.lesson_list.forEach(item => {
            let found = null
            for (let i = 0; i < prevUnpaidItems.length; i++) {
              if (prevUnpaidItems[i].selected_lesson_id_list.includes(item.id)) {
                found = prevUnpaidItems[i]
                break
              }
            }

            if (found !== null) {
              const get_item = this._getLessonToPayload(found, item.id)
              payload['lesson_id_list'].push(get_item)
            }
          })
        }

        try {
          await this.$Fetcher.GenNextMonthOrder(payload, this.nextPreviewOrderAdd)
          resolve(true)
        } catch (err) {
          this.$common.error(err)
          reject(`[INVOICE ERROR] ${this.$t(err)}`)
        }
      })
    },
    _getNextMonthOrderLessons(items) {
      const lesson_id_list = []
      const except_lesson_id_list = []
      this.nextPreviewOrder.lesson_list.forEach(item => {
        const targetItem = this.nextPreviewOrder.lesson_datas.find(el => el.id === item.id)
        if (targetItem && targetItem.paid_student_ids.includes(this.studentData.student_id)) {
          // do nothing
        } else {
          let found = null
          for (let i = 0; i < items.length; i++) {
            if (items[i].selected_lesson_id_list.includes(item.id)) {
              found = items[i]
              break
            }
          }

          if (found !== null) {
            const get_item = this._getLessonToPayload(found, item.id)
            lesson_id_list.push(get_item)
          } else {
            except_lesson_id_list.push(item.id)
          }
        }
      })
      return {
        lesson_id_list,
        except_lesson_id_list,
      }
    },
    // -- for order_id = -3
    genPrevUnpaidOrder(items, customItems = [], newItems = [], sign = '', skipItems = []) {
      return new Promise(async (resolve, reject) => {
        const getPayload = await this._getPreviewOrderPayload(newItems, customItems, sign, skipItems)
        let payload = {
          ...getPayload,
        }
        // -- handle lesson_id_list
        this.prevPreviewOrder.lesson_list.forEach(item => {
          let found = null
          for (let i = 0; i < items.length; i++) {
            if (items[i].selected_lesson_id_list.includes(item.id)) {
              found = items[i]
              break
            }
          }

          if (found !== null) {
            const get_item = this._getLessonToPayload(found, item.id)
            payload['lesson_id_list'].push(get_item)
          }
        })
        // new lessons
        if (this.enableCombineUnpaidAndNew) {
          const newCourseItems = newItems.filter(el => el.order_type === 'course')
          newCourseItems.forEach(targetRow => {
            targetRow.lesson_data_list.forEach(lesson => {
              if (targetRow.selected_lesson_id_list.includes(lesson.id)) {
                const get_item = this._getLessonToPayload(targetRow, lesson.id)
                payload['lesson_id_list'].push(get_item)
              }
            })
          })
        }

        try {
          await this.$Fetcher.GenPrevUnpaidOrder(payload)
          resolve(true)
        } catch (err) {
          this.$common.error(err)
          reject(`[UNPAID INVOICE ERROR] ${this.$t(err)}`)
        }
      })
    },

    async getSetting() {
      let data = null
      if (this.gEnableRegularPeriod && !this.gDisableSettingByCenter) {
        const selectedSchool = await this.getSearchCenterId()
        if (selectedSchool > -1) {
          try {
            const data = await this.$Fetcher.GetSchoolById(selectedSchool)
            if (this.$validate.DataValid(data.month_period) && data.month_period > 0) {
              this.previewMonths = data.month_period
            }
          } catch (err) {
            this.$common.error(err)
          }
        }
      }

      if (
        this.gEnablePointSystem ||
        this.gEnableCustomGrade ||
        (this.gEnableRegularPeriod && this.gDisableSettingByCenter)
      ) {
        try {
          data = await this.$Fetcher.GetSetting()
          if (this.gEnablePointSystem && data.points_enable) this.enablePoints = true
          if (
            this.gEnableRegularPeriod &&
            this.gDisableSettingByCenter &&
            this.$validate.DataValid(data.month_period) &&
            data.month_period > 0
          ) {
            this.previewMonths = data.month_period
          }
        } catch (err) {
          this.$common.error(err)
        }
      }
      if (this.previewMonths < 1) this.previewMonths = 1
      this.disableCourseGrade = this.gfCheckDisabledCourseGrade(data)
      if (this.gEnablePointSystem) {
        this.pointsCanUse = await this.$Fetcher.GetUserPoints(this.id)
      }
    },
    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: PayTuitionPayment')
      this.permissionValid = true
      this.userType = this.gfGetUserType()

      this.resetPage()
      this.studentData.student_id = -1
      this.studentData.student_name = ''
      this.studentData.gender = ''
      this.studentData.phone = ''
      this.studentData.schools = []
      this.studentData.grade = ''
      this.studentData.remark = ''
      this.studentData.siblings = []
      this.courseNameOptions = []
      this.remainPackageLessonCount = 0
      this.pendingPackageLessonCount = 0
      this.availablePackageLessonCount = 0
      this.remainPackageLessonCountInit = 0
      this.createLessonCount = 0
      this.createLessonRegularId = null
      this.createLessonCourseOptions = []
      this.allUnpaidLessonDataStatic = []
      this.allUnpaidLessonData = []
      this.unpaidLessonTableData = []
      this.unpaidLessonSelectedRow = []
      this.otherMonthPassLessonDates = []
      this.existMonthPass.tableData = []
      this.existMonthPass.allData = []
      this.existMonthPass.total = 0
      this.assignLessonTableData = []
      this.assignLessonSelectedRow = []
      this.enablePoints = false
      this.pointsCanUse = 0
      this.disableCourseGrade = false
      if (this.$validate.DataValid(this.id)) {
        const check = await this.gfCheckSchoolSelected(true)
        if (!check) {
          this.$store.dispatch('toggleLoadingPage', false)
          return
        }

        await this.getSetting()
      }
      this.getPayTuitionData()
    },
  },
  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  created() {
    this.qtyOptions = []
    for (let i = 1; i <= 10; i++) {
      this.qtyOptions.push({
        value: i,
        text: i,
      })
    }
    this.createTimeOptions = []
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 60; j++) {
        this.createTimeOptions.push(`${this.$formatter.pad(i)}:${this.$formatter.pad(j)}`)
      }
    }
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else {
      this.$XHR.abort()
      next()
    }
  },
}
</script>

<style lang="scss" scoped>
.order-card-title {
  background-color: #e2e2e2;
}

.details-row {
  justify-content: space-between;

  & * {
    color: var(--v-colorBlack-base);
    font-size: 0.875rem;
    font-weight: 500;
  }
}

.custom-item-container {
  & .v-btn {
    border: 2px dashed #cbcbcb !important;
    border-radius: 13px !important;
  }
}

.remark-block {
  width: 100%;
  background-color: #ffe9b5;
  border-radius: 5px;
  color: #000000;
  font-size: 0.75rem;
  max-width: 560px;
}

::v-deep.total-input {
  width: 70%;

  & input {
    font-size: 2.125rem !important;
    text-align: right;
    font-weight: 500;
    color: var(--v-colorBlack-base);
  }
}
</style>
